var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref75c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref75c"] = parcelRequire;
}
function $2c24f9dd87b676fe$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $2c24f9dd87b676fe$var$log(msg) {
    return `[Vaadin.Router] ${msg}`;
}
function $2c24f9dd87b676fe$var$logValue(value) {
    if (typeof value !== "object") return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === "Object" || stringType === "Array") return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
const $2c24f9dd87b676fe$var$MODULE = "module";
const $2c24f9dd87b676fe$var$NOMODULE = "nomodule";
const $2c24f9dd87b676fe$var$bundleKeys = [
    $2c24f9dd87b676fe$var$MODULE,
    $2c24f9dd87b676fe$var$NOMODULE
];
function $2c24f9dd87b676fe$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($2c24f9dd87b676fe$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $2c24f9dd87b676fe$var$ensureRoute(route) {
    if (!route || !$2c24f9dd87b676fe$var$isString(route.path)) throw new Error($2c24f9dd87b676fe$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        "component",
        "redirect",
        "bundle"
    ];
    if (!$2c24f9dd87b676fe$var$isFunction(route.action) && !Array.isArray(route.children) && !$2c24f9dd87b676fe$var$isFunction(route.children) && !$2c24f9dd87b676fe$var$isObject(bundle) && !stringKeys.some((key)=>$2c24f9dd87b676fe$var$isString(route[key]))) throw new Error($2c24f9dd87b676fe$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($2c24f9dd87b676fe$var$isString(bundle)) $2c24f9dd87b676fe$var$ensureBundle(bundle);
        else if (!$2c24f9dd87b676fe$var$bundleKeys.some((key)=>key in bundle)) throw new Error($2c24f9dd87b676fe$var$log('Expected route bundle to include either "' + $2c24f9dd87b676fe$var$NOMODULE + '" or "' + $2c24f9dd87b676fe$var$MODULE + '" keys, or both'));
        else $2c24f9dd87b676fe$var$bundleKeys.forEach((key)=>key in bundle && $2c24f9dd87b676fe$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        "bundle",
        "component"
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($2c24f9dd87b676fe$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $2c24f9dd87b676fe$var$ensureRoutes(routes) {
    $2c24f9dd87b676fe$var$toArray(routes).forEach((route)=>$2c24f9dd87b676fe$var$ensureRoute(route));
}
function $2c24f9dd87b676fe$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", src);
        if (key === $2c24f9dd87b676fe$var$MODULE) script.setAttribute("type", $2c24f9dd87b676fe$var$MODULE);
        else if (key === $2c24f9dd87b676fe$var$NOMODULE) script.setAttribute($2c24f9dd87b676fe$var$NOMODULE, "");
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script.onreadystatechange = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $2c24f9dd87b676fe$var$loadBundle(bundle) {
    if ($2c24f9dd87b676fe$var$isString(bundle)) return $2c24f9dd87b676fe$var$loadScript(bundle);
    else return Promise.race($2c24f9dd87b676fe$var$bundleKeys.filter((key)=>key in bundle).map((key)=>$2c24f9dd87b676fe$var$loadScript(bundle[key], key)));
}
function $2c24f9dd87b676fe$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`vaadin-router-${type}`, {
        cancelable: type === "go",
        detail: detail
    }));
}
function $2c24f9dd87b676fe$var$isObject(o) {
    // guard against null passing the typeof check
    return typeof o === "object" && !!o;
}
function $2c24f9dd87b676fe$var$isFunction(f) {
    return typeof f === "function";
}
function $2c24f9dd87b676fe$var$isString(s) {
    return typeof s === "string";
}
function $2c24f9dd87b676fe$var$getNotFoundError(context) {
    const error = new Error($2c24f9dd87b676fe$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
const $2c24f9dd87b676fe$var$notFoundResult = new class NotFoundResult {
}();
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ function $2c24f9dd87b676fe$var$getAnchorOrigin(anchor) {
    // IE11: on HTTP and HTTPS the default port is not included into
    // window.location.origin, so won't include it here either.
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === "http:" && port === "80";
    const defaultHttps = protocol === "https:" && port === "443";
    const host = defaultHttp || defaultHttps ? anchor.hostname // does not include the port number (e.g. www.example.org)
     : anchor.host; // does include the port number (e.g. www.example.org:80)
    return `${protocol}//${host}`;
}
// The list of checks is not complete:
//  - SVG support is missing
//  - the 'rel' attribute is not considered
function $2c24f9dd87b676fe$var$vaadinRouterGlobalClickHandler(event) {
    // ignore the click if the default action is prevented
    if (event.defaultPrevented) return;
    // ignore the click if not with the primary mouse button
    if (event.button !== 0) return;
    // ignore the click if a modifier key is pressed
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    // find the <a> element that the click is at (or within)
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    // FIXME(web-padawan): `Symbol.iterator` used by webcomponentsjs is broken for arrays
    // example to check: `for...of` loop here throws the "Not yet implemented" error
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === "a") {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName.toLowerCase() !== "a")anchor = anchor.parentNode;
    // ignore the click if not at an <a> element
    if (!anchor || anchor.nodeName.toLowerCase() !== "a") return;
    // ignore the click if the <a> element has a non-default target
    if (anchor.target && anchor.target.toLowerCase() !== "_self") return;
    // ignore the click if the <a> element has the 'download' attribute
    if (anchor.hasAttribute("download")) return;
    // ignore the click if the <a> element has the 'router-ignore' attribute
    if (anchor.hasAttribute("router-ignore")) return;
    // ignore the click if the target URL is a fragment on the current page
    if (anchor.pathname === window.location.pathname && anchor.hash !== "") return;
    // ignore the click if the target is external to the app
    // In IE11 HTMLAnchorElement does not have the `origin` property
    const origin = anchor.origin || $2c24f9dd87b676fe$var$getAnchorOrigin(anchor);
    if (origin !== window.location.origin) return;
    // if none of the above, convert the click into a navigation event
    const { pathname: pathname , search: search , hash: hash  } = anchor;
    if ($2c24f9dd87b676fe$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    })) {
        event.preventDefault();
        // for a click event, the scroll is reset to the top position.
        if (event && event.type === "click") window.scrollTo(0, 0);
    }
}
/**
 * A navigation trigger for Vaadin Router that translated clicks on `<a>` links
 * into Vaadin Router navigation events.
 *
 * Only regular clicks on in-app links are translated (primary mouse button, no
 * modifier keys, the target href is within the app's URL space).
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $2c24f9dd87b676fe$var$CLICK = {
    activate () {
        window.document.addEventListener("click", $2c24f9dd87b676fe$var$vaadinRouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener("click", $2c24f9dd87b676fe$var$vaadinRouterGlobalClickHandler);
    }
};
// PopStateEvent constructor shim
const $2c24f9dd87b676fe$var$isIE = /Trident/.test(navigator.userAgent);
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ if ($2c24f9dd87b676fe$var$isIE && !$2c24f9dd87b676fe$var$isFunction(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        var e = document.createEvent("Event");
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $2c24f9dd87b676fe$var$vaadinRouterGlobalPopstateHandler(event) {
    if (event.state === "vaadin-router-ignore") return;
    const { pathname: pathname , search: search , hash: hash  } = window.location;
    $2c24f9dd87b676fe$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
/**
 * A navigation trigger for Vaadin Router that translates popstate events into
 * Vaadin Router navigation events.
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $2c24f9dd87b676fe$var$POPSTATE = {
    activate () {
        window.addEventListener("popstate", $2c24f9dd87b676fe$var$vaadinRouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener("popstate", $2c24f9dd87b676fe$var$vaadinRouterGlobalPopstateHandler);
    }
};
/**
 * Expose `pathToRegexp`.
 */ var $2c24f9dd87b676fe$var$pathToRegexp_1 = $2c24f9dd87b676fe$var$pathToRegexp$1;
var $2c24f9dd87b676fe$var$parse_1 = $2c24f9dd87b676fe$var$parse;
var $2c24f9dd87b676fe$var$compile_1 = $2c24f9dd87b676fe$var$compile;
var $2c24f9dd87b676fe$var$tokensToFunction_1 = $2c24f9dd87b676fe$var$tokensToFunction;
var $2c24f9dd87b676fe$var$tokensToRegExp_1 = $2c24f9dd87b676fe$var$tokensToRegExp;
/**
 * Default configs.
 */ var $2c24f9dd87b676fe$var$DEFAULT_DELIMITER = "/";
var $2c24f9dd87b676fe$var$DEFAULT_DELIMITERS = "./";
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $2c24f9dd87b676fe$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $2c24f9dd87b676fe$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || $2c24f9dd87b676fe$var$DEFAULT_DELIMITER;
    var delimiters = options && options.delimiters || $2c24f9dd87b676fe$var$DEFAULT_DELIMITERS;
    var pathEscaped = false;
    var res;
    while((res = $2c24f9dd87b676fe$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = "";
        var next = str[index];
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
            pathEscaped = false;
        }
        var partial = prev !== "" && next !== undefined && next !== prev;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prev || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $2c24f9dd87b676fe$var$escapeGroup(pattern) : "[^" + $2c24f9dd87b676fe$var$escapeString(delimiter) + "]+?"
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $2c24f9dd87b676fe$var$compile(str, options) {
    return $2c24f9dd87b676fe$var$tokensToFunction($2c24f9dd87b676fe$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $2c24f9dd87b676fe$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(data, options) {
        var path = "";
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                // Prepend partial segment prefixes.
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? "an array" : "a string"));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $2c24f9dd87b676fe$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $2c24f9dd87b676fe$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $2c24f9dd87b676fe$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $2c24f9dd87b676fe$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $2c24f9dd87b676fe$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($2c24f9dd87b676fe$var$pathToRegexp$1(path[i], keys, options).source);
    return new RegExp("(?:" + parts.join("|") + ")", $2c24f9dd87b676fe$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $2c24f9dd87b676fe$var$stringToRegexp(path, keys, options) {
    return $2c24f9dd87b676fe$var$tokensToRegExp($2c24f9dd87b676fe$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $2c24f9dd87b676fe$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = $2c24f9dd87b676fe$var$escapeString(options.delimiter || $2c24f9dd87b676fe$var$DEFAULT_DELIMITER);
    var delimiters = options.delimiters || $2c24f9dd87b676fe$var$DEFAULT_DELIMITERS;
    var endsWith = [].concat(options.endsWith || []).map($2c24f9dd87b676fe$var$escapeString).concat("$").join("|");
    var route = start ? "^" : "";
    var isEndDelimited = tokens.length === 0;
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") {
            route += $2c24f9dd87b676fe$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            var capture = token.repeat ? "(?:" + token.pattern + ")(?:" + $2c24f9dd87b676fe$var$escapeString(token.delimiter) + "(?:" + token.pattern + "))*" : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $2c24f9dd87b676fe$var$escapeString(token.prefix) + "(" + capture + ")?";
                else route += "(?:" + $2c24f9dd87b676fe$var$escapeString(token.prefix) + "(" + capture + "))?";
            } else route += $2c24f9dd87b676fe$var$escapeString(token.prefix) + "(" + capture + ")";
        }
    }
    if (end) {
        if (!strict) route += "(?:" + delimiter + ")?";
        route += endsWith === "$" ? "$" : "(?=" + endsWith + ")";
    } else {
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, $2c24f9dd87b676fe$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $2c24f9dd87b676fe$var$pathToRegexp$1(path, keys, options) {
    if (path instanceof RegExp) return $2c24f9dd87b676fe$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $2c24f9dd87b676fe$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $2c24f9dd87b676fe$var$stringToRegexp(/** @type {string} */ path, keys, options);
}
$2c24f9dd87b676fe$var$pathToRegexp_1.parse = $2c24f9dd87b676fe$var$parse_1;
$2c24f9dd87b676fe$var$pathToRegexp_1.compile = $2c24f9dd87b676fe$var$compile_1;
$2c24f9dd87b676fe$var$pathToRegexp_1.tokensToFunction = $2c24f9dd87b676fe$var$tokensToFunction_1;
$2c24f9dd87b676fe$var$pathToRegexp_1.tokensToRegExp = $2c24f9dd87b676fe$var$tokensToRegExp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { hasOwnProperty: $2c24f9dd87b676fe$var$hasOwnProperty  } = Object.prototype;
const $2c24f9dd87b676fe$var$cache$1 = new Map();
// see https://github.com/pillarjs/path-to-regexp/issues/148
$2c24f9dd87b676fe$var$cache$1.set("|false", {
    keys: [],
    pattern: /(?:)/
});
function $2c24f9dd87b676fe$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $2c24f9dd87b676fe$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $2c24f9dd87b676fe$var$cache$1.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: $2c24f9dd87b676fe$var$pathToRegexp_1(routepath, keys, {
                end: exact,
                strict: routepath === ""
            })
        };
        $2c24f9dd87b676fe$var$cache$1.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$2c24f9dd87b676fe$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($2c24f9dd87b676fe$var$decodeParam) : [];
            else params[prop] = value ? $2c24f9dd87b676fe$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ /**
 * Traverses the routes tree and matches its nodes to the given pathname from
 * the root down to the leaves. Each match consumes a part of the pathname and
 * the matching process continues for as long as there is a matching child
 * route for the remaining part of the pathname.
 *
 * The returned value is a lazily evaluated iterator.
 *
 * The leading "/" in a route path matters only for the root of the routes
 * tree (or if all parent routes are ""). In all other cases a leading "/" in
 * a child route path has no significance.
 *
 * The trailing "/" in a _route path_ matters only for the leaves of the
 * routes tree. A leaf route with a trailing "/" matches only a pathname that
 * also has a trailing "/".
 *
 * The trailing "/" in a route path does not affect matching of child routes
 * in any way.
 *
 * The trailing "/" in a _pathname_ generally does not matter (except for
 * the case of leaf nodes described above).
 *
 * The "" and "/" routes have special treatment:
 *  1. as a single route
 *     the "" and "/" routes match only the "" and "/" pathnames respectively
 *  2. as a parent in the routes tree
 *     the "" route matches any pathname without consuming any part of it
 *     the "/" route matches any absolute pathname consuming its leading "/"
 *  3. as a leaf in the routes tree
 *     the "" and "/" routes match only if the entire pathname is consumed by
 *         the parent routes chain. In this case "" and "/" are equivalent.
 *  4. several directly nested "" or "/" routes
 *     - directly nested "" or "/" routes are 'squashed' (i.e. nesting two
 *       "/" routes does not require a double "/" in the pathname to match)
 *     - if there are only "" in the parent routes chain, no part of the
 *       pathname is consumed, and the leading "/" in the child routes' paths
 *       remains significant
 *
 * Side effect:
 *   - the routes tree { path: '' } matches only the '' pathname
 *   - the routes tree { path: '', children: [ { path: '' } ] } matches any
 *     pathname (for the tree root)
 *
 * Prefix matching can be enabled also by `children: true`.
 */ function $2c24f9dd87b676fe$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || "";
    if (routepath.charAt(0) === "/") {
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
        ignoreLeadingSlash = true;
    }
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $2c24f9dd87b676fe$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === "/") matchedLength += 1;
                    childMatches = $2c24f9dd87b676fe$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true
            };
        }
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $2c24f9dd87b676fe$var$resolveRoute(context) {
    if ($2c24f9dd87b676fe$var$isFunction(context.route.action)) return context.route.action(context);
    return undefined;
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $2c24f9dd87b676fe$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $2c24f9dd87b676fe$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $2c24f9dd87b676fe$var$updateChainForRoute(context, match) {
    const { route: route , path: path  } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else // Discard old items
        if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 */ class $2c24f9dd87b676fe$export$8b4c839865b08288 {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError("Invalid routes");
        this.baseUrl = options.baseUrl || "";
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $2c24f9dd87b676fe$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: "",
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
   * Returns the current list of routes (as a shallow copy). Adding / removing
   * routes to / from the returned array does not affect the routing config,
   * but modifying the route objects does.
   *
   * @return {!Array<!Router.Route>}
   */ getRoutes() {
        return [
            ...this.root.__children
        ];
    }
    /**
   * Sets the routing config (replacing the existing one).
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   */ setRoutes(routes) {
        $2c24f9dd87b676fe$var$ensureRoutes(routes);
        const newRoutes = [
            ...$2c24f9dd87b676fe$var$toArray(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
   * Appends one or several routes to the routing config and returns the
   * effective routing config after the operation.
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   * @return {!Array<!Router.Route>}
   * @protected
   */ addRoutes(routes) {
        $2c24f9dd87b676fe$var$ensureRoutes(routes);
        this.root.__children.push(...$2c24f9dd87b676fe$var$toArray(routes));
        return this.getRoutes();
    }
    /**
   * Removes all existing routes from the routing config.
   */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
   * Asynchronously resolves the given pathname, i.e. finds all routes matching
   * the pathname and tries resolving them one after another in the order they
   * are listed in the routes config until the first non-null result.
   *
   * Returns a promise that is fulfilled with the return value of an object that consists of the first
   * route handler result that returns something other than `null` or `undefined` and context used to get this result.
   *
   * If no route handlers return a non-null result, or if no route matches the
   * given pathname the returned promise is rejected with a 'page not found'
   * `Error`.
   *
   * @param {!string|!{pathname: !string}} pathnameOrContext the pathname to
   *    resolve or a context object with a `pathname` property and other
   *    properties to pass to the route resolver functions.
   * @return {!Promise<any>}
   */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, $2c24f9dd87b676fe$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $2c24f9dd87b676fe$var$matchRoute(this.root, this.__normalizePathname(context.pathname), this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$2c24f9dd87b676fe$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($2c24f9dd87b676fe$var$notFoundResult);
                }
            }
            if (matches.done) return Promise.reject($2c24f9dd87b676fe$var$getNotFoundError(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $2c24f9dd87b676fe$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $2c24f9dd87b676fe$var$notFoundResult) {
                    currentContext.result = resolution.result || resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).catch((error)=>{
            const errorMessage = $2c24f9dd87b676fe$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            // DOMException has its own code which is read-only
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    /**
   * URL constructor polyfill hook. Creates and returns an URL instance.
   */ static __createUrl(url, base) {
        return new URL(url, base);
    }
    /**
   * If the baseUrl property is set, transforms the baseUrl and returns the full
   * actual `base` string for using in the `new URL(path, base);` and for
   * prepernding the paths with. The returned base ends with a trailing slash.
   *
   * Otherwise, returns empty string.
   */ get __effectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, "") : "";
    }
    /**
   * If the baseUrl is set, matches the pathname with the router’s baseUrl,
   * and returns the local pathname with the baseUrl stripped out.
   *
   * If the pathname does not match the baseUrl, returns undefined.
   *
   * If the `baseUrl` is not set, returns the unmodified pathname argument.
   */ __normalizePathname(pathname) {
        if (!this.baseUrl) // No base URL, no need to transform the pathname.
        return pathname;
        const base = this.__effectiveBaseUrl;
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
    }
}
$2c24f9dd87b676fe$export$8b4c839865b08288.pathToRegexp = $2c24f9dd87b676fe$var$pathToRegexp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { pathToRegexp: $2c24f9dd87b676fe$var$pathToRegexp  } = $2c24f9dd87b676fe$export$8b4c839865b08288;
const $2c24f9dd87b676fe$var$cache = new Map();
function $2c24f9dd87b676fe$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $2c24f9dd87b676fe$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $2c24f9dd87b676fe$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $2c24f9dd87b676fe$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : "";
}
function $2c24f9dd87b676fe$var$generateUrls(router, options = {}) {
    if (!(router instanceof $2c24f9dd87b676fe$export$8b4c839865b08288)) throw new TypeError("An instance of Resolver is expected");
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $2c24f9dd87b676fe$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear(); // clear cache
            $2c24f9dd87b676fe$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $2c24f9dd87b676fe$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $2c24f9dd87b676fe$var$cache.get(route.fullPath);
        if (!regexp) {
            let fullPath = $2c24f9dd87b676fe$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $2c24f9dd87b676fe$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, "") + "/" + fullPath.replace(/^\//, "");
                rt = rt.parent;
            }
            const tokens = $2c24f9dd87b676fe$var$pathToRegexp.parse(fullPath);
            const toPath = $2c24f9dd87b676fe$var$pathToRegexp.tokensToFunction(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!$2c24f9dd87b676fe$var$isString(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $2c24f9dd87b676fe$var$cache.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || "/";
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === "?" ? query : `?${query}`;
        }
        return url;
    };
}
/**
 * @typedef NavigationTrigger
 * @type {object}
 * @property {function()} activate
 * @property {function()} inactivate
 */ /** @type {Array<NavigationTrigger>} */ let $2c24f9dd87b676fe$var$triggers = [];
function $2c24f9dd87b676fe$var$setNavigationTriggers(newTriggers) {
    $2c24f9dd87b676fe$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $2c24f9dd87b676fe$var$triggers = newTriggers;
}
const $2c24f9dd87b676fe$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue("animation-name");
    return name && name !== "none";
};
const $2c24f9dd87b676fe$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener("animationend", listener);
        cb();
    };
    elem.addEventListener("animationend", listener);
};
function $2c24f9dd87b676fe$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($2c24f9dd87b676fe$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute("style", `position: absolute; ${size}`);
            $2c24f9dd87b676fe$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute("style");
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $2c24f9dd87b676fe$var$MAX_REDIRECT_COUNT = 256;
function $2c24f9dd87b676fe$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $2c24f9dd87b676fe$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $2c24f9dd87b676fe$var$createLocation({ pathname: pathname = "" , search: search = "" , hash: hash = "" , chain: chain = [] , params: params = {} , redirectFrom: redirectFrom , resolver: resolver  }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || "",
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$2c24f9dd87b676fe$var$getPathnameForRouter($2c24f9dd87b676fe$export$55185c17a0fcbe46.pathToRegexp.compile($2c24f9dd87b676fe$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $2c24f9dd87b676fe$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $2c24f9dd87b676fe$var$renderElement(context, element) {
    element.location = $2c24f9dd87b676fe$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $2c24f9dd87b676fe$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($2c24f9dd87b676fe$var$isFunction(callback)) return callback.apply(thisArg, args);
}
function $2c24f9dd87b676fe$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return $2c24f9dd87b676fe$var$runCallbackIfPossible(element[amendmentFunction], args, element);
    };
}
function $2c24f9dd87b676fe$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !$2c24f9dd87b676fe$var$isObject(newChildren)) throw new Error($2c24f9dd87b676fe$var$log(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = $2c24f9dd87b676fe$var$toArray(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        $2c24f9dd87b676fe$var$ensureRoute(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $2c24f9dd87b676fe$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
function $2c24f9dd87b676fe$var$getPathnameForRouter(pathname, router) {
    const base = router.__effectiveBaseUrl;
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ""), base).pathname : pathname;
}
function $2c24f9dd87b676fe$var$getMatchedPath(chain) {
    return chain.map((item)=>item.path).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, "") + "/" + b.replace(/^\//, "");
        return a;
    }, "");
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $2c24f9dd87b676fe$export$55185c17a0fcbe46 extends $2c24f9dd87b676fe$export$8b4c839865b08288 {
    /**
   * Creates a new Router instance with a given outlet, and
   * automatically subscribes it to navigation events on the `window`.
   * Using a constructor argument or a setter for outlet is equivalent:
   *
   * ```
   * const router = new Router();
   * router.setOutlet(outlet);
   * ```
   * @param {?Node=} outlet
   * @param {?RouterOptions=} options
   */ constructor(outlet, options){
        const baseElement = document.head.querySelector("base");
        const baseHref = baseElement && baseElement.getAttribute("href");
        super([], Object.assign({
            // Default options
            baseUrl: baseHref && $2c24f9dd87b676fe$export$8b4c839865b08288.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, "")
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        const triggers = $2c24f9dd87b676fe$export$55185c17a0fcbe46.NavigationTrigger;
        $2c24f9dd87b676fe$export$55185c17a0fcbe46.setTriggers.apply($2c24f9dd87b676fe$export$55185c17a0fcbe46, Object.keys(triggers).map((key)=>triggers[key]));
        /**
     * The base URL for all routes in the router instance. By default,
     * if the base element exists in the `<head>`, vaadin-router
     * takes the `<base href>` attribute value, resolves against current `document.URL`
     * and gets the `pathname` from the result.
     *
     * @public
     * @type {string}
     */ this.baseUrl;
        /**
     * A promise that is settled after the current render cycle completes. If
     * there is no render cycle in progress the promise is immediately settled
     * with the last render cycle result.
     *
     * @public
     * @type {!Promise<!RouterLocation>}
     */ this.ready;
        this.ready = Promise.resolve(outlet);
        /**
     * Contains read-only information about the current router location:
     * pathname, active routes, parameters. See the
     * [Location type declaration](#/classes/RouterLocation)
     * for more details.
     *
     * @public
     * @type {!RouterLocation}
     */ this.location;
        this.location = $2c24f9dd87b676fe$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        // Using WeakMap instead of WeakSet because WeakSet is not supported by IE11
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ($2c24f9dd87b676fe$var$isFunction(route.children)) callbacks = callbacks.then(()=>route.children($2c24f9dd87b676fe$var$copyContextWithoutNext(context))).then((children)=>{
            // The route.children() callback might have re-written the
            // route.children property instead of returning a value
            if (!$2c24f9dd87b676fe$var$isResultNotEmpty(children) && !$2c24f9dd87b676fe$var$isFunction(route.children)) children = route.children;
            $2c24f9dd87b676fe$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$2c24f9dd87b676fe$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return $2c24f9dd87b676fe$var$runCallbackIfPossible(route.action, [
                context,
                commands
            ], route);
        }).then((result)=>{
            if ($2c24f9dd87b676fe$var$isResultNotEmpty(result)) {
                // Actions like `() => import('my-view.js')` are not expected to
                // end the resolution, despite the result is not empty. Checking
                // the result with a whitelist of values that end the resolution.
                if (result instanceof HTMLElement || result.redirect || result === $2c24f9dd87b676fe$var$notFoundResult) return result;
            }
            if ($2c24f9dd87b676fe$var$isString(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return $2c24f9dd87b676fe$var$loadBundle(route.bundle).then(()=>{}, ()=>{
                throw new Error($2c24f9dd87b676fe$var$log(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
        }).then((result)=>{
            if ($2c24f9dd87b676fe$var$isResultNotEmpty(result)) return result;
            if ($2c24f9dd87b676fe$var$isString(route.component)) return commands.component(route.component);
        });
    }
    /**
   * Sets the router outlet (the DOM node where the content for the current
   * route is inserted). Any content pre-existing in the router outlet is
   * removed at the end of each render pass.
   *
   * NOTE: this method is automatically invoked first time when creating a new Router instance.
   *
   * @param {?Node} outlet the DOM node where the content for the current route
   *     is inserted.
   */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
   * Returns the current router outlet. The initial value is `undefined`.
   *
   * @return {?Node} the current router outlet (or `undefined`)
   */ getOutlet() {
        return this.__outlet;
    }
    /**
   * Sets the routing config (replacing the existing one) and triggers a
   * navigation event so that the router outlet is refreshed according to the
   * current `window.location` and the new routing config.
   *
   * Each route object may have the following properties, listed here in the processing order:
   * * `path` – the route path (relative to the parent route if any) in the
   * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   *
   * * `children` – an array of nested routes or a function that provides this
   * array at the render time. The function can be synchronous or asynchronous:
   * in the latter case the render is delayed until the returned promise is
   * resolved. The `children` function is executed every time when this route is
   * being rendered. This allows for dynamic route structures (e.g. backend-defined),
   * but it might have a performance impact as well. In order to avoid calling
   * the function on subsequent renders, you can override the `children` property
   * of the route object and save the calculated array there
   * (via `context.route.children = [ route1, route2, ...];`).
   * Parent routes are fully resolved before resolving the children. Children
   * 'path' values are relative to the parent ones.
   *
   * * `action` – the action that is executed before the route is resolved.
   * The value for this property should be a function, accepting `context`
   * and `commands` parameters described below. If present, this function is
   * always invoked first, disregarding of the other properties' presence.
   * The action can return a result directly or within a `Promise`, which
   * resolves to the result. If the action result is an `HTMLElement` instance,
   * a `commands.component(name)` result, a `commands.redirect(path)` result,
   * or a `context.next()` result, the current route resolution is finished,
   * and other route config properties are ignored.
   * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
   * The target route should also be defined.
   * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
   * or the object with "module" and "nomodule" keys referring to different bundles.
   * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
   * depending on whether the browser supports ES modules or not.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
   * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `component` – the tag name of the Web Component to resolve the route to.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * If route contains the `component` property (or an action that return a component)
   * and its child route also contains the `component` property, child route's component
   * will be rendered as a light dom child of a parent component.
   *
   * * `name` – the string name of the route to use in the
   * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
   * navigation helper method.
   *
   * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
   * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
   * because arrow functions do not have their own `this` reference.
   *
   * `context` object that is passed to `action` function holds the following properties:
   * * `context.pathname` – string with the pathname being resolved
   *
   * * `context.search` – search query string
   *
   * * `context.hash` – hash string
   *
   * * `context.params` – object with route parameters
   *
   * * `context.route` – object that holds the route that is currently being rendered.
   *
   * * `context.next()` – function for asynchronously getting the next route
   * contents from the resolution chain (if any)
   *
   * `commands` object that is passed to `action` function has
   * the following methods:
   *
   * * `commands.redirect(path)` – function that creates a redirect data
   * for the path specified.
   *
   * * `commands.component(component)` – function that creates a new HTMLElement
   * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
   *
   *
   * @param {!Array<!Route>|!Route} routes a single route or an array of those
   * @param {?boolean} skipRender configure the router but skip rendering the
   *     route corresponding to the current `window.location` values
   *
   * @return {!Promise<!Node>}
   */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
   * Asynchronously resolves the given pathname and renders the resolved route
   * component into the router outlet. If no router outlet is set at the time of
   * calling this method, or at the time when the route resolution is completed,
   * a `TypeError` is thrown.
   *
   * Returns a promise that is fulfilled with the router outlet DOM Node after
   * the route component is created and inserted into the router outlet, or
   * rejected if no route matches the given path.
   *
   * If another render pass is started before the previous one is completed, the
   * result of the previous render pass is ignored.
   *
   * @param {!string|!{pathname: !string, search: ?string, hash: ?string}} pathnameOrContext
   *    the pathname to render or a context object with a `pathname` property,
   *    optional `search` and `hash` properties, and other properties
   *    to pass to the resolver.
   * @param {boolean=} shouldUpdateHistory
   *    update browser history with the rendered location
   * @return {!Promise<!Node>}
   */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: "",
            hash: ""
        }, $2c24f9dd87b676fe$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        // Find the first route that resolves to a non-empty result
        this.ready = this.resolve(context)// Process the result of this.resolve() and handle all special commands:
        // (redirect / prevent / component). If the result is a 'component',
        // then go deeper and build the entire chain of nested components matching
        // the pathname. Also call all 'on before' callbacks along the way.
        .then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                // Check if the render was prevented and make an early return in that case
                if (context === previousContext) {
                    // Replace the history with the previous context
                    // to make sure the URL stays the same.
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $2c24f9dd87b676fe$var$createLocation(context);
                if (shouldUpdateHistory) // Replace only if first render redirects, so that we don’t leave
                // the redirecting record in the history
                this.__updateBrowserHistory(context, renderId === 1);
                $2c24f9dd87b676fe$var$fireRouterEvent("location-changed", {
                    router: this,
                    location: this.location
                });
                // Skip detaching/re-attaching there are no render changes
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        // If there is another render pass started after this one,
                        // the 'disappearing content' would be removed when the other
                        // render pass calls `this.__addAppearingContent()`
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                });
            }
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $2c24f9dd87b676fe$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $2c24f9dd87b676fe$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                $2c24f9dd87b676fe$var$fireRouterEvent("error", Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
        });
        return this.ready;
    }
    // `topOfTheChainContextBeforeRedirects` is a context coming from Resolver.resolve().
    // It would contain a 'redirect' route or the first 'component' route that
    // matched the pathname. There might be more child 'component' routes to be
    // resolved and added into the chain. This method would find and add them.
    // `contextBeforeRedirects` is the context containing such a child component
    // route. It's only necessary when this method is called recursively (otherwise
    // it's the same as the 'top of the chain' context).
    //
    // Apart from building the chain of child components, this method would also
    // handle 'redirect' routes, call 'onBefore' callbacks and handle 'prevent'
    // and 'redirect' callback results.
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects)// `contextAfterRedirects` is always a context with an `HTMLElement` result
        // In other cases the promise gets rejected and .then() is not called
        .then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $2c24f9dd87b676fe$var$getPathnameForRouter($2c24f9dd87b676fe$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            // Recursive method to try matching more child and sibling routes
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $2c24f9dd87b676fe$var$notFoundResult) {
                        // Next context is not found in children, ...
                        if (isFound) // ...but original context is already fully matching - use it
                        return context;
                        else if (parent.parent !== null) // ...and there is no full match yet - step up to check siblings
                        return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $2c24f9dd87b676fe$var$notFoundResult) throw $2c24f9dd87b676fe$var$getNotFoundError(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $2c24f9dd87b676fe$var$notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $2c24f9dd87b676fe$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error($2c24f9dd87b676fe$var$log(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${$2c24f9dd87b676fe$var$logValue(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$2c24f9dd87b676fe$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            // Skip re-attaching and notifications if element and chain do not change
            newContext.__skipAttach = // Same route chain
            newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && // Same element
            this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                // execute onBeforeLeave for changed segment element when skipping attach
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                // execute onBeforeEnter for changed segment element when skipping attach
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $2c24f9dd87b676fe$var$createLocation(newContext, previousChain[i].route);
                }
            } else // execute onBeforeLeave when NOT skipping attach
            for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        // execute onBeforeEnter when NOT skipping attach
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $2c24f9dd87b676fe$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $2c24f9dd87b676fe$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $2c24f9dd87b676fe$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $2c24f9dd87b676fe$var$amend("onBeforeLeave", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $2c24f9dd87b676fe$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $2c24f9dd87b676fe$var$amend("onBeforeEnter", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if (counter > $2c24f9dd87b676fe$var$MAX_REDIRECT_COUNT) throw new Error($2c24f9dd87b676fe$var$log(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError($2c24f9dd87b676fe$var$log(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname , search: search = "" , hash: hash = ""  }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? "replaceState" : "pushState";
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent("popstate", {
                state: "vaadin-router-ignore"
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        // Find the deepest common parent between the last and the new component
        // chains. Update references for the unchanged elements in the new chain
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        // If the previous 'entering' animation has not completed yet,
        // stop it and remove that content from the DOM before adding new one.
        this.__removeAppearingContent();
        // Copy reusable elements from the previousContext to current
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        // Keep two lists of DOM elements:
        //  - those that should be removed once the transition animation is over
        //  - and those that should remain
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter(// Only remove layout content that was added by router
        (e)=>this.__addedByRouter.get(e) && // Do not remove the result element to avoid flickering
            e !== context.result);
        // Add new elements (starting after the deepest common parent) to the DOM.
        // That way only the components that are actually different between the two
        // locations are added to the DOM (and those that are common remain in the
        // DOM without first removing and then adding them again).
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $2c24f9dd87b676fe$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $2c24f9dd87b676fe$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        // REVERSE iteration: from Z to A
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $2c24f9dd87b676fe$var$createLocation(currentContext);
                $2c24f9dd87b676fe$var$runCallbackIfPossible(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $2c24f9dd87b676fe$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        // forward iteration: from A to Z
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $2c24f9dd87b676fe$var$createLocation(currentContext, currentContext.chain[i].route);
            $2c24f9dd87b676fe$var$runCallbackIfPossible(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = $2c24f9dd87b676fe$var$isObject(config) && config.leave || "leaving";
            const enter = $2c24f9dd87b676fe$var$isObject(config) && config.enter || "entering";
            promises.push($2c24f9dd87b676fe$var$animate(from, leave));
            promises.push($2c24f9dd87b676fe$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
   * Subscribes this instance to navigation events on the `window`.
   *
   * NOTE: beware of resource leaks. For as long as a router instance is
   * subscribed to navigation events, it won't be garbage collected.
   */ subscribe() {
        window.addEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    /**
   * Removes the subscription to navigation events created in the `subscribe()`
   * method.
   */ unsubscribe() {
        window.removeEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname , search: search , hash: hash  } = event ? event.detail : window.location;
        if ($2c24f9dd87b676fe$var$isString(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
   * Configures what triggers Router navigation events:
   *  - `POPSTATE`: popstate events on the current `window`
   *  - `CLICK`: click events on `<a>` links leading to the current page
   *
   * This method is invoked with the pre-configured values when creating a new Router instance.
   * By default, both `POPSTATE` and `CLICK` are enabled. This setup is expected to cover most of the use cases.
   *
   * See the `router-config.js` for the default navigation triggers config. Based on it, you can
   * create the own one and only import the triggers you need, instead of pulling in all the code,
   * e.g. if you want to handle `click` differently.
   *
   * See also **Navigation Triggers** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * @param {...NavigationTrigger} triggers
   */ static setTriggers(...triggers) {
        $2c24f9dd87b676fe$var$setNavigationTriggers(triggers);
    }
    /**
   * Generates a URL for the route with the given name, optionally performing
   * substitution of parameters.
   *
   * The route is searched in all the Router instances subscribed to
   * navigation events.
   *
   * **Note:** For child route names, only array children are considered.
   * It is not possible to generate URLs using a name for routes set with
   * a children function.
   *
   * @function urlForName
   * @param {!string} name the route name or the route’s `component` name.
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = $2c24f9dd87b676fe$var$generateUrls(this);
        return $2c24f9dd87b676fe$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
   * Generates a URL for the given route path, optionally performing
   * substitution of parameters.
   *
   * @param {!string} path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForPath(path, params) {
        return $2c24f9dd87b676fe$var$getPathnameForRouter($2c24f9dd87b676fe$export$55185c17a0fcbe46.pathToRegexp.compile(path)(params), this);
    }
    /**
   * Triggers navigation to a new path. Returns a boolean without waiting until
   * the navigation is complete. Returns `true` if at least one `Router`
   * has handled the navigation (was subscribed and had `baseUrl` matching
   * the `path` argument), otherwise returns `false`.
   *
   * @param {!string|!{pathname: !string, search: (string|undefined), hash: (string|undefined)}} path
   *   a new in-app path string, or an URL-like object with `pathname`
   *   string property, and optional `search` and `hash` string properties.
   * @return {boolean}
   */ static go(path) {
        const { pathname: pathname , search: search , hash: hash  } = $2c24f9dd87b676fe$var$isString(path) ? this.__createUrl(path, "http://a") // some base to omit origin
         : path;
        return $2c24f9dd87b676fe$var$fireRouterEvent("go", {
            pathname: pathname,
            search: search,
            hash: hash
        });
    }
}
const $2c24f9dd87b676fe$var$DEV_MODE_CODE_REGEXP = /\/\*[\*!]\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $2c24f9dd87b676fe$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $2c24f9dd87b676fe$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $2c24f9dd87b676fe$var$uncommentAndRun(test);
}
function $2c24f9dd87b676fe$var$isDevelopmentMode() {
    try {
        if ($2c24f9dd87b676fe$var$isForcedDevelopmentMode()) return true;
        if (!$2c24f9dd87b676fe$var$isLocalhost()) return false;
        if ($2c24f9dd87b676fe$var$FlowClients) return !$2c24f9dd87b676fe$var$isFlowProductionMode();
        return !$2c24f9dd87b676fe$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $2c24f9dd87b676fe$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $2c24f9dd87b676fe$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $2c24f9dd87b676fe$var$isFlowProductionMode() {
    if ($2c24f9dd87b676fe$var$FlowClients) {
        const productionModeApps = Object.keys($2c24f9dd87b676fe$var$FlowClients).map((key)=>$2c24f9dd87b676fe$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $2c24f9dd87b676fe$var$uncommentAndRun(callback, args) {
    if (typeof callback !== "function") return;
    const match = $2c24f9dd87b676fe$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log("vaadin-development-mode-detector: uncommentAndRun() failed", e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window["Vaadin"] = window["Vaadin"] || {};
/**
 * Inspects the source code of the given `callback` function for
 * specially-marked _commented_ code. If such commented code is found in the
 * callback source, uncomments and runs that code instead of the callback
 * itself. Otherwise runs the callback as is.
 *
 * The optional arguments are passed into the callback / uncommented code,
 * the result is returned.
 *
 * See the `isMinified()` function source code in this file for an example.
 *
 */ const $2c24f9dd87b676fe$var$runIfDevelopmentMode = function(callback, args) {
    if (window.Vaadin.developmentMode) return $2c24f9dd87b676fe$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $2c24f9dd87b676fe$var$isDevelopmentMode();
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ function $2c24f9dd87b676fe$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $2c24f9dd87b676fe$var$usageStatistics = function() {
    if (typeof $2c24f9dd87b676fe$var$runIfDevelopmentMode === "function") return $2c24f9dd87b676fe$var$runIfDevelopmentMode($2c24f9dd87b676fe$var$maybeGatherAndSendStats);
};
window.Vaadin = window.Vaadin || {};
window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.registrations.push({
    is: "@vaadin/router",
    version: "1.7.4"
});
$2c24f9dd87b676fe$var$usageStatistics();
$2c24f9dd87b676fe$export$55185c17a0fcbe46.NavigationTrigger = {
    POPSTATE: $2c24f9dd87b676fe$var$POPSTATE,
    CLICK: $2c24f9dd87b676fe$var$CLICK
};


const $1ab404e0aa33e84f$var$root = document.querySelector(".root");
const $1ab404e0aa33e84f$var$router = new (0, $2c24f9dd87b676fe$export$55185c17a0fcbe46)($1ab404e0aa33e84f$var$root);
$1ab404e0aa33e84f$var$router.setRoutes([
    {
        path: "/",
        component: "home-page"
    },
    {
        path: "/index.html",
        component: "home-page"
    },
    {
        path: "/en",
        component: "en-home-page"
    },
    {
        path: "/en/index.html",
        component: "en-home-page"
    },
    {
        path: "/company/indalo-media",
        component: "indalo-media-page"
    },
    {
        path: "/company/oil-m&s",
        component: "oil-combustibles-page"
    },
    {
        path: "/company/cpc",
        component: "cpc-page"
    },
    {
        path: "/company/providencia",
        component: "providencia-page"
    },
    {
        path: "/company/alpat",
        component: "alpat-page"
    },
    {
        path: "/company/serma",
        component: "serma-page"
    },
    {
        path: "/company/pilgrim",
        component: "pilgrim-page"
    },
    {
        path: "/en/company/indalo-media",
        component: "en-indalo-media-page"
    },
    {
        path: "/en/company/oil-m&s",
        component: "en-oil-combustibles-page"
    },
    {
        path: "/en/company/cpc",
        component: "en-cpc-page"
    },
    {
        path: "/en/company/providencia",
        component: "en-providencia-page"
    },
    {
        path: "/en/company/alpat",
        component: "en-alpat-page"
    },
    {
        path: "/en/company/serma",
        component: "en-serma-page"
    },
    {
        path: "/en/company/pilgrim",
        component: "en-pilgrim-page"
    }
]);


var $58a3dc59024aec1d$exports = {};

$58a3dc59024aec1d$exports = new URL((parcelRequire("6Dqfy")).resolve("1i1MU"), import.meta.url).toString();


var $fc139128a52810d7$exports = {};

$fc139128a52810d7$exports = new URL((parcelRequire("6Dqfy")).resolve("2DXjT"), import.meta.url).toString();


var $971b1f94782b4bff$exports = {};

$971b1f94782b4bff$exports = new URL((parcelRequire("6Dqfy")).resolve("4fTEl"), import.meta.url).toString();


const $83c2f2f3efc2ecb4$var$indaloVideo = "https://indalo-institucional.s3.amazonaws.com/grupo-indalo.mp4";
customElements.define("home-page", class initHomePage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <header-comp class="header"></header-comp>
            
				<div id="hero" class="hero">
					<div class="hero__slider-container">
						<hero-slider class="hidden">
						Construcción, energía, minería y medios de comunicación.
						</hero-slider>
					</div>
					<div class="hero__scroll">
						<text-comp class="scroll__text" variant="hero" scheme="f-light" contains-html>
							Scroll
							<img src="${$fc139128a52810d7$exports}"/>
						</text-comp>
					</div>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <title-comp class="hidden" variant="section montserrat bold" scheme="light">
							Nuestro futuro, mucho por hacer
						</title-comp>
                        <subtitle-comp class="hidden" variant="section montserrat bold" scheme="yellow">
							¿Qué es el Grupo Indalo?
						</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light">
                        	El Grupo Indalo es un conglomerado de empresas que invierte en la Argentina desde hace más de veinte años y que apuesta por el desarrollo del país generando empleo para miles de trabajadores y trabajadoras a lo largo de todo el territorio nacional.
                        </text-comp>
                        <text-comp class="hidden" variant="section" scheme="light">
                        	Está integrado por empresas de producción y servicios de diferentes rubros, principalmente en medios de comunicación, construcción, energía y minería.
                        </text-comp>
                        <text-comp class="hidden" variant="section" scheme="light">
                        	Fue creado en 1999 y desde entonces se convirtió en uno de los grupos más importantes de la Argentina con proyecciones de crecimiento en toda la región.
                        </text-comp>
                    </div>

                    <span class="divider xl mobile"></span>

                    <div class="about-us__content mobile second-section">
                        <title-comp class="hidden" variant="section montserrat bold" scheme="light">Lo que creemos</title-comp>
                        <subtitle-comp class="hidden" variant="section jakarta semibold" scheme="red">Misión</subtitle-comp>
                        <text-slider dualSlider class="hidden"
						first-paragraph="Contribuir al desarrollo económico y social de la Argentina a través de la inversión en empresas de diversos sectores, generando empleo y mejorando la calidad de vida de la población."
						second-paragraph="Buscamos ser líderes en cada una de nuestras áreas de negocio, brindando productos y servicios de alta calidad que satisfagan las necesidades de nuestros clientes y generen un impacto positivo en la sociedad."
						>
                        </text-slider>
                        <subtitle-comp class="hidden" variant="section jakarta semibold" scheme="blue">Visión</subtitle-comp>
                        <text-slider class="hidden"
						first-paragraph="Apuntamos a consolidar el liderazgo de nuestro grupo empresarial en el país y a proyectarnos hacia la región en busca de nuevos mercados estratégicos."
						second-paragraph="Ser referentes en cada uno de los sectores en los que participamos, brindando productos y soluciones innovadoras que generen valor a nuestros clientes y a la sociedad."
						third-paragraph="Además, nos comprometemos a ser una empresa socialmente responsable, promoviendo la sustentabilidad y el cuidado del medio ambiente en cada una de nuestras operaciones y contribuyendo al desarrollo de las comunidades en las que operamos."
						>
                        </text-slider>
                        <subtitle-comp class="hidden" variant="section jakarta semibold" scheme="green">Valores</subtitle-comp>
                        <text-slider class="hidden" variant="last-item"
						first-title="Compromiso:"
						first-paragraph="Nos comprometemos a brindar productos innovadores y de calidad a nuestros clientes y a ser un grupo de empresas socialmente responsable que contribuya al desarrollo sostenible de las comunidades en las que opera."
						second-title="Innovación:"
						second-paragraph="Nos esforzamos por estar a la vanguardia de cada uno de los mercados en los que participamos, invirtiendo en nuevas tecnologías y fomentando la creatividad y la innovación en todos nuestros equipos de trabajo."
						third-title="Excelencia:"
						third-paragraph="Buscamos la excelencia en todo lo que hacemos, desde la gestión empresarial hasta en la calidad de nuestros productos y servicios."
						>
                        </text-slider>
						<span class="divider mobile bottom event"></span>
                    </div>

					<div class="about-us__content desktop">
						<about-content class="hidden"></about-content>
					</div>

					<div class="about-us__media hidden">
						<img class="hidden about-us__media-icon" src="${$58a3dc59024aec1d$exports}">
						<video-embed src="${$83c2f2f3efc2ecb4$var$indaloVideo}"></video-embed>
					</div>
				</div>

				<div id="companies" class="companies">
					<div class="companies__content mobile">
						<span class="divider mobile"></span>
						<title-comp class="hidden" variant="section medium margin-top jakarta extra-bold" scheme="dark">Nuestro grupo</title-comp>
						<div class="companies-cards">
							<companies-slider></companies-slider>
						</div>
						<span class="divider dark mobile bottom"></span>
					</div>
					<div class="hidden companies__content desktop">
						<companies-content></companies-content>
					</div>
				</div>

                <div id="sust" class="sust">
					<div class="hidden sust-box">
						<div class="sust-box__pattern"></div>
						<div class="sust-box__content-wrapper">
							<div class="sust-box__content">
								<title-comp class="hidden" variant="section jakarta medium no-x-padding" scheme="light">Sustentabilidad</title-comp>
								<div class="sust-box__subtitle">
									<subtitle-comp class="hidden" variant="montserrat medium" scheme="light"></subtitle-comp>
								</div>
								<a class="sust-box__link" href="https://instagram.com/rseindalo?igshid=YmMyMTA2M2Y=">
									<button class="hidden sust-box__button">Ver más</button>
								</a>
							</div>
						</div>
					</div>
                </div>

				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.9vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 90vh;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			.hero__slider-container {
				margin: auto 0;
			}

			.hero__scroll {
				display: none;
			}

			@media (min-width: 768px) {
				.hero__scroll {
					display: initial;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					border-bottom: 1px solid var(--primary-color);
				}
			}

			.scroll__text {
				opacity: 0.8;
				transition: all .3s;
				animation: bounce 3s infinite;
			}

			.scroll__text:hover {
				cursor: pointer;
				opacity: 1;
			}

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 35px 25px;
				padding-bottom: 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				align-items: flex-start;
				border-bottom: 1px solid var(--white-color);
			}	

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 25px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.about-us__media {
					height: 80vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 1280px) {
				.about-us__media {
					height: 90vh;
					padding: 60px 0;
				}
			}

			@media (min-width: 1440px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 110px 0;
				}
			}

			@media (min-width: 768px) {
				.about-us__media-icon {
					display: none;
				}
			}

            .companies {
                width: 100%;
                height: 100vh;
				min-height: 770px;
				margin-top: 3vh;
                display: flex;
                flex-direction: column;
				align-items: center;
                justify-content: flex-start;
				background-color: var(--white-color);
				border-bottom: 1px solid var(--black-color);
            }


			@media (min-width: 768px) {
				.companies {
					min-height: 180vh;
					margin: 0;
					border: none;
				}
			}

			@media (min-width: 768px) and (max-width: 1440px) and (max-height: 780px) {
                .companies {
                    height: 200vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 700px) {
                .companies {
                    height: 225vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 650px) {
                .companies {
                    height: 230vh;
                }
            }

			@media (min-width: 1440px) {
				.companies {
					min-height: 260vh;
				}
			}

			@media (min-width: 1440px) and (max-height: 780px) {
                .companies {
                    height: 275vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 700px) {
                .companies {
                    height: 290vh;
                }
            }

			.companies__content {
				width: 100%;
                height: 100%;
				display: flex;
                flex-direction: column;
				align-items: center;
                justify-content: flex-start;
			}

			.companies__content.desktop {
				display: none;
			}

			@media (min-width: 768px) {
				.companies__content.mobile {
					display: none;
				}

				.companies__content.desktop {
					height: 100%;
					display: flex;
					justify-content: flex-start;
					align-items: center;
				}
			}
			
			.content__left-side {
				height: 100%;
				display: flex;
				justify-content: space-evenly;
				align-items: center;
			}

			.companies-cards { 
				width: 100%;
				height: 100%;
			}

			.companies-cards.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.companies-cards.mobile {
					display: none;
				}

				.companies-cards.desktop {
					display: flex;
					justify-content: center;
					align-items: center;
				}	
			}

			.sust {
                width: 100%;
                height: 50vh;
				min-height: 425px;
                display: flex;
                justify-content: center;
				align-items: center;
				background-color: var(--white-color);
            }

			@media (min-width: 768px) {
				.sust {
					height: 70vh;
				}
			}

			.sust-box {
				width: 360px;
				height: 370px;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;
				border: none;
				border-radius: 10px;
				background-color: var(--black-color);
			}

			@media (min-width: 768px) {
				.sust-box {
					height: 40vh;
					width: 70vw;
					flex-direction: row-reverse;
				}
			}

			.sust-box__pattern {
				width: 100%;
				height: 30%;
				background-position: top center;
				background-image: url(${$971b1f94782b4bff$exports});
				background-size: 75%;
			}

			@media (min-width: 768px) {
				.sust-box__pattern {
					width: 50%;
					height: 100%;
					background-size: cover;
				}
			}

			.sust-box__content-wrapper {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			@media (min-width: 768px) {
				.sust-box__content-wrapper {
					width: 50%;
				}	
			}

			.sust-box__content {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				text-align: center;
			}

			@media (min-width: 768px) {
				.sust-box__content {
					width: 85%;
					align-items: flex-start;
					text-align: left;
				}
			}

			@media (min-width: 960px) {
				.sust-box__content {
					width: 70%;
				}
			}

			@media (min-width: 1440px) {
				.sust-box__content {
					width: 60%;
				}
			}

			.sust-box__subtitle {
				width: 100%;
				padding: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-top: 1px solid var(--white-color);
			}

			@media (min-width: 768px) {
				.sust-box__subtitle {
					width: 90%;
					padding: 10px 0;
					padding-bottom: 20px;
					border: none;
				}
			}

			@media (min-width: 1850px) {
				.sust-box__subtitle {
					padding: 15px 0;
					padding-bottom: 25px;
				}
			}

			.sust-box__link {
				text-decoration: none;
			}

			.sust-box__button {
				width: 110px;
				height: 35px;
				background-color: var(--white-color);
				border: none;
				border-radius: 22px;
				font: 500 10px var(--jakarta-font);
			}

			.sust-box__button:hover {
				opacity: 0.8;
				cursor: pointer;
			}

			@media (min-width: 768px) {
				.sust-box__button {					
					width: 130px;
					height: 40px;
					font-size: 15px;				
				}
			}

			@media (min-width: 960px) {
				.sust-box__button {
					border-radius: 30px;

				}
			}

			@media (min-width: 1280px) {
				.sust-box__button {					
					width: 165px;
					height: 50px;
					font-size: 18px;
				}
			}

			@keyframes bounce {
				0% {
				  transform: translateY(0);
				}
				25% {
				  transform: translateY(-10px);
				}
				50% {
				  transform: translateY(0);
				}
				100% {
					transform: translateY(0);	
				}
			  }
        `;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const rootEl = document.querySelector(".root");
        const scrollTextEl = this.querySelector(".scroll__text");
        const aboutUsEl = this.querySelector("#about-us");
        bodyEl.style.overflowY = "auto";
        rootEl.style.overflowX = "initial";
        scrollTextEl.addEventListener("click", ()=>{
            aboutUsEl.scrollIntoView({
                behavior: "smooth"
            });
        });
        window.addEventListener("beforeunload", (e)=>{
            e.preventDefault();
            window.scrollTo(0, 0);
        });
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $42cb1983031089b4$exports = {};

$42cb1983031089b4$exports = new URL((parcelRequire("6Dqfy")).resolve("81uGT"), import.meta.url).toString();


var $e44a9ca88677ea64$exports = {};

$e44a9ca88677ea64$exports = new URL((parcelRequire("6Dqfy")).resolve("1WeYn"), import.meta.url).toString();




const $7aad15de45b1016b$var$videoIndaloMedia = "https://indalo-institucional.s3.amazonaws.com/indalo-media.mp4";
customElements.define("indalo-media-page", class initIndaloMediaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$42cb1983031089b4$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
							Compromiso, innovación y credibilidad.
                        </title-comp>
					</div>
					<button style="display: none" class="btn hero__btn">
						Visitar web
					</button>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de Indalo Media</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
							Indalo Media es uno de los principales multimedios de la Argentina. Cuenta con una fuerte presencia en la industria de la televisión, la radio, los medios gráficos, digitales y en la producción de contenidos audiovisuales. Gracias a un público fiel, crítico y a la calidad de sus servicios de comunicación, información, noticias, entretenimiento y música logró consolidarse entre los líderes de audiencia.
							<br><br>
							Los medios que componen el Grupo son: el canal de noticias C5N, las radios POP FM 101.5, Mega FM 98.3, Vale FM 97.5, One FM 103.7, Radio 10 AM710, el diario Ámbito Financiero, los portales ambito.com, c5n.com, minutouno.com, buenosairesherald.com y diarioregistrado.com. También forma parte del holding la productora Ideas del Sur, Pensado para Televisión (PPT) y La Corte.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de Indalo Media</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
									Fuerte presencia en televisión, radio, medios gráficos, digitales y en producción de contenidos audiovisuales.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
										Indalo Media es uno de los principales multimedios de la Argentina. Cuenta con una fuerte presencia en la industria de la televisión, la radio, los medios gráficos, digitales y en la producción de contenidos audiovisuales. Gracias a un público fiel, crítico y a la calidad de sus servicios de comunicación, información, noticias, entretenimiento y música logró consolidarse entre los líderes de audiencia.
										<br><br>
										Los medios que componen el Grupo son: el canal de noticias C5N, las radios POP FM 101.5, Mega FM 98.3, Vale FM 97.5, One FM 103.7, Radio 10 AM710, el diario Ámbito Financiero, los portales ambito.com, c5n.com, minutouno.com, buenosairesherald.com y diarioregistrado.com. También forma parte del holding la productora Ideas del Sur, Pensado para Televisión (PPT) y La Corte.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div style="display: none" class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$7aad15de45b1016b$var$videoIndaloMedia}"></video-embed>
						</div>

						<collabs-slider></collabs-slider>
	
						<button style="display: none" class="btn bottom__btn">
							Visitar web
						</button>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }
			
			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$e44a9ca88677ea64$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$e44a9ca88677ea64$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const rootEl = document.querySelector(".root");
        rootEl.style.overflowX = "hidden";
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $a2bd2683f70a0a67$exports = {};

$a2bd2683f70a0a67$exports = new URL((parcelRequire("6Dqfy")).resolve("c9zGL"), import.meta.url).toString();


var $9cd284aa05024f8e$exports = {};

$9cd284aa05024f8e$exports = new URL((parcelRequire("6Dqfy")).resolve("dzYeb"), import.meta.url).toString();




customElements.define("oil-combustibles-page", class initOilCombustiblesPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$a2bd2683f70a0a67$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
							Servicios integrales para la industria petrolera
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://oilms.ar/" target="_blank">
						<button class="btn hero__btn">
							Visitar web
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de Oil M&S</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
							Oil M&S es una empresa proveedora de soluciones integrales a la industria hidrocarburífera y minera en todo el país. Fundada en el año 2001 y, bajo un sistema de gestión integrado, ofrece una amplia variedad de servicios: operación y mantenimiento de yacimientos, operación integral de plantas de tratamiento de petróleo y gas, administración ambiental integral, perforación y workover, obras civiles y de ingeniería, servicios de logística y equipamiento vial, entre otros. Lleva a cabo sus operaciones en Buenos Aires, Chubut, Neuquén, Río Negro, Santa Cruz y Mendoza.							<br><br>
							La compañía cuenta con servicios liderados por personas de alta calificación junto a recursos tecnológicos de última generación en la búsqueda de la máxima eficiencia.
						</text-comp>
					</div>

					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de Oil M&S</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
									Soluciones integrales a la industria hidrocarburífera y minera.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
										Oil M&S es una empresa proveedora de soluciones integrales a la industria hidrocarburífera y minera en todo el país. Fundada en el año 2001 y, bajo un sistema de gestión integrado, ofrece una amplia variedad de servicios: operación y mantenimiento de yacimientos, operación integral de plantas de tratamiento de petróleo y gas, administración ambiental integral, perforación y workover, obras civiles y de ingeniería, servicios de logística y equipamiento vial, entre otros. Lleva a cabo sus operaciones en Buenos Aires, Chubut, Neuquén, Río Negro, Santa Cruz y Mendoza.										<br><br>
										La compañía cuenta con servicios liderados por personas de alta calificación junto a recursos tecnológicos de última generación en la búsqueda de la máxima eficiencia.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<button class="btn bottom__btn">
							<a class="hero__btn-link" href="https://oilms.ar/" target="_blank">Visitar web</a>
						</button>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$9cd284aa05024f8e$exports});
                background-position: left center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$9cd284aa05024f8e$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $cc64f062cd38ae25$exports = {};

$cc64f062cd38ae25$exports = new URL((parcelRequire("6Dqfy")).resolve("loP4k"), import.meta.url).toString();


var $ac89dac40e26ec20$exports = {};

$ac89dac40e26ec20$exports = new URL((parcelRequire("6Dqfy")).resolve("iHRLD"), import.meta.url).toString();




const $cb6731702292bd4f$var$videoCpc = "https://indalo-institucional.s3.amazonaws.com/cpc.mp4";
customElements.define("cpc-page", class initHomePage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$cc64f062cd38ae25$exports}">
                        	<title-comp variant="hero company-name jakarta bold" scheme="light">
                        	    CPC
                        	</title-comp>
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Líder en construcción de obras públicas de gran envergadura.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://www.cpc-sa.com.ar/" target="_blank">
						<button class="btn hero__btn">
							Visitar web
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de CPC</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
                        	Comercial del Plata Construcciones S.A fue fundada en el año 1977 y en 1995 cambió su nombre a CPC S.A. Desde sus inicios forjó una cultura ética de negocios y se consolidó como una de las mayores empresas latinoamericanas de construcción.
							<br><br>
							Formar parte del Grupo Indalo le permitió convertirse en una empresa líder en la construcción de obras públicas, destacándose en obras viales, mejoramientos y renovación de gasoductos, oleoductos, rutas y vías de ferrocarril.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de CPC</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Más de 40 años construyendo una gran compañía.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
										Comercial del Plata Construcciones S.A fue fundada en el año 1977 y en 1995 cambió su nombre a CPC S.A. Desde sus inicios forjó una cultura ética de negocios y se consolidó como una de las mayores empresas latinoamericanas de construcción.
										<br><br>
										Formar parte del Grupo Indalo le permitió convertirse en una empresa líder en la construcción de obras públicas, destacándose en obras viales, mejoramientos y renovación de gasoductos, oleoductos, rutas y vías de ferrocarril.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item hidden">
								<h3 class="item__number red" data-val="20000">0</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue" data-val="500">0</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green" data-val="1200">0</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider dark bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$cb6731702292bd4f$var$videoCpc}"></video-embed>
						</div>
	
						<a class="hero__btn-link" href="https://www.cpc-sa.com.ar/" target="_blank">
							<button class="btn bottom__btn">
								Visitar web
							</button>
						</a>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$ac89dac40e26ec20$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$ac89dac40e26ec20$exports});
					background-position: center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 40px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const itemNumberEl = this.querySelectorAll(".item__number");
        const factsItemEl = this.querySelector(".facts__item");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        window.addEventListener("scroll", ()=>{
            if (window.scrollY < 100) itemNumberEl.forEach((item)=>{
                item.textContent = "0";
            });
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    if (factsItemEl.classList.contains("show")) itemNumberEl.forEach((item)=>{
                        const updateNumber = ()=>{
                            const endValue = +item.getAttribute("data-val");
                            let startValue = +item.textContent;
                            item.textContent = `${Math.ceil(endValue)}`;
                            let increment = endValue / 100;
                            if (startValue < endValue) {
                                item.textContent = `${Math.ceil(startValue + increment)}`;
                                setTimeout(updateNumber, 20);
                            } else item.textContent = endValue.toString();
                        };
                        updateNumber();
                    });
                } else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $39341b9d299a6db1$exports = {};

$39341b9d299a6db1$exports = new URL((parcelRequire("6Dqfy")).resolve("2dCAO"), import.meta.url).toString();


var $7b07003ab1dc9312$exports = {};

$7b07003ab1dc9312$exports = new URL((parcelRequire("6Dqfy")).resolve("iBoUh"), import.meta.url).toString();




var $1704451a997f91e4$exports = {};

$1704451a997f91e4$exports = new URL((parcelRequire("6Dqfy")).resolve("ji7vT"), import.meta.url).toString();


customElements.define("providencia-page", class initProvidenciaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$39341b9d299a6db1$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Tranquilidad asegurada.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="http://providencia.com.ar/" target="_blank">
						<button class="btn hero__btn">
							Visitar web
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de Providencia Seguros</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
							Providencia Seguros inició sus operaciones en 1904. En la actualidad, es una compañía de capitales nacionales con un fuerte respaldo local, solidez patrimonial, profesionales altamente capacitados y una amplia gama de servicios diseñados para nuestro mercado.
							<br><br>
							Su mayor fortaleza es la atención centrada en el cliente, con una gran adaptación y flexibilidad para dar respuesta a cada necesidad, tanto en el segmento individuos como en el de PyMes y Grandes Empresas.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de Providencia Seguros</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Más de un siglo de historia.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
										Providencia Seguros inició sus operaciones en 1904. En la actualidad, es una compañía de capitales nacionales con un fuerte respaldo local, solidez patrimonial, profesionales altamente capacitados y una amplia gama de servicios diseñados para nuestro mercado.
										<br><br>
										Su mayor fortaleza es la atención centrada en el cliente, con una gran adaptación y flexibilidad para dar respuesta a cada necesidad, tanto en el segmento individuos como en el de PyMes y Grandes Empresas.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$1704451a997f91e4$exports}"></video-embed>
						</div>
	
						<a class="hero__btn-link" href="http://providencia.com.ar/" target="_blank">
							<button class="btn bottom__btn">
								Visitar web
							</button>
						</a>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$7b07003ab1dc9312$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$7b07003ab1dc9312$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 15px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 40px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $3e67dcecaa17c827$exports = {};

$3e67dcecaa17c827$exports = new URL((parcelRequire("6Dqfy")).resolve("iadjQ"), import.meta.url).toString();


var $b87cea178d57ad98$exports = {};

$b87cea178d57ad98$exports = new URL((parcelRequire("6Dqfy")).resolve("7Zxqu"), import.meta.url).toString();




const $3d974ce83cbba225$var$videoAlpat = "https://indalo-institucional.s3.amazonaws.com/alpat.mp4";
customElements.define("alpat-page", class initAlpatPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$3e67dcecaa17c827$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
							Única empresa productora de carbonato de sodio en Latinoamérica.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://alcalisdelapatagonia.com/" target="_blank">
						<button class="btn hero__btn">
							Visitar web
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de ALPAT</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
							Alcalis de la Patagonia (ALPAT) comenzó sus actividades en el año 2005 y actualmente es la única empresa productora de carbonato de sodio de Latinoamérica.
							<br><br>
							Se trata de una materia prima que se utiliza en la industria del vidrio, que demanda carbonato de sodio denso, mientras que en la industria química se requiere en su versión liviana para la producción de jabones y detergentes. También se utiliza para la industria del papel, petróleo y gas, metalurgia y química.
							<br><br>
							Alpat se encuentra ubicada en la localidad de San Antonio Oeste de la provincia de Río Negro.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de ALPAT</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Empresa fuertemente comprometida con la excelencia en la calidad y servicio al cliente.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
										Alcalis de la Patagonia (ALPAT) comenzó sus actividades en el año 2005 y actualmente es la única empresa productora de carbonato de sodio de Latinoamérica.
										<br><br>
										Se trata de una materia prima que se utiliza en la industria del vidrio, que demanda carbonato de sodio denso, mientras que en la industria química se requiere en su versión liviana para la producción de jabones y detergentes. También se utiliza para la industria del papel, petróleo y gas, metalurgia y química.
										<br><br>
										Alpat se encuentra ubicada en la localidad de San Antonio Oeste de la provincia de Río Negro.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item hidden">
								<h3 class="item__number red" data-val="170000">0</h3>
								<p class="item__text">Toneladas por año de carbonato de sodio</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue" data-val="5">0</h3>
								<p class="item__text">Exporta a cinco países de la región</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green" data-val="400">0</h3>
								<p class="item__text">Empleados directos</p>
							</div>
							<span class="divider dark bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$3d974ce83cbba225$var$videoAlpat}"></video-embed>
						</div>
	
						<a class="hero__btn-link" href="https://alcalisdelapatagonia.com/" target="_blank">
							<button class="btn bottom__btn">
								Visitar web
							</button>
						</a>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$b87cea178d57ad98$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$b87cea178d57ad98$exports});
					background-position: center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 200px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 230px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					width: 70%;
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 70%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 65%;
				}
			}

			.facts__item {
				width: 75%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			@media (min-width: 960px) {
				.facts__item {	
					width: 70%
				}
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 100%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1280px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 85%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const itemNumberEl = this.querySelectorAll(".item__number");
        const factsItemEl = this.querySelector(".facts__item");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        window.addEventListener("scroll", ()=>{
            if (window.scrollY < 100) itemNumberEl.forEach((item)=>{
                item.textContent = "0";
            });
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    if (factsItemEl.classList.contains("show")) itemNumberEl.forEach((item)=>{
                        const updateNumber = ()=>{
                            const endValue = +item.getAttribute("data-val");
                            let startValue = +item.textContent;
                            item.textContent = `${Math.ceil(endValue)}`;
                            let increment = endValue / 100;
                            if (startValue < endValue) {
                                item.textContent = `${Math.ceil(startValue + increment)}`;
                                setTimeout(updateNumber, 20);
                            } else item.textContent = endValue.toString();
                        };
                        updateNumber();
                    });
                } else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $32bc09c7dfbdca68$exports = {};

$32bc09c7dfbdca68$exports = new URL((parcelRequire("6Dqfy")).resolve("cfpIg"), import.meta.url).toString();


var $2548ae788ce5686d$exports = {};

$2548ae788ce5686d$exports = new URL((parcelRequire("6Dqfy")).resolve("eOa12"), import.meta.url).toString();




customElements.define("serma-page", class initSermaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$32bc09c7dfbdca68$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Empresa de vanguardia en ingeniería ambiental del mercado petrolero.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://serma.com.ar/" target="_blank">
					<button class="btn hero__btn">
						Visitar web
					</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de Serma</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light">
							Serma S.A. fue fundada en el año de 2006 como una empresa dedicada a la prestación de servicios para el up stream y down stream de la industria petrolera en la provincia de Neuquén y Rio Negro. Hoy, con los servicios de las provincias de La Pampa, Mendoza, Rio Negro y Santa Cruz la compañía sigue creciendo, adaptando su oferta a la necesidades del mercado petrolero para consolidarse y continuar siendo referente de servicios en la industria petrolera nacional.
						</text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de Serma</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Referente de servicios en la industria petrolera nacional.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light">
										Serma S.A. fue fundada en el año de 2006 como una empresa dedicada a la prestación de servicios para el up stream y down stream de la industria petrolera en la provincia de Neuquén y Rio Negro. Hoy, con los servicios de las provincias de La Pampa, Mendoza, Rio Negro y Santa Cruz la compañía sigue creciendo, adaptando su oferta a la necesidades del mercado petrolero para consolidarse y continuar siendo referente de servicios en la industria petrolera nacional.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<a class="hero__btn-link" href="https://serma.com.ar/" target="_blank">
						<button class="btn bottom__btn">
							Visitar web
						</button>
						</a>
						</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$2548ae788ce5686d$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$2548ae788ce5686d$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 200px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 230px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $ba7ed2acb1e041df$exports = {};

$ba7ed2acb1e041df$exports = new URL((parcelRequire("6Dqfy")).resolve("i0QEE"), import.meta.url).toString();


var $ea54a7185f45d98b$exports = {};

$ea54a7185f45d98b$exports = new URL((parcelRequire("6Dqfy")).resolve("cc9Th"), import.meta.url).toString();




customElements.define("pilgrim-page", class initPilgrimPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <company-header-comp class="header"></company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$ba7ed2acb1e041df$exports}">
						</div>
                        <title-comp variant="hero company-slogan minimized jakarta thick-line medium bold" scheme="light">
							Empresa especializada en la producción y desarrollo de yacimientos de petróleo y gas.
						</title-comp>
					</div>
					<button style="display: none" class="btn hero__btn">
						Visitar web
					</button>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de PILGRIM ENERGY</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
                            Es una empresa argentina que desarrolla de manera rentable activos de productividad marginal en exploración, producción y transporte de crudo y gas. Tiene operación y actividades en la provincia de Chubut, en el área Cerro Negro, localizada en la Cuenca del Golfo San Jorge, a 130 km al Oeste de la ciudad de Comodoro Rivadavia y a 25 km al sureste de la ciudad de Sarmiento. Se extiende un área de 186 km2. 
							<br><br>
							La empresa cuenta con un equipo de trabajo profesional y altamente calificado que busca obtener la mayor rentabilidad de sus activos, desarrollando e implementando modelos operativos y de desarrollo con altos estándares de calidad, seguridad y medio ambiente.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de PILGRIM ENERGY</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
									Empresa especializada en la producción y desarrollo de yacimientos de petróleo y gas.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
                                        Es una empresa argentina que desarrolla de manera rentable activos de productividad marginal en exploración, producción y transporte de crudo y gas. Tiene operación y actividades en la provincia de Chubut, en el área Cerro Negro, localizada en la Cuenca del Golfo San Jorge, a 130 km al Oeste de la ciudad de Comodoro Rivadavia y a 25 km al sureste de la ciudad de Sarmiento. Se extiende un área de 186 km2. 
										<br><br>
										La empresa cuenta con un equipo de trabajo profesional y altamente calificado que busca obtener la mayor rentabilidad de sus activos, desarrollando e implementando modelos operativos y de desarrollo con altos estándares de calidad, seguridad y medio ambiente.
                			        </text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<button class="btn bottom__btn">
							Visitar web
						</button>
					</div>
				</div>
				<footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$ea54a7185f45d98b$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$ea54a7185f45d98b$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
				border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});


var $fca64589137b1371$exports = {};

$fca64589137b1371$exports = new URL((parcelRequire("6Dqfy")).resolve("8NeQb"), import.meta.url).toString();


var $b053139d7337e77f$exports = {};

$b053139d7337e77f$exports = new URL((parcelRequire("6Dqfy")).resolve("9fA6s"), import.meta.url).toString();


var $138cbacc045963da$exports = {};

$138cbacc045963da$exports = new URL((parcelRequire("6Dqfy")).resolve("8nrZT"), import.meta.url).toString();


class $f36ebff6534831b7$var$HeaderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
        .header {
            z-index: 200;
            position: fixed;
            left: 0;
            right: 0;
            width: calc(100% - 50px);
            padding: 0 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: var(--menu-bkgd-color);
            backdrop-filter: blur(10px);
						-webkit-backdrop-filter: blur(10px);
						border-bottom: 1px solid #fff;
						transition: all .4s linear;
        }

				.header__right {
					display: none
				}
        
        @media (min-width: 768px) {
            .header {
							width: calc(100% - 100px);
							padding: 0 50px;
            }
        }
				@media (max-width: 767px) {
					.header {
						gap: 12px;
						justify-content: flex-start;
					}
					.header__right {
						display: flex;
						width: 100%;
						justify-content: space-between;
					}
				}

				@media (min-width: 1280px) {
					.header {
						height: 90px;
					}
				}

				@media (min-width: 1440px) {
					.header {
						width: calc(100% - 200px);
						padding: 0 100px;
					}
				}

				.header__companies {
					margin: 0 auto;
					font: 700 18px var(--jakarta-font);
					text-decoration: none;
					color: var(--white-color);
				}

				.header__companies:hover {
					cursor: pointer;
				}

				.companies__list {
					display: none;
					transition: all .4s linear;
				}

				.companies__list.active {
					position: absolute;
					width: 150px;
					height: 200px;
					padding: 20px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: flex-start;
					background-color: var(--menu-bkgd-color);
					backdrop-filter: blur(10px);
					-webkit-backdrop-filter: blur(10px);
					border: 1px solid #fff;
					transition: all .4s linear;
				}

				@media (min-width: 768px) {
					.companies__list.active {
						top: 60px;
						right: 280px;
					}
				}

				@media (min-width: 1280px) {
					.companies__list.active {
						top: 90px;
					}
				}


				@media (min-width: 1440px) {
					.companies__list.active {
						top: 90px;
						right: 330px;
					}
				}

				.indalo-logo__wrapper {
					display: flex;
					justify-content: center;
					align-items: center;
					height: 100%;
				}

				.indalo-logo {
								padding: 15px 0;
								padding-right: 25px;
					height: 20px;
				}

				@media (min-width: 768px) {
					.indalo-logo {
						padding-right: 50px;
						height: 30px;
					}
				}

				@media (min-width: 1440px) {
					.indalo-logo {
						padding-right: 100px;
						height: 30px;
					}
				}

				@media (min-width: 1850px) {
					.indalo-logo {
						height: 40px;
					}
				}

        .header .indalo-logo__wrapper {
            border-right: 1px solid #fff;
        }

				.indalo-logo:hover {
					cursor: pointer;
				}
				
				.header-nav {
					display: none;
				}

				@media (min-width: 769px) {
					.header-nav {
						display: flex;
						justify-content: center;
						align-items: center;
						gap: 34px;
					}	
				}

				.burger-menu:hover {
					cursor: pointer;
				}

				.cross-menu {
					display: none;
				}

				.cross-menu:hover {
					cursor: pointer;
				}

				@media (min-width: 769px) {
					.menu,
					.burger-menu,
					.cross-menu,
					.translate--mobile {
						display: none;
					}
				}	
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                <header class="header">
                    <a class="indalo-logo__wrapper" href="#hero"><img class="indalo-logo" src="${$fca64589137b1371$exports}"></a>
										<div class="header__right">
											<translate-comp class="translate--mobile"></translate-comp>
											<img class="burger-menu" src="${$b053139d7337e77f$exports}">
											<img class="cross-menu" src="${$138cbacc045963da$exports}">
										</div>
					<div class="header-nav">
						<link-comp class="header-nav__link" variant="header" scheme="light" href="#hero">Inicio</link-comp>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="#about-us">Quiénes Somos</link-comp>
						<a class="header__companies" href="#companies">Empresas</a>
						<div class="companies__list">
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/indalo-media">Indalo Media</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/oil-m&s">Oil M&S</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/cpc">CPC</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/providencia">Providencia</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/alpat">Alpat</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/serma">Serma</link-comp>
						</div>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="#sust">Sustentabilidad</link-comp>
						<translate-comp></translate-comp>
					</div>
                </header>
                <menu-comp class="menu"></menu-comp>
        `;
    }
    elementsOverlap(el1, el2) {
        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();
        const overlaps = !(domRect1.top > domRect2.bottom || domRect1.bottom < domRect2.top);
        return overlaps;
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const burgerMenu = this.shadow.querySelector(".burger-menu");
        const crossMenu = this.shadow.querySelector(".cross-menu");
        const headerEl = this.shadow.querySelector(".header");
        const menuComponentEl = this.shadow.querySelector(".menu");
        const headerNavLinksEl = this.shadow.querySelectorAll(".header-nav__link");
        const headerCompaniesEl = this.shadow.querySelector(".header__companies");
        const companiesListEl = this.shadow.querySelector(".companies__list");
        const shadowMenuEl = menuComponentEl.shadowRoot.querySelector(".menu-container");
        const shadowMenuLinksEl = menuComponentEl.shadowRoot.querySelectorAll(".nav-link");
        const aboutUsDividerEl = document.querySelector(".divider.bottom");
        const mediaSectionEl = document.querySelector(".about-us__media");
        const companiesSectionEl = document.querySelector(".companies");
        const rseSectionEl = document.querySelector(".sust");
        burgerMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "hidden";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "none";
            crossMenu.style.display = "inherit";
        });
        crossMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "auto";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "inherit";
            crossMenu.style.display = "none";
        });
        headerEl.addEventListener("mouseleave", ()=>{
            companiesListEl.classList.remove("active");
        });
        headerCompaniesEl.addEventListener("mouseover", ()=>{
            companiesListEl.classList.toggle("active");
        });
        headerNavLinksEl.forEach((link)=>{
            link.addEventListener("mouseover", ()=>{
                companiesListEl.classList.remove("active");
            });
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        const mainLandingWindowEvent = ()=>{
            const headerOverlapsDivider = this.elementsOverlap(headerEl, aboutUsDividerEl);
            const headerOverlapsMediaSection = this.elementsOverlap(headerEl, mediaSectionEl);
            const headerOverlapsCompaniesSection = this.elementsOverlap(headerEl, companiesSectionEl);
            const headerOverlapsRSESection = this.elementsOverlap(headerEl, rseSectionEl);
            if (headerOverlapsMediaSection || headerOverlapsCompaniesSection || headerOverlapsRSESection) {
                headerEl.style.backdropFilter = "blur(0)";
                headerEl.style.backgroundColor = "#111";
                companiesListEl.style.backdropFilter = "blur(0)";
                companiesListEl.style.backgroundColor = "#111";
            } else if (headerOverlapsDivider) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop < window.innerHeight) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
        };
        window.addEventListener("scroll", mainLandingWindowEvent);
    }
}
customElements.define("header-comp", $f36ebff6534831b7$var$HeaderComponent);


var $42dad3286475bcc1$exports = {};

$42dad3286475bcc1$exports = new URL((parcelRequire("6Dqfy")).resolve("78Q4c"), import.meta.url).toString();


var $125e1db133398f72$exports = {};

$125e1db133398f72$exports = new URL((parcelRequire("6Dqfy")).resolve("ll8HU"), import.meta.url).toString();


var $5f5de6ecc8a73be6$exports = {};

$5f5de6ecc8a73be6$exports = new URL((parcelRequire("6Dqfy")).resolve("dOdQT"), import.meta.url).toString();


var $492809a4e9407687$exports = {};

$492809a4e9407687$exports = new URL((parcelRequire("6Dqfy")).resolve("6J2PC"), import.meta.url).toString();


var $a54685e3e631b55c$exports = {};

$a54685e3e631b55c$exports = new URL((parcelRequire("6Dqfy")).resolve("iYl4f"), import.meta.url).toString();


class $04eb6b18f1d57394$var$FooterComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .footer {
            width: 100vw;
            height: 25vh;
            min-height: 210px;
            padding-bottom: 25px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-image: url(${$42dad3286475bcc1$exports});
            background-color: var(--black-color);
            background-position: 0 35%;
            background-size: 75px;
            background-repeat: no-repeat;
        }

        @media (min-width: 600px) {
            .footer {
                background-size: 80px;
            }
        }

        @media (min-width: 768px) {
            .footer {
                width: 100vw;
                height: 30vh;
                padding: 50px 0;
                background-size: 15%;
                background-position: left center;
                background-color: var(--dark-gray-color);
            }
        }

        @media (min-width: 960px) {
            .footer {
                width: 99.7vw;
                height: 100%;
                max-height: 310px;
                padding: 50px 0;
                background-size: 10%;
            }
        }

        @media (min-width: 1440px) {
            .footer {
                justify-content: flex-end;
                padding: 100px 0;
                background-size: 12%;
            }
        }

        @media (min-width: 1850px) {
            .footer {
                background-size: 10%;
            }
        }

        .footer__content {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        @media (min-width: 768px) {
            .footer__content {
                max-width: none;
                justify-content: space-between;
                align-items: center;
            }
        }

        .content__left-side {
            width: 40%;
            height: 80%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            gap: 15px;
        }

        @media (min-width: 768px) {
            .content__left-side {
                height: 100%;
                justify-content: center;
            }
        }

        @media (min-width: 960px) {
            .content__left-side {
                width: 45%;
            }
        }


        .left-side__logo {
            width: 100px;
            height: auto;
        }

        @media (min-width: 550px) {
            .left-side__logo {
                width: 150px;
            }
        }

        @media (min-width: 768px) {            
            .left-side__logo {
                padding-left: 50px;
                width: 205px;
            }
        }

        @media (min-width: 960px) {            
            .left-side__logo {
                padding-left: 50px;
                width: 220px;
            }
        }

        @media (min-width: 1280px) {
            .left-side__logo {
                width: 300px;
            }
        }

        @media (min-width: 1440px) {
            .left-side__logo {
                width: 325px;
            }
        }

        @media (min-width: 1850px) {            
            .left-side__logo {
                width: 400px;
            }
        }

        .content__right-side {
            width: 40%;
            height: 80%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
        }

        @media (min-width: 768px) {
            .content__right-side {
                width: 20%;
                height: 100%;
            }
        }

        @media (min-width: 960px) {
            .content__right-side {
                width: 24%;
            }
        }

        @media (min-width: 1280px) {
            .content__right-side {
                width: 22%;
            }
        }

        .content__nav-links {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }

        .nav-links__title {
            width: 65%;
            font: 400 14px var(--roboto-font);
            color: var(--white-color);
            text-align: left;
        }

        @media (min-width: 768px) {
            .nav-links__title {
                width: 100%;
                font-family: var(--jakarta-font);
                font-size: 16px;
                text-decoration: none;
            }
        }

        @media (min-width: 960px) {
            .nav-links__title {
                font-size: 19px;
                margin-bottom: 10px;
            }
        }

        @media (min-width: 1440px) {
            .nav-links__title {
                margin-bottom: 20px;
                font-size: 24px;
            }
        }

        .nav-links__title.bold {
            font-weight: 700;
            font-size: 18px;
        }

        @media (min-width: 768px) {
            .nav-links__title.bold {
                font-size: 20px;
            }
        }

        @media (min-width: 960px) {
            .nav-links__title.bold {
                margin-top: 0;
                font-size: 24px;
            }
        }


        @media (min-width: 1280px) {
            .nav-links__title.bold {
                font-size: 28px;
            }
        }

        @media (min-width: 1440px) {
            .nav-links__title.bold {
                font-size: 32px;
            }
        }

        .content__social-media {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
        }

        @media (min-width: 768px) {
            .content__social-media {
                width: 150px;
                justify-content: flex-start;
            }    
        }

        @media (min-width: 960px) {
            .content__social-media {
                width: 170px;
                justify-content: flex-start;
            }    
        }

        @media (min-width: 1280px) {
            .content__social-media {
                width: 250px;
            }    
        }

        @media (min-width: 1440px) {
            .content__social-media {
                width: 270px;
            }    
        }

        @media (min-width: 1850px) {
            .content__social-media {
                width: 350px;
            }    
        }

        .content__social-media-logo {
            width: 25px;
        }

        @media (min-width: 960px) {
            .content__social-media-logo {
                width: 30px;
            }
        }

        @media (min-width: 1280px) {
            .content__social-media-logo {
                width: 40px;
            }
        }
        
        @media (min-width: 1440px) {
            .content__social-media-logo {
                width: 45px;
            }
        }

        @media (min-width: 1850px) {
            .content__social-media-logo {
                width: 54px;
            }
        }

        .social-media__link {
            text-decoration: none;
        }

        .content__details {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
        }

        .details__first-section {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 15px;
        }

        .footer__details {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
        }

        @media (min-width: 768px) {
            .footer__details {
                width: 22%;
                height: 100%;
                padding-right: 50px;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: flex-start;
            }
        }

        @media (min-width: 960px) {
            .footer__details {
                width: 30%;
                padding: 0;
            }
        }

        @media (min-width: 1280px) {
            .footer__details {
                width: 20%;
            }
        }

        @media (min-width: 1280px) {
            .footer__details {
                width: 24%;
            }
        }

        @media (min-width: 1440px) {
            .footer__details {
                width: 24%;
            }
        }

        .desktop {
            display: none;
        }

        @media (min-width: 768px) {            
            .mobile {
                display: none;
            }

            .desktop {
                display: inherit;
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    //! footer__details (Mobile y Desktop) tiene display: none; (estilos inline)
    render() {
        this.shadow.innerHTML = `
        <footer class="footer">
            <div class="footer__content">
				<div class="content__left-side">
                    <img class="left-side__logo" src="${$125e1db133398f72$exports}">
                    <div class="content__social-media">
                        <a class="social-media__link" href="https://instagram.com/grupoindalooficial?igshid=YmMyMTA2M2Y=" target="_blank">
                            <img class="content__social-media-logo" src="${$5f5de6ecc8a73be6$exports}" alt="Instagram">
                        </a>
                        <a class="social-media__link" href="https://www.linkedin.com/company/grupo-indalo/posts/?
                        feedView=all&viewAsMember=true" target="_blank">
                            <img class="content__social-media-logo" src="${$492809a4e9407687$exports}" alt="LinkedIn">
                        </a>
                        <a class="social-media__link" href="https://twitter.com/indaloprensa?s=11&t=NnNu0h-1-eNnbilJH-dz6w" target="_blank">
                            <img class="content__social-media-logo" src="${$a54685e3e631b55c$exports}" alt="Twitter">
                        </a>
                    </div>
				</div>
                <div class="content__right-side">
                    <h3 class="nav-links__title bold">Menu</h3>
                    <div class="content__nav-links">
                        <a href="#hero" class="nav-links__title">Inicio</a>
                        <a href="#about-us" class="nav-links__title">Quiénes somos</a>
                        <a href="#companies" class="nav-links__title">Nuestro grupo</a>
                        <a href="#rse" class="nav-links__title">Sustentabilidad</a>
                    </div>
                </div>
                <div style="display: none" class="footer__details desktop">
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                        Política de Privacidad
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                        Condiciones de uso
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                        Privacidad y cookies
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                        Declaración de Accesibilidad
                    </text-comp>
                </div>
			</div>
			<div style="display: none" class="footer__details mobile">
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
					Política de Privacidad
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
					Condiciones de uso
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
					Privacidad y cookies
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
					Declaración de Accesibilidad
				</text-comp>
			</div>
        </footer>
        `;
    }
    addListeners() {}
}
customElements.define("footer-comp", $04eb6b18f1d57394$var$FooterComponent);





class $8c375ddfb805d3ca$var$CompanyHeaderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
			.header {
					z-index: 200;
					position: fixed;
					left: 0;
					right: 0;
					width: calc(100% - 50px);
					padding: 0 25px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background-color: var(--menu-bkgd-color);
					border-bottom: 1px solid #fff;
				transition: all .4s linear;
			}
        
			.header__right {
				display: none
			}
        
			@media (min-width: 768px) {
					.header {
						width: calc(100% - 100px);
						padding: 0 50px;
					}
			}
			@media (max-width: 767px) {
				.header {
					gap: 12px;
					justify-content: flex-start;
				}
				.header__right {
					display: flex;
					width: 100%;
					justify-content: space-between;
				}
			}

			@media (min-width: 1280px) {
				.header {
					height: 90px;
				}
			}

			@media (min-width: 1440px) {
				.header {
					width: calc(100% - 200px);
					padding: 0 100px;
				}
      }

			.header__companies {
				margin: 0 auto;
				font: 700 18px var(--jakarta-font);
				text-decoration: none;
				color: var(--white-color);
			}

			.header__companies:hover {
				cursor: pointer;
			}

			.companies__list {
				display: none;
				transition: all .4s linear;
			}

			.companies__list.active {
				position: absolute;
				width: 150px;
				height: 200px;
				padding: 20px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: flex-start;
				background-color: var(--menu-bkgd-color);
							backdrop-filter: blur(10px);
				-webkit-backdrop-filter: blur(10px);
				border: 1px solid #fff;
				transition: all .4s linear;
			}

			@media (min-width: 768px) {
				.companies__list.active {
					top: 60px;
					right: 280px;
				}
			}

			@media (min-width: 1280px) {
				.companies__list.active {
					top: 90px;
				}
			}


			@media (min-width: 1440px) {
				.companies__list.active {
					top: 90px;
					right: 330px;
				}
			}

			.indalo-logo__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 100%;
			}

			.indalo-logo {
							padding: 15px 0;
							padding-right: 25px;
				height: 20px;
			}

			@media (min-width: 768px) {
				.indalo-logo {
					padding-right: 50px;
					height: 30px;
				}
			}

			@media (min-width: 1440px) {
				.indalo-logo {
					padding-right: 100px;
					height: 30px;
				}
			}

			@media (min-width: 1850px) {
				.indalo-logo {
					height: 40px;
				}
			}

			.header .indalo-logo__wrapper {
					border-right: 1px solid #fff;
			}

			.indalo-logo:hover {
				cursor: pointer;
			}
			
			.header-nav {
				display: none;
			}

			@media (min-width: 769px) {
				.header-nav {
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 34px;
				}	
			}

			.burger-menu:hover {
				cursor: pointer;
			}

			.cross-menu {
				display: none;
			}

			.cross-menu:hover {
				cursor: pointer;
			}

			@media (min-width: 769px) {
				.menu,
				.burger-menu,
				.cross-menu,
				.translate--mobile  {
					display: none;
				}
			}
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                <header class="header">
                    <a class="indalo-logo__wrapper" href="/#hero"><img class="indalo-logo" src="${$fca64589137b1371$exports}"></a>
                    <div class="header__right">
											<translate-comp class="translate--mobile"></translate-comp>
											<img class="burger-menu" src="${$b053139d7337e77f$exports}">
											<img class="cross-menu" src="${$138cbacc045963da$exports}">
										</div>
					<div class="header-nav">
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/#hero">Inicio</link-comp>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/#about-us">Quiénes Somos</link-comp>
						<a class="header__companies" scheme="light" href="/#companies">Empresas</a>
						<div class="companies__list">
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/indalo-media">Indalo Media</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/oil-m&s">Oil M&S</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/cpc">CPC</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/providencia">Providencia</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/alpat">Alpat</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/serma">Serma</link-comp>
						</div>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/#sust">Sustentabilidad</link-comp>
						<translate-comp></translate-comp>
					</div>
                </header>
                <menu-comp class="menu"></menu-comp>
        `;
    }
    elementsOverlap(el1, el2) {
        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();
        const overlaps = !(domRect1.top > domRect2.bottom || domRect1.bottom < domRect2.top);
        return overlaps;
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const burgerMenu = this.shadow.querySelector(".burger-menu");
        const crossMenu = this.shadow.querySelector(".cross-menu");
        const headerEl = this.shadow.querySelector(".header");
        const menuComponentEl = this.shadow.querySelector(".menu");
        const shadowMenuEl = menuComponentEl.shadowRoot.querySelector(".menu-container");
        const headerNavLinksEl = this.shadow.querySelectorAll(".header-nav__link");
        const headerCompaniesEl = this.shadow.querySelector(".header__companies");
        const companiesListEl = this.shadow.querySelector(".companies__list");
        const shadowMenuLinksEl = menuComponentEl.shadowRoot.querySelectorAll(".nav-link");
        const lightSectionStarting = document.querySelector(".about-us");
        const darkSectionStarting = document.querySelector(".btn");
        burgerMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "hidden";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "none";
            crossMenu.style.display = "inherit";
        });
        crossMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "auto";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "inherit";
            crossMenu.style.display = "none";
        });
        headerEl.addEventListener("mouseleave", ()=>{
            companiesListEl.classList.remove("active");
        });
        headerNavLinksEl.forEach((link)=>{
            link.addEventListener("mouseover", ()=>{
                companiesListEl.classList.remove("active");
            });
        });
        headerCompaniesEl.addEventListener("mouseover", ()=>{
            companiesListEl.classList.toggle("active");
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        const companyLandingWindowEvent = ()=>{
            const headerOverlapsLightContent = this.elementsOverlap(headerEl, lightSectionStarting);
            const headerOverlapsDarkContent = this.elementsOverlap(headerEl, darkSectionStarting);
            if (headerOverlapsLightContent) {
                headerEl.style.backdropFilter = "blur(0)";
                headerEl.style.backgroundColor = "#111";
                companiesListEl.style.backdropFilter = "blur(0)";
                companiesListEl.style.backgroundColor = "#111";
            } else if (headerOverlapsDarkContent) {
                headerEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backdropFilter = "blur(10px)";
            }
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop < window.innerHeight) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
        };
        window.addEventListener("scroll", companyLandingWindowEvent);
    }
}
customElements.define("company-header-comp", $8c375ddfb805d3ca$var$CompanyHeaderComponent);






class $9efdb79d5acf6b92$var$menuComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .menu-container {
            width: calc(100% - 2px);
            height: 90vh;
            display: none;
            background-color: var(--menu-bkgd-color);
            backdrop-filter: blur(32px);
            -webkit-backdrop-filter: blur(32px);
            border: 1px solid var(--white-color);
        }
        
        .menu-container.active {
            z-index: 199;
            left: 0;
            right: 0;
            position: fixed;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            animation: forwardExpand 400ms ease forwards;
        }

        .menu__nav-links {
            width: 100%;
            height: 70%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding-top: 10vh;
            gap: 0px;
        }

        @media (min-width: 769px) {
            .menu__nav-links {
                height: 50vh;
                padding-top: 0;
                justify-content: space-evenly;
            }
        }

        .nav-link {
            padding: 25px;
            border-bottom: 1px solid var(--white-color);
        }

        .nav-link.companies-list {
            padding-bottom: 15px;
        }

        .menu__social-media {
            width: 50%;
            padding-top: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 25px;
        }

        @media (min-height: 840px) {
            .menu__social-media {
                padding-top: 60px;
            }
        }

        @media (min-width: 1280px) {
            .menu__social-media {
                width: 200px;
                justify-content: flex-start;
            }
        }

        .menu__social-media-logo {
            width: 50px;
        }

        .social-media__link {
            text-decoration: none;
        }

        @keyframes forwardExpand {
            0% {
                opacity: 0;
                transform: translateY(-100%);
            }
        
            100% {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @keyframes backwardExpand {
            0% {
                opacity: 0;
                transform: translateY(0);
            }
        
            100% {
                opacity: 1;
                transform: translateY(-100%);
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
            <div class="menu-container">
                <div class="menu__nav-links">
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/#hero">Inicio</link-comp>
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/#about-us">Quiénes somos</link-comp>
                    <accordion-item class="nav-link companies-list">Empresas</accordion-item>
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/#sust">Sustentabilidad</link-comp>
                </div>
                <div class="menu__social-media">
                    <a class="social-media__link" href="" target="_blank">
                        <img class="menu__social-media-logo" src="${$492809a4e9407687$exports}" alt="LinkedIn">
                    </a>
                    <a class="social-media__link" href="" target="_blank">
                    <img class="menu__social-media-logo" src="${$a54685e3e631b55c$exports}" alt="Twitter">
                    </a>
                    <a class="social-media__link" href="https://www.instagram.com/molde__arq/" target="_blank">
                    <img class="menu__social-media-logo" src="${$5f5de6ecc8a73be6$exports}" alt="Instagram">
                    </a>
                </div>
            </div>
        `;
    }
    addListeners() {
        const burgerMenuEl = this.shadow.querySelector(".menu-container");
        const scrollCheckEvent = ()=>{
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop > window.innerHeight * 2.7 && location.pathname === "/") burgerMenuEl.style.backgroundColor = "var(--primary-color)";
            else if (scrollTop > window.innerHeight * 0.7) burgerMenuEl.style.backgroundColor = "var(--primary-color)";
            else burgerMenuEl.style.backgroundColor = "var(--menu-bkgd-color)";
        };
        window.addEventListener("scroll", scrollCheckEvent);
    }
}
customElements.define("menu-comp", $9efdb79d5acf6b92$var$menuComponent);


var $2a03b197c7bfe3c5$exports = {};

$2a03b197c7bfe3c5$exports = new URL((parcelRequire("6Dqfy")).resolve("e5nTm"), import.meta.url).toString();


var $685962251ed1dff4$exports = {};

$685962251ed1dff4$exports = new URL((parcelRequire("6Dqfy")).resolve("7yCGn"), import.meta.url).toString();



var $0639761b32001ba7$exports = {};

$0639761b32001ba7$exports = new URL((parcelRequire("6Dqfy")).resolve("4pa1r"), import.meta.url).toString();


var $a77e43b5ed177443$exports = {};

$a77e43b5ed177443$exports = new URL((parcelRequire("6Dqfy")).resolve("cOEXD"), import.meta.url).toString();



var $1c813357f4895e23$exports = {};

$1c813357f4895e23$exports = new URL((parcelRequire("6Dqfy")).resolve("4oQWv"), import.meta.url).toString();


class $b4feaded8d1e273b$var$HeroSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = `
        
        .carousel-container {
            width: 100vw;
            height: 90vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 45px;
        } 

        @media (min-width: 1850px) {
            .carousel-container {
                width: 100vw;
                height: 90vh;
                max-width: none;
                max-height: none;
            }
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        .sliders-container {
            width: 500%;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all .7s ease;
        }
        
        .sliders__item {
            width: 100vw;
            height: 100%;
        }
        
        .sliders__item.first-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$ea54a7185f45d98b$exports});
        }

        .sliders__item.second-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$0639761b32001ba7$exports});
        }

        .sliders__item.third-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$a77e43b5ed177443$exports});
        }

        .sliders__item.fourth-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$e44a9ca88677ea64$exports});
        }

        .sliders__item.fifth-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom right;
            background-image: url(${$1c813357f4895e23$exports});
        }

        .item__content {
            position: absolute;
            left: 10%;
            top: 40%;
            max-width: 80%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            z-index: 100;
        }

        @media (min-width: 768px) {
            .item__content {
                max-width: 70%;
            }
        }

        @media (min-width: 1850px) {
            .item__content {
                max-width: 50%;
            }
        }

        .item__title {
            width: 100%;
        }

        .item__text {
            margin-top: 10px;
        }

        @media (min-width: 768px) {
            .item__text {
                margin-top: 20px;
            }
        }

        @media (min-width: 1440px) {
            .item__text {
                margin-top: 30px;
            }
        }

        @media (min-width: 1850px) {
            .item__text {
                margin-top: 35px;
            }
        }

        .item__controls {
            width: 100%;
            margin-top: 15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 20px;
        }

        .left-arrow, 
        .right-arrow {
            width: 43px;    
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }
        
        @media (min-width: 1280px) {
            .left-arrow, 
            .right-arrow {
                width: 45px;
            }    
        }

        @media (min-width: 1850px) {
            .left-arrow, 
            .right-arrow {
                width: 48px;    
            }    
        }

        `;
        this.render();
        this.shadow.appendChild(style);
    }
    addListeners() {
        const carouselEl = this.shadow.querySelector(".carousel");
        const SlContainerEl = this.shadow.querySelector(".sliders-container");
        const slidersItemsEl = this.shadow.querySelectorAll(".sliders__item");
        const leftArrowEl = this.shadow.querySelector(".left-arrow");
        const rightArrowEl = this.shadow.querySelector(".right-arrow");
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID, currentIndex = 0;
        slidersItemsEl.forEach((slide, index)=>{
            slide.addEventListener("touchstart", touchStart(index));
            slide.addEventListener("touchend", touchEnd);
            slide.addEventListener("touchmove", touchMove);
        });
        function getPositionX(event) {
            return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        }
        function touchStart(index) {
            return function(event) {
                currentIndex = index;
                startPos = getPositionX(event);
                isDragging = true;
                animationID = requestAnimationFrame(animation);
            };
        }
        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }
        function touchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            if (movedBy > 100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (movedBy > 100 && offset == "4") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (movedBy > 100 && offset == "3") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy > 100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy > 100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
            if (movedBy < -100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy < -100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy < -100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (movedBy < -100 && offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (movedBy < -100 && offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        }
        function animation() {
            if (isDragging) requestAnimationFrame(animation);
        }
        leftArrowEl.addEventListener("click", (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (position == "previous" && offset == "0") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (position == "previous" && offset == "4") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (position == "previous" && offset == "3") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (position == "previous" && offset == "2") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (position == "previous" && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        });
        rightArrowEl.addEventListener("click", (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (position == "next" && offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (position == "next" && offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (position == "next" && offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (position == "next" && offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (position == "next" && offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        });
        setInterval(()=>{
            const offset = SlContainerEl.getAttribute("offset");
            if (offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        }, 5000);
    }
    render() {
        this.shadow.innerHTML = `
        <div class="carousel-container">
            <div class="item__content">
                <title-comp class="item__title" variant="hero left-sided no-margin jakarta bold" scheme="light">SOMOS</title-comp>
                <title-comp class="item__title" variant="hero left-sided no-margin jakarta bold" scheme="light">GRUPO INDALO</title-comp>
                <text-comp class="item__text" variant="slider no-margin left-sided" scheme="f-light">
                    ${this.textContent}
                </text-comp>
                <div class="item__controls">
                    <img class="left-arrow" src="${$2a03b197c7bfe3c5$exports}" position="previous">
                    <img class="right-arrow" src="${$685962251ed1dff4$exports}" position="next">
                </div>
            </div>
            <div class="carousel">
                <div class="sliders-container" offset="0">
                    <div class="first-item sliders__item" offset="0">
                    </div>
                    <div class="second-item sliders__item" offset="1">
                    </div>
                    <div class="third-item sliders__item" offset="2">
                    </div>
                    <div class="fourth-item sliders__item" offset="3">
                    </div>
                    <div class="fifth-item sliders__item" offset="4">
                    </div>
                </div>
            </div>
        </div>
        `;
        this.addListeners();
    }
}
customElements.define("hero-slider", $b4feaded8d1e273b$var$HeroSliderComponent);


class $a042d422138cfcb4$var$TitleComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .jakarta {
             font-family: var(--jakarta-font);
             line-height: 0.8;
        }

        .thick-line { 
            line-height: 1.2;
        }
        
        .regular {
            font-weight: 400;
        }

        .medium {
            font-weight: 500;
        }

        .semi-bold {
            font-weight: 600;
        }

        .bold {
            font-weight: 700;
        }

        .extra-bold {
            font-weight: 800;
        }

        .montserrat {
            font-family: var(--montserrat-font);
        }

        .hero {
            width: 100%;
            font-size: 33px;
        }

        @media (min-width: 500px) {
            .hero {
                font-size: 37px;
            }
        }

        @media (min-width: 768px) {
            .hero {
                font-size: 48px;
            }
        }

        @media (min-width: 960px) {
            .hero {
                font-size: 55px;
            }
        }

        @media (min-width: 1280px) {
            .hero {
                font-size: 67px;
            }
        }

        @media (min-width: 1440px) {
            .hero {
                font-size: 70px;
            }
        }

        @media (min-width: 1850px) {
            .hero {
                font-size: 80px;
            }
        }

        .hero.company-name {
            font-size: 37px;
            margin: 0;
        }

        @media (min-width: 768px) {
            .hero.company-name {
                font-size: 47px;
            }
        }

        @media (min-width: 960px) {
            .hero.company-name {
                font-size: 55px;
            }
        }

        @media (min-width: 1280px) {
            .hero.company-name {
                font-size: 65px;
            }
        }

        @media (min-width: 1440px) {
            .hero.company-name {
                font-size: 75px;
            }
        }

        @media (min-width: 1850px) {
            .hero.company-name {
                font-size: 95px;
            }
        }

        .hero.company-slogan {
            margin: 0;
        }

        @media (min-width: 768px) {
            .hero.company-slogan {
                width: 80%;
                font-size: 37px;
            }
        }

        @media (min-width: 960px) {
            .hero.company-slogan {
                width: 70%;
                font-size: 45px;
            }
        }

        @media (min-width: 1280px) {
            .hero.company-slogan {
                width: 67%;
                font-size: 49px;
            }
        }


        @media (min-width: 1440px) {
            .hero.company-slogan {
                font-size: 51px;
            }
        }

        @media (min-width: 1850px) {
            .hero.company-slogan {
                font-size: 67px;
            }
        }

        .hero.company-slogan.minimized {
            font-size: 30px;
            margin: 0;
        }

        @media (min-width: 768px) {
            .hero.company-slogan.minimized {
                width: 80%;
                font-size: 33px;
            }
        }

        @media (min-width: 960px) {
            .hero.company-slogan.minimized {
                width: 70%;
                font-size: 37px;
            }
        }

        @media (min-width: 1280px) {
            .hero.company-slogan.minimized {
                width: 67%;
                font-size: 46px;
            }
        }

        @media (min-width: 1440px) {
            .hero.company-slogan.minimized {
                font-size: 50px;
            }
        }

        @media (min-width: 1850px) {
            .hero.company-slogan.minimized {
                font-size: 63px;
            }
        }

        .section {
            width: calc(100% - 70px);
            padding: 40px 35px;
            margin: 0;
            font-size: 27px;
            text-align: left;
        }

        @media (min-width: 390px) {
            .section {
                font-size: 30px;
            }
        }

        @media (min-width: 768px) {
            .section {
                width: calc(100% - 100px);
                padding: 15px 50px;
                font-size: 20px;
            }
        }

        @media (min-width: 1440px) {
            .section {
                width: calc(100% - 70px);
                padding: 15px 35px;
            }
        }

        .section.medium {
            font-size: 28px;
            line-height: 45px;
        }

        @media (min-width: 768px) {
            .section.medium {
                font-size: 30px;
            }
        }
        
        @media (min-width: 1280px) {
            .section.medium {
                font-size: 33px;
            }
        }

        @media (min-width: 1440px) {
            .section.medium {
                font-size: 36px;
            }
        }

        @media (min-width: 1850px) {
            .section.medium {
                font-size: 47px;
            }
        }

        .section.margin-top {
            margin-top: 45px;
        }

        .card {
            font: 500 29px var(--aeonik-font);
            margin: 0;
            padding: 10px 0;
        }

        @media (min-width: 1440px) {
            .card {
                font-size: 43px;
            }
        }

        .dark {
            color: var(--black-color);
        }

        .light {
            color: var(--white-color);
        }

        .hundred-percent-width {
            width: 100%;
        }

        .left-sided {
            text-align: left;
        }

        .middle-sided {
            text-align: center;
        }

        .right-sided {
            text-align: right;
        }

        .no-x-padding {
            width: 100%;
            padding: 20px 0;
        }

        @media (min-width: 768px) {
            .no-x-padding {
                padding: 10px 0;
            }
        }

        .no-margin {
            margin: 0;
        }

        .no-border {
            border: none;
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <h3 class="title
            ${this.getAttribute("variant")}
            ${this.getAttribute("scheme")}
            ">
            ${this.textContent}
            </h3>
        `;
    }
}
customElements.define("title-comp", $a042d422138cfcb4$var$TitleComponent);


class $b0e8e137c56f6599$var$SubtitleComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .jakarta.semibold {
            font: 600 16px var(--jakarta-font);
        }

        .jakarta.bold {
            font: 700 19px var(--jakarta-font);
        }

        .montserrat.bold {
            font: 700 16px var(--montserrat-font);
        }

        .montserrat.medium {
            font: 500 16px var(--montserrat-font);
            margin: 0;
        }

        @media (min-width: 1440px) {
            .montserrat.medium {
                font-size: 20px;
            }
        }

        @media (min-width: 1850px) {
            .montserrat.medium {
                font-size: 24px;
            }
        }
        
        .section {
            width: calc(100vw - 120px);
            margin: 0;
            text-align: left;
        }

        @media (min-width: 960px) {
            .section {
                font-size: 50px;
            }
        }

        @media (min-width: 1280px) {
            .section {
                font-size: 75px;
            }
        }

        @media (min-width: 1440px) {
            .section {
                font-size: 80px;
            }
        }

        @media (min-width: 1920px) {
            .section {
                font-size: 120px;
            }
        }
        
        .card {
            font: 400 16px var(--aeonik-font);
        }

        .dark {
            color: var(--black-color);
        }

        .light {
            color: var(--white-color);
        }

        .left-sided {
            text-align: left;
        }

        .middle-sided {
            text-align: center;
        }

        .right-sided {
            text-align: right;
        }

        .yellow { 
            color: var(--yellow-color);
        }

        .red { 
            color: var(--red-color);
            padding: 0px 35px;
        }

        .blue { 
            color: var(--blue-color);
            padding: 0px 35px;
        }

        .green { 
            color: var(--green-color);
            padding: 0px 35px;
        }

        .hide-mobile {
            display: none;
        }

        @media (min-width: 768px) {      
            .hide-mobile {
                display: inherit;
            }
            
            .hide-desktop {
                display: none;
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <h4 class="
            ${this.getAttribute("variant")}
            ${this.getAttribute("scheme")}
            ">
            ${this.hasAttribute("contains-html") ? this.innerHTML : this.textContent}
            </h4>
        `;
    }
}
customElements.define("subtitle-comp", $b0e8e137c56f6599$var$SubtitleComponent);


class $f3f77fcf5ed5b645$var$TextComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
        
        .section {
            line-height: 22px;
            margin-top: 15px;
            width: calc(100vw - 120px);
            font: 400 13px var(--montserrat-font);
        }

        @media (min-width: 960px) {
            .section {
                font-size: 36px;
            }
        }

        @media (min-width: 1440px) {
            .section {
                font-size: 75px;
            }
        }

        .hero {
            font: 400 19px var(--jakarta-font);
        }

        .hero img {
            vertical-align: middle;
        }

        @media (min-width: 630px) {            
            .about {
                margin: 10px;
                line-height: 20px;
                font: 400 15px var(--jakarta-font);
            }
        }

        @media (min-width: 960px) {            
            .about {
                font-size: 17px;
            }
        }

        @media (min-width: 960px) and (max-height: 720px) {            
            .about {
                font-size: 17px;
            }
        }

        @media (min-width: 1280px) {            
            .about {
                font-size: 20px;
            }
        }

        @media (min-width: 1440px) {            
            .about { 
                font-size: 23px;
            }
        }

        @media (min-width: 1850px) {            
            .about {
                font-size: 30px;
                line-height: 45px;
            }
        }

        @media (min-width: 630px) {
            .about.company-hero {
                line-height: 20px;
            }
        }

        @media (min-width: 768px) {
            .about.company-hero {
                line-height: 24px;
            }
        }

        @media (min-width: 960px) {
            .about.company-hero {
                width: 100%;
                line-height: 33px;
            }
        }

        @media (min-width: 960px) and (max-height: 720px) {
            .about.company-hero {
                line-height: 25px;
            }
        }

        @media (min-width: 1280px) {
            .about.company-hero {
                font-size: 20px;
                line-height: 33px;
            }
        }

        @media (min-width: 1440px) {
            .about.company-hero {
                font-size: 23px;
                line-height: 37px;
            }
        }

        @media (min-width: 1850px) {
            .about.company-hero {
                font-size: 25px;
                line-height: 45px;
            
            }
        }

        .slider {
            font: 500 13px var(--montserrat-font);
        }

        @media (min-width: 500px) {
            .slider {
                font-size: 16px;
            }
        }

        @media (min-width: 960px) {
            .slider {
                font-size: 18px;
            }
        }

        @media (min-width: 1280px) {
            .slider {
                line-height: 30px;
                font-size: 20px;
            }
        }

        @media (min-width: 1440px) {
            .slider {
                font-size: 22px;
            }
        }

        @media (min-width: 1850px) {
            .slider {
                line-height: 38px;
                font-size: 24px;
            }
        }

        .card {
            font: 500 13px var(--jakarta-font);
        }

        @media (min-width: 1440px) {
            .card {
                font-size: 16px;
            }
        }

        @media (min-width: 1850px) {
            .card {
                font-size: 20px;
            }
        }

        .card.border {
            border-bottom: 1px solid var(--secondary-color);
        }

        .footer {
            font: 500 20px var(--aeonik-font);
        }

        @media (min-width: 768px) {
            .footer {
                font-family: var(--jakarta-font);
                font-size: 24px;
            }
        }

        @media (min-width: 960px) {
            .footer {
                font-size: 32px;
            }
        }

        @media (min-width: 1280px) {
            .footer {
                font-size: 40px;
            }
        }

        @media (min-width: 1440px) {
            .footer {
                font-size: 50px;
            }
        }

        @media (min-width: 1850px) {
            .footer {
                font-size: 64px;
            }
        }
        
        .footer-details {
            font: 400 8px var(--roboto-font);
        }

        @media (min-width: 768px) {
            .footer-details {
                margin: 20px 0;
                font-family: var(--jakarta-font);
                font-size: 12px;
                border-bottom: 1px solid var(--white-color);
            }
        }

        @media (min-width: 960px) {
            .footer-details {
                margin: 0;
                margin-bottom: 25px;
                font-size: 16px;
            }
        }

        @media (min-width: 1440px) {
            .footer-details {
                margin-bottom: 35px;
                font-size: 19px;
            }
        }

        .footer-details a {
            color: var(--secondary-color);
        }

        .footer-details.copyright {
            margin-bottom: -13px;
        }

        @media (min-width: 768px) {
            .footer-details.copyright {
                display: none;
            }
        }

        .dark {
            color: var(--primary-color);
        }

        .light {
            color: var(--text-color);
        }

        .f-light {
            color: var(--white-color);
        }

        .regular {
            font-weight: 400;
        }

        .no-margin {
            margin: 0;
        }

        .margin-top {
            margin-top: 10px;
        }

        @media (min-width: 1850px) {
            .margin-top {
                margin-top: 35px;
            }    
        }

        .left-sided {
            text-align: left;
        }

        .middle-sided {
            text-align: center;
        }

        .right-sided {
            text-align: right;
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <p class="
            ${this.getAttribute("variant")}
            ${this.getAttribute("scheme")}
            ">
            ${this.hasAttribute("contains-html") ? this.innerHTML : this.textContent}
            </p>
        `;
    }
}
customElements.define("text-comp", $f3f77fcf5ed5b645$var$TextComponent);




class $f4b792ecd70eb4c0$var$TextSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = `
        
        .carousel-container {
            width: calc(100% - 70px);
            height: 100%;
            margin: 10px auto;
            margin-bottom: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 15px;
        }

        .carousel-container.last-item {
            margin-bottom: 70px;
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        @media (min-width: 630px) {
            .carousel {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 65px 0;
                overflow: hidden;
            }
        }

        .sliders-container {
            width: 300%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            transition: all .7s ease;
            overflow: hidden;
            scroll-snap-type: x mandatory;
			scroll-behavior: smooth;
        }
        
        .sliders-container.dual-slider {
            width: 200%;
        }

        .sliders__item {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            vertical-align: top;
            scroll-snap-align: center;
        }
        
        .sliders__item.hidden {
            display: none;
        }
        
        .item:hover {
            cursor: grab;
        }

        .item__controlls {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 35px;
        }

        .left-arrow, 
        .right-arrow {
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    addListeners() {
        const carouselEl = this.shadow.querySelector(".carousel");
        const SlContainerEl = this.shadow.querySelector(".sliders-container");
        const slidersItemsEl = this.shadow.querySelectorAll(".sliders__item");
        const leftArrowEl = this.shadow.querySelector(".left-arrow");
        const rightArrowEl = this.shadow.querySelector(".right-arrow");
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID, currentIndex = 0;
        slidersItemsEl.forEach((slide, index)=>{
            slide.addEventListener("touchstart", touchStart(index));
            slide.addEventListener("mousedown", touchStart(index));
            if (SlContainerEl.classList.contains("dual-slider")) {
                slide.addEventListener("touchend", dualTouchEnd);
                slide.addEventListener("mouseup", dualTouchEnd);
            } else {
                slide.addEventListener("touchend", touchEnd);
                slide.addEventListener("mouseup", touchEnd);
            }
            slide.addEventListener("touchmove", touchMove);
            slide.addEventListener("mousemove", touchMove);
        });
        function getPositionX(event) {
            return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        }
        function touchStart(index) {
            return function(event) {
                currentIndex = index;
                startPos = getPositionX(event);
                isDragging = true;
                animationID = requestAnimationFrame(animation);
            };
        }
        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }
        function dualTouchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            // if moved enough negative then snap to next slide if there is one
            if (movedBy < -100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-50%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy < -100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
            // if moved enough positive then snap to previous slide if there is one
            if (movedBy > 100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-50%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy > 100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        }
        function touchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            // if moved enough negative then snap to next slide if there is one
            if (movedBy < -100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-33.3%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy < -100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(-66.6%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy < -100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
            // if moved enough positive then snap to previous slide if there is one
            if (movedBy > 100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-66.6%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy > 100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(-0%)";
                SlContainerEl.setAttribute("offset", "0");
            } else if (movedBy > 100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(-33.3%)";
                SlContainerEl.setAttribute("offset", "1");
            }
        }
        function animation() {
            if (isDragging) requestAnimationFrame(animation);
        }
        if (SlContainerEl.classList.contains("dual-slider")) {
            leftArrowEl.addEventListener("click", (e)=>{
                const target = e.target;
                const position = target.getAttribute("position");
                const offset = SlContainerEl.getAttribute("offset");
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-50%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            });
            rightArrowEl.addEventListener("click", (e)=>{
                const target = e.target;
                const position = target.getAttribute("position");
                const offset = SlContainerEl.getAttribute("offset");
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-50%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            });
        } else {
            leftArrowEl.addEventListener("click", (e)=>{
                const target = e.target;
                const position = target.getAttribute("position");
                const offset = SlContainerEl.getAttribute("offset");
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-66.6%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-33.3%)";
                    SlContainerEl.setAttribute("offset", "1");
                }
            });
            rightArrowEl.addEventListener("click", (e)=>{
                const target = e.target;
                const position = target.getAttribute("position");
                const offset = SlContainerEl.getAttribute("offset");
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-33.3%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(-66.6%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            });
        }
    }
    render() {
        this.shadow.innerHTML = `
        <div class="carousel-container ${this.getAttribute("variant")}">
            <div class="carousel">
                <div class="sliders-container ${this.hasAttribute("dualSlider") ? "dual-slider" : ""}" offset="0">
                    <div class="sliders__item">
                        <text-comp class="item" variant="slider no-margin left-sided" scheme="light" contains-html>
                        ${this.hasAttribute("first-title") ? `
                                <b class="regular f-light">
                                    ${this.getAttribute("first-title")}
                                </b>
                                <br>
                                ` : ""}
                        ${this.getAttribute("first-paragraph")} 
                        </text-comp>
                    </div>
                    <div class="sliders__item">
                        <text-comp class="item" variant="slider no-margin left-sided" scheme="light" contains-html>
                        ${this.hasAttribute("second-title") ? `
                                <b class="regular f-light">
                                    ${this.getAttribute("second-title")}
                                </b>
                                <br>
                                ` : ""}
                        ${this.getAttribute("second-paragraph")} 
                        </text-comp>
                    </div>
                    <div class="sliders__item ${this.hasAttribute("dualSlider") ? "hidden" : ""}">
                        <text-comp class="item" variant="slider no-margin left-sided" scheme="light" contains-html>
                        ${this.hasAttribute("third-title") ? `
                                <b class="regular f-light">
                                    ${this.getAttribute("third-title")}
                                </b>
                                <br>
                                ` : ""}
                        ${this.getAttribute("third-paragraph")}
                        </text-comp>
                    </div>
                </div>
            </div>
            <div class="item__controlls">
            <img class="left-arrow" src="${$2a03b197c7bfe3c5$exports}" position="previous">
            <img class="right-arrow" src="${$685962251ed1dff4$exports}" position="next">
            </div>
        </div>
        `;
        this.addListeners();
    }
}
customElements.define("text-slider", $f4b792ecd70eb4c0$var$TextSliderComponent);


class $d15847cf8f772c09$var$LinkComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .header {
            font: 700 18px var(--jakarta-font);
            text-decoration: none;
        }

        .menu {
            font: 700 26px var(--jakarta-font);
            padding: 25px;
            line-height: 39px;
            text-decoration: none;
        }

        .submenu {
            padding: 0;
            font: 500 26px var(--jakarta-font);
        }

        @media (min-width: 769px) {
            .menu {
                font-size: 15px;
            }
        }

        @media (min-width: 1280px) {
            .menu {
                font-size: 18px;
            }
        }

        .card {
            font: 700 14px var(--aeonik-font);
        }

        .dark {
            color: var(--black-color);
        }

        .light {
            color: var(--white-color);
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <a class="
            ${this.getAttribute("variant")}
            ${this.getAttribute("scheme")}
            " href="${this.getAttribute("href")}">
            ${this.textContent}
            </a>
        `;
    }
}
customElements.define("link-comp", $d15847cf8f772c09$var$LinkComponent);


class $993e5933d4133cb4$var$AccordionComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
		.accordion-item {
			width: 100%;
			height: 100%;
			margin: 0 auto;
			text-align: left;
		}

		.accordion-item:hover {
			cursor: pointer;
		}

		.accordion-item__wrapper {
			padding-bottom: 15px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
		}

		@media (min-width: 768px) {
			.accordion-item__wrapper {
				width: calc(100% - 100px);
				height: auto;
			}
		}

		.accordion-item__inverse-wrapper {
			flex-direction: row-reverse;	
		}

		.accordion-item__title {
            font: 700 26px var(--jakarta-font);
			color: var(--white-color);
			padding: 0 25px;
            text-decoration: none;
        }

		.accordion-item__toggle {
			font: 700 26px var(--jakarta-font);
			color: var(--white-color);
			margin: 0;
            text-decoration: none;
			transition: transform .4s ease;
		}

		.accordion-item__number {
			margin-left: 10px;
			font: 400 15px var(--aeonik-font);
		}

		.accordion-item__content {
			padding: 0 25px;
			display: none;
			overflow: auto;
		}
		
		.accordion-item__content.deactive {
			max-height: 0px;
		}

		.accordion-item__content.active {
			height: 100px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 15px;
		}

		@media (min-height: 840px) {
			.accordion-item__content.active {
				height: 200px;
			}
		}
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
        <div class="accordion-item">
			<div class="accordion-item__wrapper ${this.hasAttribute("inverse") ? "accordion-item__inverse-wrapper" : ""}">
				<div class="accordion-item__title">
            		${this.textContent}
				</div>
				<h3 class="accordion-item__toggle ${this.hasAttribute("active") ? "active" : ""}">${this.hasAttribute("active") ? "-" : "+"}</h3>
			</div>
			<div class="accordion-item__content deactive ${this.hasAttribute("active") ? "active" : ""}">
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/indalo-media">Indalo Media</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/oil-m&s">Oil M&S</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/cpc">CPC</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/providencia">Providencia</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/alpat">Alpat</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/company/serma">Serma</link-comp>
			</div>
        </div>
        `;
    }
    addListeners() {
        const accordionItemEl = this.shadow.querySelector(".accordion-item");
        const itemContentEl = this.shadow.querySelector(".accordion-item__content");
        const itemToggleEl = this.shadow.querySelector(".accordion-item__toggle");
        itemContentEl.addEventListener("animationend", ()=>{
            if (itemContentEl.classList.contains("deactive") && itemContentEl.classList.contains("active")) itemContentEl.classList.toggle("deactive");
        }, {
            once: true
        });
        accordionItemEl.addEventListener("click", ()=>{
            itemContentEl.classList.toggle("active");
            itemContentEl.classList.toggle("deactive");
            itemToggleEl.classList.toggle("active");
        });
    }
}
customElements.define("accordion-item", $993e5933d4133cb4$var$AccordionComponent);


class $7cccbcf59f240e42$var$AboutComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
            .about-container {
                height: 90vh;
                width: 100vw;
                display: flex;
                justify-content: space-between;
                align-items: center;

            }

            .about__side-bar {
                width: 40%;
                height: calc(100% - 25px);
                padding: 0 25px;
                padding-top: 25px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                border-right: 1px solid var(--white-color);
                border-top: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: calc(100% - 50px);
                    padding: 0 50px;
                    padding-top: 50px;
                }
            }

            @media (min-width: 960px) {
                .about__side-bar {
                    width: 38%;
                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 30%;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .about__side-bar {
                    height: calc(100% - 25px);
                    padding-top: 25px;
                }
            }


            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 42%;
                    height: calc(100% - 50px);
                    padding: 0 100px;
                    padding-top: 50px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    width: 39%;
                    height: calc(100% - 100px);
                    padding-top: 100px;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 19px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            .side-bar__title:hover {
                cursor: pointer;
            }

            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 24px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .side-bar__title {
                    font-size: 25px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 32px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            @media (min-width: 1850px) {
                .side-bar__content {
                    margin-top: 55px; 
                }
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .content__title {
                    font-size: 27px;
                }
            }


            @media (min-width: 1440px) {
                .content__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .content__text {
                    font-size: 14px;
                }
            }


            @media (min-width: 1440px) {
                .content__text {
                    font-size: 18px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 55%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 960px) {
                .about__content {
                    width: 60%;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
            <div class="about-container">
                <div class="about__side-bar">
                    <div class="side-bar__faq">
                        <h3 class="side-bar__title yellow active" item="first">¿Qué es el Grupo Indalo?</h3>
                        <h3 class="side-bar__title red" item="second">Misión</h3>
                        <h3 class="side-bar__title blue" item="third">Visión</h3>
                        <h3 class="side-bar__title green" item="fourth">Valores</h3>
                    </div>
                    <div class="side-bar__content">
                        <h3 class="content__title">
                            Nuestro futuro, 
                            <br>
                            mucho por hacer.
                        </h3>
                        <p class="content__text">
                            Fue creado en 1999 y desde entonces se convirtió en uno de los grupos más importantes de la Argentina con proyecciones de crecimiento en toda la región.
                        </p>
                    </div>
                </div>
                <div class="about__content">
                    <div class="content-item first active">
                        <text-comp variant="about" scheme="f-light">
                            El Grupo Indalo es un conglomerado de empresas que invierte en la Argentina desde hace más de veinte años y que apuesta por el desarrollo del país generando empleo para miles de trabajadores y trabajadoras a lo largo de todo el territorio nacional.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                            Está integrado por empresas de producción y servicios de diferentes rubros, principalmente en medios de comunicación, construcción, energía y minería.
                        </text-comp>
                    </div>
                    <div class="content-item second">
                        <text-comp variant="about" scheme="f-light">
                            Nuestra misión es contribuir al desarrollo económico y social de la Argentina a través de la inversión en empresas de diversos sectores, generando empleo y mejorando la calidad de vida de la población.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                            Buscamos ser líderes en cada una de nuestras áreas de negocio, brindando productos y servicios de alta calidad que satisfagan las necesidades de nuestros clientes y generen un impacto positivo en la sociedad.
                        </text-comp>
                    </div>
                    <div class="content-item third">
                        <text-comp variant="about" scheme="f-light">
                            Apuntamos a consolidar el liderazgo de nuestro grupo empresarial en el país y proyectarnos hacia la región en busca de nuevos mercados estratégicos.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                            Ser referentes en cada uno de los sectores en los que participamos, brindando productos y soluciones innovadoras que generen valor a nuestros clientes y a la sociedad en general.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                            Además, nos comprometemos a ser una empresa socialmente responsable, promoviendo la sustentabilidad y el cuidado del medio ambiente en cada una de nuestras operaciones y contribuyendo al desarrollo de las comunidades en las que operamos.
                        </text-comp>
                    </div>
                    <div class="content-item fourth">
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Compromiso:</b>
                            Nos comprometemos a brindar productos innovadores y de calidad a nuestros clientes y a ser un grupo de empresas socialmente responsable que contribuya al desarrollo sostenible de las comunidades en las que opera.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Innovación:</b>
                            Nos esforzamos por estar a la vanguardia de cada uno de los mercados en los que participamos, invirtiendo en nuevas tecnologías y fomentando la creatividad y la innovación en todos nuestros equipos de trabajo.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Excelencia:</b>
                            Buscamos la excelencia en todo lo que hacemos, desde la gestión empresarial hasta en la calidad de nuestros productos y servicios.
                        </text-comp>
                    </div>
                </div>
            </div>
        `;
    }
    addListeners() {
        const sideBarTitles = this.shadow.querySelectorAll(".side-bar__title");
        const firstTitleEl = this.shadow.querySelector("[item=first]");
        const secondTitleEl = this.shadow.querySelector("[item=second]");
        const thirdTitleEl = this.shadow.querySelector("[item=third]");
        const fourthTitleEl = this.shadow.querySelector("[item=fourth]");
        const firstContentEl = this.shadow.querySelector(".content-item.first");
        const secondContentEl = this.shadow.querySelector(".content-item.second");
        const thirdContentEl = this.shadow.querySelector(".content-item.third");
        const fourthContentEl = this.shadow.querySelector(".content-item.fourth");
        sideBarTitles.forEach((title)=>{
            title.addEventListener("click", ()=>{
                const itemAttr = title.getAttribute("item");
                if (itemAttr == "first") {
                    firstTitleEl.classList.add("active");
                    firstContentEl.classList.add("active");
                    secondTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "second") {
                    secondTitleEl.classList.add("active");
                    secondContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "third") {
                    thirdTitleEl.classList.add("active");
                    thirdContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    secondTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "fourth") {
                    fourthTitleEl.classList.add("active");
                    fourthContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    secondTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                }
            });
        });
    }
}
customElements.define("about-content", $7cccbcf59f240e42$var$AboutComponent);









class $d34caf84e4e25040$var$CompaniesComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
            .companies-container {
                height: 180vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 780px) {
                .companies-container {
                    height: 200vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 700px) {
                .companies-container {
                    height: 225vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 650px) {
                .companies-container {
                    height: 230vh;
                }
            }

            @media (min-width: 1440px) {
                .companies-container {
                    height: 260vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 780px) {
                .companies-container {
                    height: 275vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 700px) {
                .companies-container {
                    height: 290vh;
                }
            }

            .companies__side-bar {
                width: 40%;
                height: calc(100% - 25px);
                padding: 0 25px;
                padding-top: 25px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                border-right: 1px solid var(--black-color);
                border-top: 1px solid var(--black-color);
                border-bottom: 1px solid var(--black-color);
            }

            @media (min-width: 768px) {
                .companies__side-bar {
                    height: calc(100% - 180px);
                    padding: 90px 50px;
                }
            }

            @media (min-width: 960px) {
                .companies__side-bar {
                    width: 42%;
                }
            }

            @media (min-width: 1280px) {
                .companies__side-bar {
                    height: calc(100% - 300px);
                    padding: 150px 50px;
                    width: 38%;
                }
            }

            @media (min-width: 1440px) {
                .companies__side-bar {
                    width: 42%;
                    height: calc(100% - 330px);
                    padding: 165px 100px;
                }
            }

            @media (min-width: 1850px) {
                .companies__side-bar {
                    width: 45%;
                }
            }


            .side-bar__title {
                width: 100%;
                margin: 0;
                margin-bottom: 27px;
                font: 700 20px var(--jakarta-font);
                color: var(--black-color);
                text-align: left;
                transition: all .4s;
            }
            
            .side-bar__title:hover {
                cursor: pointer;
            }

            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__content {
                width: 100%;
                position: sticky;
                top: 45%;
            }

            @media (min-width: 1850px) {
                .side-bar__content {
                    margin-top: 55px; 
                }
            }

            .content__text {
                width: 100%;
                font: 500 12px var(--jakarta-font); 
                color: var(--black-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .companies__content-cards {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 25px;
                padding-right: 50px;
                border-top: 1px solid var(--black-color);
                border-bottom: 1px solid var(--black-color);
                gap: 25px;
            }

            @media (min-width: 960px) {
                .companies__content-cards {
                    width: 80%;
                    padding: 0;
                }
            }

            @media (min-width: 1280px) {
                .companies__content-cards {
                    gap: 30px;
                }
            }

            @media (min-width: 1440px) {
                .companies__content-cards {
                    gap: 50px;
                }
            }

            @media (min-width: 1850px) {
                .companies__content-cards {
                    width: 85%;
                    gap: 100px;
                }
            }

            .content__left-side {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding-top: 25vh;
            }

            @media (min-width: 1280px) {
                .content__left-side {
                    padding-top: 35vh;
                }
            }

            @media (min-width: 1850px) {
                .content__left-side {
                    padding-top: 30vh;
                }
            }

            .content__right-side {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .content__left-side,
            .content__right-side {
                gap: 25px;
                padding-top: 25vh;
            }

            @media (min-width: 1280px) {
                .content__left-side,
                .content__right-side {
                    gap: 30px;
                    padding-top: 35vh;
                }
            }

            @media (min-width: 1440px) {
                .content__left-side,
                .content__right-side {
                    gap: 50px;
                }
            }

            @media (min-width: 1850px) {
                .content__left-side,
                .content__right-side {
                    gap: 100px;
                    padding-top: 30vh;
                }
            }
            
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <div class="companies-container">
                <div class="companies__side-bar">
                    <div class="side-bar__content">
                        <h3 class="side-bar__title">
                        Nuestro grupo
                        </h3>
                        <p class="content__text">
                        Está integrado por empresas de producción y servicios de diferentes rubros, principalmente en medios de comunicación, construcción, energía y minería.
                        </p>
                    </div>
                </div>
                <div class="companies__content-cards">
                    <div class="content__left-side">
                        <company-card path="/company/indalo-media" src="${$42cb1983031089b4$exports}" rectangularLogo>
                            Es uno de los principales multimedios de la Argentina. Tiene una fuerte presencia en la industria de la televisión, la radio, los medios gráficos y digitales y en la producción de contenidos audiovisuales.
                        </company-card>
                        <company-card path="/company/cpc" src="${$cc64f062cd38ae25$exports}" squareLogo>
                            Empresa líder en construcción de obras públicas de gran envergadura.
                        </company-card>
                        <company-card path="/company/alpat" src="${$3e67dcecaa17c827$exports}" squareLogo>
                            Única empresa productora de carbonato de sodio de Latinoamérica.
                        </company-card>
                    </div>
                    <div class="content__right-side">
                        <company-card path="/company/oil-m&s" src="${$a2bd2683f70a0a67$exports}" rectangularLogo>
                            Compañía proveedora de soluciones integrales a la industria hidrocarburífera y minera en todo el país.
                        </company-card>
                        <company-card path="/company/providencia" src="${$39341b9d299a6db1$exports}" rectangularLogo>
                            Aseguradora enfocada en brindar un amplio espectro de servicios a personas y empresas a través de brokers y productores.
                        </company-card>
                        <company-card path="/company/serma" src="${$32bc09c7dfbdca68$exports}" squareLogo>
                            Brinda servicios de ingeniería ambiental a empresas de la industria hidrocarburífera y minera.
                        </company-card>
                    </div>
                </div>
            </div>
        `;
    }
}
customElements.define("companies-content", $d34caf84e4e25040$var$CompaniesComponent);



var $a1b65d7217d97d91$exports = {};

$a1b65d7217d97d91$exports = new URL((parcelRequire("6Dqfy")).resolve("ezZIi"), import.meta.url).toString();


class $fea70fb53265391e$var$CardComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
                    .company-card {
                        width: 210px;
                        height: 360px;
                        position: relative;
                        left: 0;
                        right: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        align-items: center;
                        background-color: var(--black-color);
                        border: none;
                        border-radius: 10px; 
                        transition: all .4s;
                    }

                    @media (min-width: 1440px) {
                        .company-card {
                            width: 277px;
                            height: 480px;
                        }
                    }
  
                    @media (min-width: 1850px) {
                        .company-card {
                            width: 345px;
                            height: 600px;
                        }
                    }

                    .company-card:hover {
                        background-color: var(--secondary-color);   
                        cursor: pointer;
                    }

                    .company-card__wrapper {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                    }
                    
                    .company-card__data {
                        width: calc(100% - 40px);
                        height: 100%;
                        padding: 0 20px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
            
                    @media (min-width: 768px) {
                        .company-card__data {
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                        }
                    }
            
                    .company-card__logo-container {
                        width: 100%;
                        height: 30%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo-container {
                            width: 85%;
                        }
                    }

                    .company-card__logo {
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 80px;
                    }

                    @media (min-width: 960px) {
                        .company-card__logo {
                            max-height: 75px;
                        }
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo {
                            max-height: 100px;
                        }
                    }

                    .company-card__logo.rectangular-logos {
                        width: 100%;
                    }

                    @media (min-width: 1440px) {
                        .company-card__logo.rectangular-logos {
                            width: 75%;
                        }    
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo.rectangular-logos {
                            width: 90%;
                        }    
                    }

                    .company-card__logo.square-logos {
                        height: 100%;
                    }
            
                    .company-card__redirect {
                        width: 100%;
                        height: 50px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        background-color: var(--gray-color);
                        border-radius: 0 0 9px 9px;
                        transition: all .4s;
                    }

                    @media (min-width: 1850px) {
                        .company-card__redirect {
                            height: 85px;
                        }
                    }

                    .company-card__redirect:hover {
                        opacity: .8;
                    }

                    .company-card__redirect-arrow {
                        width: 29px;
                    }

                    .company-card__redirect-arrow:hover {
                        cursor: pointer;
                    }

                    .company-card__link {
                        width: 100%;
                        height: 100%;
                        padding: 0 20px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        gap: 5px;
                        text-decoration: none;
                    }

                    .company-card__link:hover {
                        cursor: pointer;
                    }
            
                    `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                    <div class="company-card">
                        <div class="company-card__wrapper">
                            <div class="company-card__data">
                                <div class="company-card__logo-container">
                                    <img class="company-card__logo ${this.hasAttribute("rectangularLogo") ? "rectangular-logos" : ""}
                                    ${this.hasAttribute("squareLogo") ? "square-logos" : ""}
                                    "
                                    src="${this.getAttribute("src")}">
                                </div>

                                <text-comp variant="card middle-sided" scheme="f-light">
                                ${this.textContent}
                                </text-comp>
                            </div>
                            <div class="company-card__redirect">
                                <a class="company-card__link" path="${this.getAttribute("path")}">
                                    <img class="company-card__redirect-arrow" src="${$a1b65d7217d97d91$exports}" alt="">
                                    <text-comp variant="card" scheme="dark">Ver más</text-comp>
                                </a>
                            </div>
                        </div>
                    </div>
                    `;
    }
    addListeners() {
        const companyCardEl = this.shadow.querySelector(".company-card");
        const companyCardLinkEl = this.shadow.querySelector(".company-card__link");
        function getPageMaxScroll() {
            return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
        }
        const scrollUp = ()=>{
            let top = 1000000;
            const maxScroll = getPageMaxScroll();
            if (top > maxScroll) top = maxScroll;
            const rect = document.querySelector("div").getBoundingClientRect();
            window.scrollTo({
                top: rect.top,
                behavior: "smooth"
            });
        };
        scrollUp();
        companyCardEl.addEventListener("click", ()=>{
            const path = this.getAttribute("path");
            (0, $2c24f9dd87b676fe$export$55185c17a0fcbe46).go(path);
            setTimeout(scrollUp, 100);
        });
        companyCardLinkEl.addEventListener("click", ()=>{
            const path = this.getAttribute("path");
            (0, $2c24f9dd87b676fe$export$55185c17a0fcbe46).go(path);
            setTimeout(scrollUp, 100);
        });
    }
}
customElements.define("company-card", $fea70fb53265391e$var$CardComponent);











class $577731f9053fb652$var$CompaniesSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = `
        
        .carousel-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 45px;
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        @media (min-width: 630px) {
            .carousel {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
            }
        }

        .sliders-container {
            width: calc(100% + 13% * 5);
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6%;
            transform: translateX(-40%);
            transition: all .7s ease;
			scroll-snap-type: x mandatory;
			scroll-behavior: smooth;
        }

        @media (min-width: 425px) {
            .sliders-container {
                gap: 10%;
            }
        }

		@media (min-width: 500px) {
			.sliders-container {
				transform: translateX(-37%);
			}
		}

        @media (min-width: 630px) {
            .sliders-container {
                transform: translateX(-15%);
            }
        }

        .slider__item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            opacity: .35;
            transform: scale(0.9);
            transition: all .6s;
        }

        .slider__item.active {
            opacity: 1;
            transform: scale(1);            
        }

        .item__controlls {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 45px;
            mix-blend-mode: difference;
        }

        .left-arrow, 
        .right-arrow {
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }

        `;
        this.render();
        this.shadow.appendChild(style);
    }
    addListeners() {
        const carouselEl = this.shadow.querySelector(".carousel");
        const SlContainerEl = this.shadow.querySelector(".sliders-container");
        const slidersItemsEl = this.shadow.querySelectorAll(".slider__item");
        const leftArrowEl = this.shadow.querySelector(".left-arrow");
        const rightArrowEl = this.shadow.querySelector(".right-arrow");
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID, currentIndex = 0;
        slidersItemsEl.forEach((slide, index)=>{
            slide.addEventListener("touchstart", touchStart(index));
            slide.addEventListener("mousedown", touchStart(index));
            slide.addEventListener("touchend", touchEnd);
            slide.addEventListener("mouseup", touchEnd);
            slide.addEventListener("touchmove", touchMove);
            slide.addEventListener("mousemove", touchMove);
        });
        function getPositionX(event) {
            return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        }
        function touchStart(index) {
            return function(event) {
                currentIndex = index;
                startPos = getPositionX(event);
                isDragging = true;
                animationID = requestAnimationFrame(animation);
            };
        }
        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }
        function touchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            // if moved enough negative then snap to next slide if there is one
            if (window.innerWidth <= 425) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 630) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            }
            if (window.innerWidth <= 425) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 630) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            }
        }
        function animation() {
            if (isDragging) requestAnimationFrame(animation);
        }
        const leftArrowListener = (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (window.innerWidth <= 425) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 630) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            }
        };
        const rightArrowListener = (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (window.innerWidth <= 425) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 630) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            }
        };
        leftArrowEl.addEventListener("click", leftArrowListener);
        rightArrowEl.addEventListener("click", rightArrowListener);
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") slidersItemsEl.forEach((item)=>{
                    const itemOffset = item.getAttribute("offset");
                    const sliderOffset = SlContainerEl.getAttribute("offset");
                    if (sliderOffset == itemOffset) item.classList.add("active");
                    else item.classList.remove("active");
                });
            });
        });
        observer.observe(SlContainerEl, {
            attributes: true
        });
        const translationOnResize = ()=>{
            leftArrowEl.removeEventListener("click", leftArrowListener);
            leftArrowEl.removeEventListener("click", rightArrowListener);
            leftArrowEl.addEventListener("click", leftArrowListener);
            rightArrowEl.addEventListener("click", rightArrowListener);
        };
        window.addEventListener("resize", translationOnResize);
    }
    render() {
        this.shadow.innerHTML = `
        <div class="carousel-container">
            <div class="carousel">
                <div class="sliders-container" offset="3">
                    <div class="slider__item" offset="0">
                        <company-card path="/company/indalo-media" src="${$42cb1983031089b4$exports}">
							Es uno de los principales multimedios de la Argentina. Tiene una fuerte presencia en la industria de la televisión, la radio, los medios gráficos y digitales y en la producción de contenidos audiovisuales.
                        </company-card>
                    </div>
                    <div class="slider__item" offset="1">
                        <company-card path="/company/oil-m&s" src="${$a2bd2683f70a0a67$exports}">
							Compañía proveedora de soluciones integrales a la industria hidrocarburífera y minera en todo el país.
                        </company-card>
                    </div>
                    <div class="slider__item" offset="2">
                        <company-card path="/company/cpc" src="${$cc64f062cd38ae25$exports}">
                            Empresa líder en construcción de obras públicas de gran envergadura.
                        </company-card>
                    </div>
                    <div class="slider__item active" offset="3">
                        <company-card path="/company/providencia" src="${$39341b9d299a6db1$exports}">
							Aseguradora enfocada en brindar un amplio espectro de servicios a personas y empresas a través de brokers y productores.
                        </company-card>
                    </div>
                    <div class="slider__item" offset="4">
                        <company-card path="/company/alpat" src="${$3e67dcecaa17c827$exports}">
							Única empresa productora de carbonato de sodio de Latinoamérica.
                        </company-card>
                    </div>
                    <div class="slider__item" offset="5">
                        <company-card path="/company/serma" src="${$32bc09c7dfbdca68$exports}">
							Brinda servicios de ingeniería ambiental a empresas de la industria hidrocarburífera y minera.
                        </company-card>
                    </div>
                </div>
            </div>
            <div class="item__controlls">
            <img class="chevron-arrow left-arrow" src="${$2a03b197c7bfe3c5$exports}" position="previous">
            <img class="chevron-arrow right-arrow" src="${$685962251ed1dff4$exports}" position="next">
            </div>
        </div>
        `;
        this.addListeners();
    }
}
customElements.define("companies-slider", $577731f9053fb652$var$CompaniesSliderComponent);


var $bdce1ee241c0d53e$exports = {};

$bdce1ee241c0d53e$exports = new URL((parcelRequire("6Dqfy")).resolve("f4ZXR"), import.meta.url).toString();


var $dd2b943197d1a4ef$exports = {};

$dd2b943197d1a4ef$exports = new URL((parcelRequire("6Dqfy")).resolve("1xhvz"), import.meta.url).toString();


var $e42bdb8d8b369aaa$exports = {};

$e42bdb8d8b369aaa$exports = new URL((parcelRequire("6Dqfy")).resolve("6hVkq"), import.meta.url).toString();


var $51122e7d5b8f77eb$exports = {};

$51122e7d5b8f77eb$exports = new URL((parcelRequire("6Dqfy")).resolve("gC7GN"), import.meta.url).toString();


var $ec7cbc9c52414157$exports = {};

$ec7cbc9c52414157$exports = new URL((parcelRequire("6Dqfy")).resolve("f5l6t"), import.meta.url).toString();


var $e08b2125ca49e194$exports = {};

$e08b2125ca49e194$exports = new URL((parcelRequire("6Dqfy")).resolve("899gl"), import.meta.url).toString();


var $02a6965afb733683$exports = {};

$02a6965afb733683$exports = new URL((parcelRequire("6Dqfy")).resolve("kV3gF"), import.meta.url).toString();


var $4925103803db69ef$exports = {};

$4925103803db69ef$exports = new URL((parcelRequire("6Dqfy")).resolve("1gTsS"), import.meta.url).toString();


var $2840cc3390d04278$exports = {};

$2840cc3390d04278$exports = new URL((parcelRequire("6Dqfy")).resolve("dgI5V"), import.meta.url).toString();


var $ab6141456974d246$exports = {};

$ab6141456974d246$exports = new URL((parcelRequire("6Dqfy")).resolve("iTVTs"), import.meta.url).toString();


var $1df9a197a53f9f38$exports = {};

$1df9a197a53f9f38$exports = new URL((parcelRequire("6Dqfy")).resolve("7VJyz"), import.meta.url).toString();


var $a070b45794fc3165$exports = {};

$a070b45794fc3165$exports = new URL((parcelRequire("6Dqfy")).resolve("6HsrW"), import.meta.url).toString();


class $52ed28b941e85249$var$CollaboratorsSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .slider {
            width: 100%;
            height: 90px;
            margin: 40px auto;
            overflow: hidden;
        }

        @media (min-width: 768px) {
            .slider {
                height: 120px;
            }
        }

        @media (min-width: 960px) {
            .slider {
                height: 150px;
            }
        }

        @media (min-width: 1280px) {
            .slider {
                height: 200px;
            }
        }

        @media (min-width: 1440px) {
            .slider {
                height: 220px;
            }
        }

        .slider__track {
            width: calc(175px * 24);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            -webkit-animation: mobile-scroll 30s linear infinite;
            animation: mobile-scroll 30s linear infinite;
        }

        @media (min-width: 768px) {
            .slider__track {
                width: calc(200px * 24);
                -webkit-animation: tablet-scroll 30s linear infinite;
                animation: tablet-scroll 30s linear infinite;    
            }
        }

        @media (min-width: 960px) {
            .slider__track {
                width: calc(300px * 24);
                -webkit-animation: desktop-scroll 30s linear infinite;
                animation: desktop-scroll 30s linear infinite;    
            }
        }

        @media (min-width: 1440px) {
            .slider__track {
                width: calc(400px * 24);
                -webkit-animation: desktop-scroll 30s linear infinite;
                animation: desktop-xl-scroll 30s linear infinite;    
            }
        }

        .slide {
            width: 175px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @media (min-width: 768px) {
            .slide {
                width: 200px;
            }
        }

        @media (min-width: 960px) {
            .slide {
                width: 300px;
                height: 80%;
            }
        }

        @media (min-width: 1440px) {
            .slide {
                width: 400px;
            }
        }

        .slide img {
            width: auto;
            height: 100%;
        }


        @keyframes mobile-scroll {
            0% {
                -webkit-transform: translateX(0);
                transform: translateX(0);
            }
            100% {
                -webkit-transform: translateX(calc(-175px * 12 - 10px * 2));
                transform: translateX(calc(-175px * 12 - 10px * 2));
            }
        }

        @keyframes tablet-scroll {
            0% {
                -webkit-transform: translateX(0);
                transform: translateX(0);
            }
            100% {
                -webkit-transform: translateX(calc(-200px * 12 - 10px * 2));
                transform: translateX(calc(-200px * 12 - 10px * 2));
            }
        }

        @keyframes desktop-scroll {
            0% {
                -webkit-transform: translateX(0);
                transform: translateX(0);
            }
            100% {
                -webkit-transform: translateX(calc(-300px * 12 - 10px * 2));
                transform: translateX(calc(-300px * 12 - 10px * 2));
            }
        }


        @keyframes desktop-xl-scroll {
            0% {
                -webkit-transform: translateX(0);
                transform: translateX(0);
            }
            100% {
                -webkit-transform: translateX(calc(-400px * 12 - 10px * 2));
                transform: translateX(calc(-400px * 12 - 10px * 2));
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <div class="slider">
                <div class="slider__track">
                    <div class="slide">
                        <img src="${$bdce1ee241c0d53e$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$dd2b943197d1a4ef$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$e42bdb8d8b369aaa$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$51122e7d5b8f77eb$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$ec7cbc9c52414157$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$e08b2125ca49e194$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$02a6965afb733683$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$4925103803db69ef$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$2840cc3390d04278$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$ab6141456974d246$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$1df9a197a53f9f38$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$a070b45794fc3165$exports}" alt="">
                    </div>

                    <div class="slide">
                        <img src="${$bdce1ee241c0d53e$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$dd2b943197d1a4ef$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$e42bdb8d8b369aaa$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$51122e7d5b8f77eb$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$ec7cbc9c52414157$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$e08b2125ca49e194$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$02a6965afb733683$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$4925103803db69ef$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$2840cc3390d04278$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$ab6141456974d246$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$1df9a197a53f9f38$exports}" alt="">
                    </div>
                    <div class="slide">
                        <img src="${$a070b45794fc3165$exports}" alt="">
                    </div>
                </div>
            </div>
        `;
    }
}
customElements.define("collabs-slider", $52ed28b941e85249$var$CollaboratorsSliderComponent);


var $caeac12c891eb22b$exports = {};

$caeac12c891eb22b$exports = new URL((parcelRequire("6Dqfy")).resolve("5pMMu"), import.meta.url).toString();


var $6b58867a48b35f0b$exports = {};

$6b58867a48b35f0b$exports = new URL((parcelRequire("6Dqfy")).resolve("d0AMb"), import.meta.url).toString();


class $f0f60724b7ad6262$var$VideoEmbedComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
		.video-container {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		
        .video {
			width: 100%;
            height: 100%;
            min-height: 255px;
			object-fit: cover;
			object-position: center;
			border: none;
			border-radius: 4px;
			filter: brightness(0.6);
        }

		@media (min-width: 768px) {
			.video {
				border-radius: 8px;
				max-width: 70vw;
				max-height: 70vh;
			}
		}
		
		.video:active {
			filter: brightness(1);
		}

		.video-controls {
			position: absolute;
		}

		.play-btn.show,
		.pause-btn.show {
			opacity: 0.7;
			width: 50px;
			transition: all .4s;
		}

		.play-btn.hide,
		.pause-btn.hide {
			opacity: 0;
			width: 50px;
			transition: all .4s;
		}

		.play-btn:hover,
		.pause-btn:hover {
			opacity: 1;
			cursor: pointer;
			transition: all .4s;
		}
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
		    <div class="video-container">
		        <video class="video" src="${this.getAttribute("src")}" type="video/mp4" allowfullscreen="" controlslist="nodownload" playsinline></video>
				<div class="video-controls">
					<img class="play-btn show" src="${$caeac12c891eb22b$exports}" play="${$caeac12c891eb22b$exports}" pause="${$6b58867a48b35f0b$exports}">
				<div>
			</div>
		`;
    }
    addListeners() {
        const video = this.shadow.querySelector(".video");
        const playBtn = this.shadow.querySelector(".play-btn");
        video.volume = 0.5;
        function togglePlay() {
            const play = playBtn.getAttribute("play");
            const pause = playBtn.getAttribute("pause");
            if (video.paused) {
                playBtn.setAttribute("src", pause);
                video.setAttribute("controls", "controls");
                video.style.filter = "brightness(1)";
                video.play();
            } else {
                playBtn.setAttribute("src", play);
                video.style.filter = "brightness(.6)";
                video.pause();
            }
            playBtn.classList.toggle("paused");
        }
        function showControls() {
            playBtn.classList.remove("hide");
            playBtn.classList.add("show");
        }
        function hideControls() {
            playBtn.classList.remove("show");
            playBtn.classList.add("hide");
        }
        function reloadVideo() {
            video.load();
            const play = playBtn.getAttribute("play");
            video.removeAttribute("controls");
            playBtn.setAttribute("src", play);
            playBtn.classList.remove("hide");
            playBtn.classList.add("show");
        }
        playBtn.addEventListener("click", togglePlay);
        video.addEventListener("click", (e)=>{
            e.preventDefault();
        });
        video.addEventListener("ended", reloadVideo);
        video.addEventListener("mouseover", showControls);
        video.addEventListener("mouseleave", hideControls);
    }
}
customElements.define("video-embed", $f0f60724b7ad6262$var$VideoEmbedComponent);


var $02473897196aea3f$exports = {};

$02473897196aea3f$exports = new URL((parcelRequire("6Dqfy")).resolve("8WXpc"), import.meta.url).toString();


class $ec085cc2d0338251$var$translateComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
		.header__language-select {
			display: flex;
			justify-content: space-between;
			position: relative;

			width: 5.25rem;
			height: 2rem;

			cursor: pointer;

			box-sizing: border-box;
			border: 1px solid #FFF;
			color: #fff;
		}
		.header__options {
			display: flex;
			flex-direction: column;
			gap: 2px;
			width: 100%;
			height: 1.4rem;
			overflow: hidden;
			transition: height 0.5s;
		}
		.header__option {
			font-family: Plus Jakarta Sans;
			font-size: 1.125rem;
			font-weight: 700;
			line-height: 1.375rem;
			padding: 4px 8px;
			
		}
		.header__option .light {
			color: var(--white-color);
			text-decoration: none;
		}
		.icon-down {
			position: absolute;
			top: 3px;
			right: 8px;
			transition: transform 0.5s;
		}
		.header__language-select.open {
			backgroud: red;
		}
		.header__language-select.open .header__options {
			height: 4rem;
		}
		.header__language-select.open .header__option:not(:first-child) {
			background: rgba(43, 43, 43, 0.57);
		}
		.header__language-select.open .icon-down {
			transform: rotate(180deg);
		}
		}
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
			<div class="header__language-select">
				<div class="header__options">
					<div id="es" class="header__option">
						<a class="light" href="">ESP</a>
					</div>
					<div id="en" class="header__option">
						<a class="light" href="">ENG</a>
					</div>
				</div>
				<img src="${$02473897196aea3f$exports}" class="icon-down"/>
			</div>
        `;
    }
    addListeners() {
        //START Translate Button
        const languageSelect = this.shadow.querySelector(".header__language-select");
        const englishOption = this.shadow.querySelector("#en");
        const spanishOption = this.shadow.querySelector("#es");
        const url = window.location.href;
        const isPresent = url.includes("/en");
        if (isPresent) {
            englishOption.parentNode.prepend(englishOption);
            englishOption.style.pointerEvents = "none";
        } else spanishOption.style.pointerEvents = "none";
        languageSelect?.addEventListener("click", (e)=>{
            languageSelect.classList.toggle("open");
        });
        const options = this.shadow.querySelectorAll(".header__option");
        options.forEach((option, index)=>index > 0 && option.addEventListener("click", (e)=>{
                const url = new URL(window.location.href);
                const path = url.pathname.substr(1);
                const fragment = url.hash;
                if (option.id == "en") option.querySelector("a").href = `/en${fragment ? fragment : "/" + path}`;
                else {
                    const newpath = path.replace("en/", "");
                    option.querySelector("a").href = `/${fragment ? fragment : newpath}`;
                }
                if (fragment) setTimeout(()=>{
                    const targetElement = document.querySelector(fragment);
                    targetElement.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 100);
            }));
    //END Translate Button
    }
}
customElements.define("translate-comp", $ec085cc2d0338251$var$translateComponent);





const $0ecf2462e16a12c5$var$en_indaloVideo = "https://indalo-institucional.s3.amazonaws.com/grupo-indalo.mp4";
customElements.define("en-home-page", class en_initHomePage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
							<div class="container">
								<en-header-comp class="header"></en-header-comp>
							
								<div id="hero" class="hero">
									<div class="hero__slider-container">
										<en-hero-slider class="hidden">
											Construction, energy, mining and media.
										</en-hero-slider>
									</div>
									<div class="hero__scroll">
										<text-comp class="scroll__text" variant="hero" scheme="f-light" contains-html>
											Scroll
											<img src="${$fc139128a52810d7$exports}"/>
										</text-comp>
									</div>
								</div>
								
								<div id="about-us" class="about-us">
									<span class="divider mobile"></span>
									<div class="about-us__content mobile">
										<title-comp class="hidden" variant="section montserrat bold" scheme="light">
											Our future, much to do
										</title-comp>
										<subtitle-comp class="hidden" variant="section montserrat bold" scheme="yellow">
											What is Grupo Indalo?
										</subtitle-comp>
										<text-comp class="hidden" variant="section" scheme="light">
											Grupo Indalo is a conglomerate of companies that has been investing in Argentina for more than twenty years and is committed to the development of the country, generating employment for thousands of workers throughout the country. 
										</text-comp>
										<text-comp class="hidden" variant="section" scheme="light">
											Grupo Indalo includes production and service companies in different industries, mainly in media, construction, energy and mining.
										</text-comp>
										<text-comp class="hidden" variant="section" scheme="light">
											It was established in 1999 and since then it has become one of the most prominent groups in Argentina with growth projections across the region.
										</text-comp>
									</div>

									<span class="divider xl mobile"></span>

									<div class="about-us__content mobile second-section">
										<title-comp class="hidden" variant="section montserrat bold" scheme="light">What we believe</title-comp>
										<subtitle-comp class="hidden" variant="section jakarta semibold" scheme="red">Mission</subtitle-comp>
										<text-slider dualSlider class="hidden"
										first-paragraph="Our mission is to contribute to the economic and social development of Argentina by investing in companies in different industries, generating employment and improving the quality of life of the population."
										second-paragraph="We aim to be leaders in each of our business areas, providing high quality products and services that meet the needs of our customers and generate a positive impact on society."
										>
										</text-slider>
										<subtitle-comp class="hidden" variant="section jakarta semibold" scheme="blue">Vision</subtitle-comp>
										<text-slider class="hidden"
										first-paragraph="We aim to consolidate the leadership of our business group in the country and to expand into the region in search of new strategic markets."
										second-paragraph="To be a key player in each of the industries in which we operate, providing innovative products and solutions that generate value for our customers and society in general."
										third-paragraph="In addition, we are committed to being a socially responsible company, promoting sustainability and environmental protection in each of our operations and contributing to the development of the communities in which we operate."
										>
										</text-slider>
										<subtitle-comp class="hidden" variant="section jakarta semibold" scheme="green">Values</subtitle-comp>
										<text-slider class="hidden" variant="last-item"
										first-title="Commitment:"
										first-paragraph="We are committed to providing innovative and quality products to our customers and to being a socially responsible group of companies that contributes to the sustainable development of the communities in which we operate."
										second-title="Innovation:"
										second-paragraph="We strive to be at the forefront of each of the markets in which we operate, investing in new technologies and fostering creativity and innovation in all our work teams."
										third-title="Excellence:"
										third-paragraph="We pursue excellence in everything we do, from business management to the quality of our products and services."
										>
										</text-slider>
										<span class="divider mobile bottom event"></span>
									</div>

									<div class="about-us__content desktop">
										<en-about-content class="hidden"></en-about-content>
									</div>

									<div class="about-us__media hidden">
										<img class="hidden about-us__media-icon" src="${$58a3dc59024aec1d$exports}">
									<video-embed src="${$0ecf2462e16a12c5$var$en_indaloVideo}"></video-embed>
									</div>
								</div>

								<div id="companies" class="companies">
									<div class="companies__content mobile">
										<span class="divider mobile"></span>
										<title-comp class="hidden" variant="section medium margin-top jakarta extra-bold" scheme="dark">Our Group</title-comp>
										<div class="companies-cards">
											<en-companies-slider></en-companies-slider>
										</div> 
										<span class="divider dark mobile bottom"></span>
									</div>
									<div class="hidden companies__content desktop">
										<en-companies-content></en-companies-content>
									</div>
								</div>

								<div id="sust" class="sust">
									<div class="hidden sust-box">
										<div class="sust-box__pattern"></div>
										<div class="sust-box__content-wrapper">
											<div class="sust-box__content">
												<title-comp class="hidden" variant="section jakarta medium no-x-padding" scheme="light">Sustainability</title-comp>
												<div class="sust-box__subtitle">
													<subtitle-comp class="hidden" variant="montserrat medium" scheme="light"></subtitle-comp>
												</div>
												<a class="sust-box__link" href="https://instagram.com/rseindalo?igshid=YmMyMTA2M2Y=">
													<button class="hidden sust-box__button">See more</button>
												</a>
											</div>
										</div>
									</div>
								</div>

								<en-footer-comp></en-footer-comp>
							</div>
			`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.9vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 90vh;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			.hero__slider-container {
				margin: auto 0;
			}

			.hero__scroll {
				display: none;
			}

			@media (min-width: 768px) {
				.hero__scroll {
					display: initial;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					border-bottom: 1px solid var(--primary-color);
				}
			}

			.scroll__text {
				opacity: 0.8;
				transition: all .3s;
				animation: bounce 3s infinite;
			}

			.scroll__text:hover {
				cursor: pointer;
				opacity: 1;
			}

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 35px 25px;
				padding-bottom: 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				align-items: flex-start;
				border-bottom: 1px solid var(--white-color);
			}	

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 25px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.about-us__media {
					height: 80vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 1280px) {
				.about-us__media {
					height: 90vh;
					padding: 60px 0;
				}
			}

			@media (min-width: 1440px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 110px 0;
				}
			}

			@media (min-width: 768px) {
				.about-us__media-icon {
					display: none;
				}
			}

            .companies {
                width: 100%;
                height: 100vh;
				min-height: 770px;
				margin-top: 3vh;
                display: flex;
                flex-direction: column;
				align-items: center;
                justify-content: flex-start;
				background-color: var(--white-color);
				border-bottom: 1px solid var(--black-color);
            }


			@media (min-width: 768px) {
				.companies {
					min-height: 180vh;
					margin: 0;
					border: none;
				}
			}

			@media (min-width: 768px) and (max-width: 1440px) and (max-height: 780px) {
                .companies {
                    height: 200vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 700px) {
                .companies {
                    height: 225vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 650px) {
                .companies {
                    height: 230vh;
                }
            }

			@media (min-width: 1440px) {
				.companies {
					min-height: 260vh;
				}
			}

			@media (min-width: 1440px) and (max-height: 780px) {
                .companies {
                    height: 275vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 700px) {
                .companies {
                    height: 290vh;
                }
            }

			.companies__content {
				width: 100%;
                height: 100%;
				display: flex;
                flex-direction: column;
				align-items: center;
                justify-content: flex-start;
			}

			.companies__content.desktop {
				display: none;
			}

			@media (min-width: 768px) {
				.companies__content.mobile {
					display: none;
				}

				.companies__content.desktop {
					height: 100%;
					display: flex;
					justify-content: flex-start;
					align-items: center;
				}
			}
			
			.content__left-side {
				height: 100%;
				display: flex;
				justify-content: space-evenly;
				align-items: center;
			}

			.companies-cards { 
				width: 100%;
				height: 100%;
			}

			.companies-cards.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.companies-cards.mobile {
					display: none;
				}

				.companies-cards.desktop {
					display: flex;
					justify-content: center;
					align-items: center;
				}	
			}

			.sust {
                width: 100%;
                height: 50vh;
				min-height: 425px;
                display: flex;
                justify-content: center;
				align-items: center;
				background-color: var(--white-color);
            }

			@media (min-width: 768px) {
				.sust {
					height: 70vh;
				}
			}

			.sust-box {
				width: 360px;
				height: 370px;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;
				border: none;
				border-radius: 10px;
				background-color: var(--black-color);
			}

			@media (min-width: 768px) {
				.sust-box {
					height: 40vh;
					width: 70vw;
					flex-direction: row-reverse;
				}
			}

			.sust-box__pattern {
				width: 100%;
				height: 30%;
				background-position: top center;
				background-image: url(${$971b1f94782b4bff$exports});
				background-size: 75%;
			}

			@media (min-width: 768px) {
				.sust-box__pattern {
					width: 50%;
					height: 100%;
					background-size: cover;
				}
			}

			.sust-box__content-wrapper {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			@media (min-width: 768px) {
				.sust-box__content-wrapper {
					width: 50%;
				}	
			}

			.sust-box__content {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				text-align: center;
			}

			@media (min-width: 768px) {
				.sust-box__content {
					width: 85%;
					align-items: flex-start;
					text-align: left;
				}
			}

			@media (min-width: 960px) {
				.sust-box__content {
					width: 70%;
				}
			}

			@media (min-width: 1440px) {
				.sust-box__content {
					width: 60%;
				}
			}

			.sust-box__subtitle {
				width: 100%;
				padding: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-top: 1px solid var(--white-color);
			}

			@media (min-width: 768px) {
				.sust-box__subtitle {
					width: 90%;
					padding: 10px 0;
					padding-bottom: 20px;
					border: none;
				}
			}

			@media (min-width: 1850px) {
				.sust-box__subtitle {
					padding: 15px 0;
					padding-bottom: 25px;
				}
			}

			.sust-box__link {
				text-decoration: none;
			}

			.sust-box__button {
				width: 110px;
				height: 35px;
				background-color: var(--white-color);
				border: none;
				border-radius: 22px;
				font: 500 10px var(--jakarta-font);
			}

			.sust-box__button:hover {
				opacity: 0.8;
				cursor: pointer;
			}

			@media (min-width: 768px) {
				.sust-box__button {					
					width: 130px;
					height: 40px;
					font-size: 15px;				
				}
			}

			@media (min-width: 960px) {
				.sust-box__button {
					border-radius: 30px;

				}
			}

			@media (min-width: 1280px) {
				.sust-box__button {					
					width: 165px;
					height: 50px;
					font-size: 18px;
				}
			}

			@keyframes bounce {
				0% {
				  transform: translateY(0);
				}
				25% {
				  transform: translateY(-10px);
				}
				50% {
				  transform: translateY(0);
				}
				100% {
					transform: translateY(0);	
				}
			  }
        `;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const rootEl = document.querySelector(".root");
        const scrollTextEl = this.querySelector(".scroll__text");
        const aboutUsEl = this.querySelector("#about-us");
        bodyEl.style.overflowY = "auto";
        rootEl.style.overflowX = "initial";
        scrollTextEl.addEventListener("click", ()=>{
            aboutUsEl.scrollIntoView({
                behavior: "smooth"
            });
        });
        window.addEventListener("beforeunload", (e)=>{
            e.preventDefault();
            window.scrollTo(0, 0);
        });
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






const $8ad549c5df3d4e99$var$en_videoIndaloMedia = "https://indalo-institucional.s3.amazonaws.com/indalo-media.mp4";
customElements.define("en-indalo-media-page", class initIndaloMediaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$42cb1983031089b4$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Commitment, innovation and credibility.
                        </title-comp>
					</div>
					<button style="display: none" class="btn hero__btn">
						Visit website
					</button>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About Indalo Media</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
							Indalo Media is one of the leading multimedia companies in Argentina. It has a strong presence in the television, radio, graphic and digital media industries and in the production of audiovisual content. Thanks to a loyal, critical audience and the quality of its communication, information, news, entertainment and music services, it was able to consolidate its position among the leaders in terms of audience share.
							<br><br>
							The media that make up the Group are: the news channel C5N, the radio stations POP FM 101.5, Mega FM 98.3, Vale FM 97.5, One FM 103.7, Radio 10 AM710, the newspaper Ámbito Financiero, the web portals ambito.com, c5n.com, minutouno.com, buenosairesherald.com and diarioregistrado.com. Ideas del Sur, Pensado para Televisión (PPT) and La Corte production companies also form part of the Group. 
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">About Indalo Media</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Strong presence in television, radio, graphic and digital media as well as audiovisual content production.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
									Indalo Media is one of the leading multimedia companies in Argentina. It has a strong presence in the television, radio, graphic and digital media industries and in the production of audiovisual content. Thanks to a loyal, critical audience and the quality of its communication, information, news, entertainment and music services, it was able to consolidate its position among the leaders in terms of audience share.
										<br><br>
										The media that make up the Group are: the news channel C5N, the radio stations POP FM 101.5, Mega FM 98.3, Vale FM 97.5, One FM 103.7, Radio 10 AM710, the newspaper Ámbito Financiero, the web portals ambito.com, c5n.com, minutouno.com, buenosairesherald.com and diarioregistrado.com. Ideas del Sur, Pensado para Televisión (PPT) and La Corte production companies also form part of the Group. 
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div style="display: none" class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">Linear km covered</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Projects implemented</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Employees</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$8ad549c5df3d4e99$var$en_videoIndaloMedia}"></video-embed>
						</div>

						<collabs-slider></collabs-slider>
	
						<button style="display: none" class="btn bottom__btn">
							Visit website
						</button>
					</div>
				</div>
				<en-footer-comp></en-footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }
			
			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$e44a9ca88677ea64$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$e44a9ca88677ea64$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const rootEl = document.querySelector(".root");
        rootEl.style.overflowX = "hidden";
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






customElements.define("en-oil-combustibles-page", class initOilCombustiblesPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$a2bd2683f70a0a67$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Comprehensive services for the oil industry. 
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://oilms.ar/" target="_blank">
						<button class="btn hero__btn">
							Visit website
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About Oil M&S</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
						Oil M&S provides comprehensive solutions to the hydrocarbon and mining industries throughout the country. Founded in 2001 and, under an integrated management system, the company offers a wide range of services, including oilfield operation and maintenance, integrated oil and gas treatment plant operation, complete environmental management, drilling and workover, civil and engineering works, logistics services and road equipment, among others. The company operates in the provinces of Buenos Aires, Chubut, Neuquén, Río Negro, Santa Cruz and Mendoza.
						<br><br>
						The company provides services by highly qualified employees together with state-of-the-art technological resources to achieve maximum efficiency.
						</text-comp>
					</div>

					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de Oil M&S</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								Comprehensive solutions for the hydrocarbon and mining industries.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
									Oil M&S provides comprehensive solutions to the hydrocarbon and mining industries throughout the country. Founded in 2001 and, under an integrated management system, the company offers a wide range of services, including oilfield operation and maintenance, integrated oil and gas treatment plant operation, complete environmental management, drilling and workover, civil and engineering works, logistics services and road equipment, among others. The company operates in the provinces of Buenos Aires, Chubut, Neuquén, Río Negro, Santa Cruz and Mendoza.
									<br><br>
									The company provides services by highly qualified employees together with state-of-the-art technological resources to achieve maximum efficiency.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">Linear km covered</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Projects implemented</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Employees</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<button class="btn bottom__btn">
							<a class="hero__btn-link" href="https://oilms.ar/" target="_blank">Visit website</a>
						</button>
					</div>
				</div>
				<en-footer-comp></footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$9cd284aa05024f8e$exports});
                background-position: left center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$9cd284aa05024f8e$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






const $8fdaef6f778d147d$var$en_videoCpc = "https://indalo-institucional.s3.amazonaws.com/cpc.mp4";
customElements.define("en-cpc-page", class initHomePage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$cc64f062cd38ae25$exports}">
                        	<title-comp variant="hero company-name jakarta bold" scheme="light">
                        	    CPC
                        	</title-comp>
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Leader in the implementation of large-scale public work projects.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://www.cpc-sa.com.ar/" target="_blank">
						<button class="btn hero__btn">
							Visit website
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About CPC</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
						Comercial del Plata Construcciones S.A. was founded in 1977 and in 1995 changed its name to CPC S.A. Since its inception, it has forged an ethical business culture and consolidated its position as one of the largest construction companies in Latin America.
							<br><br>
							As part of the Indalo Group, it became a leading company in the implementation of public work projects, particularly in road works, improvements and renovation of gas pipelines, oil pipelines, including railroads and their routes.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">About CPC</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								More than 40 years building a great company.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
									Comercial del Plata Construcciones S.A. was founded in 1977 and in 1995 changed its name to CPC S.A. Since its inception, it has forged an ethical business culture and consolidated its position as one of the largest construction companies in Latin America.
										<br><br>
										As part of the Indalo Group, it became a leading company in the implementation of public work projects, particularly in road works, improvements and renovation of gas pipelines, oil pipelines, including railroads and their routes.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item hidden">
								<h3 class="item__number red" data-val="20000">0</h3>
								<p class="item__text">linear km covered</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue" data-val="500">0</h3>
								<p class="item__text">projects implemented</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green" data-val="1200">0</h3>
								<p class="item__text">employees</p>
							</div>
							<span class="divider dark bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$8fdaef6f778d147d$var$en_videoCpc}"></video-embed>
						</div>
	
						<a class="hero__btn-link" href="https://www.cpc-sa.com.ar/" target="_blank">
							<button class="btn bottom__btn">
								Visit website
							</button>
						</a>
					</div>
				</div>
				<en-footer-comp></en-footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$ac89dac40e26ec20$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$ac89dac40e26ec20$exports});
					background-position: center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 40px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const itemNumberEl = this.querySelectorAll(".item__number");
        const factsItemEl = this.querySelector(".facts__item");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        window.addEventListener("scroll", ()=>{
            if (window.scrollY < 100) itemNumberEl.forEach((item)=>{
                item.textContent = "0";
            });
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    if (factsItemEl.classList.contains("show")) itemNumberEl.forEach((item)=>{
                        const updateNumber = ()=>{
                            const endValue = +item.getAttribute("data-val");
                            let startValue = +item.textContent;
                            item.textContent = `${Math.ceil(endValue)}`;
                            let increment = endValue / 100;
                            if (startValue < endValue) {
                                item.textContent = `${Math.ceil(startValue + increment)}`;
                                setTimeout(updateNumber, 20);
                            } else item.textContent = endValue.toString();
                        };
                        updateNumber();
                    });
                } else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});







customElements.define("en-providencia-page", class initProvidenciaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$39341b9d299a6db1$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Peace of mind guaranteed.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="http://providencia.com.ar/" target="_blank">
						<button class="btn hero__btn">
							Visit website
						</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About Providencia Seguros</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
						Providencia Seguros was established in 1904. Today, it is a nationally owned company with strong local support, solid assets, highly qualified professionals and a wide range of services designed for the local market.
							<br><br>
							Its greatest strength is its customer-oriented service, with great adaptability and flexibility to meet every need, both in the individual segment and in the SME and Large Company segment.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">About Providencia Seguros</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
									Over a century of history.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
									Providencia Seguros was established in 1904. Today, it is a nationally owned company with strong local support, solid assets, highly qualified professionals and a wide range of services designed for the local market.
										<br><br>
										Its greatest strength is its customer-oriented service, with great adaptability and flexibility to meet every need, both in the individual segment and in the SME and Large Company segment.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div class="about-us__media hidden">
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
							<video-embed src="${$1704451a997f91e4$exports}"></video-embed>
						</div>
	
						<a class="hero__btn-link" href="http://providencia.com.ar/" target="_blank">
						<button class="btn bottom__btn">
							Visit website
						</button>
					</a>
					</div>
				</div>
				<en-footer-comp></en-footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$7b07003ab1dc9312$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$7b07003ab1dc9312$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 15px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 40px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






const $6d3773fa6fde224a$var$en_videoAlpat = "https://indalo-institucional.s3.amazonaws.com/alpat.mp4";
customElements.define("en-alpat-page", class initAlpatPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
						<div class="container">
						<en-company-header-comp class="header"></en-company-header-comp>

						<div id="hero" class="hero">
							<div class="hero__company-info">
								<div class="info__wrapper">
									<img class="info__company-logo" src="${$3e67dcecaa17c827$exports}">
								</div>
								<title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
									The only sodium carbonate producer in Latin America.
								</title-comp>
							</div>
							<a class="hero__btn-link" href="https://alcalisdelapatagonia.com/" target="_blank">
								<button class="btn hero__btn">
									visit website
								</button>
							</a>
						</div>

						<div id="about-us" class="about-us">
							<span class="divider mobile"></span>
							<div class="about-us__content mobile">
								<subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About ALPAT</subtitle-comp>
								<text-comp class="hidden" variant="section" scheme="light" contains-html>
									Alcalis de la Patagonia (ALPAT) started its activities in 2005 and is currently the first and only sodium carbonate producer in Latin America.
									<br><br>
									Sodium carbonate is a raw material used in the glass industry, which requires dense sodium carbonate, while its light version is used in the chemical industry for the production of soaps and detergents. It is also used in the paper, oil and gas and metallurgy industries.
									<br><br>
									Alpat is based in San Antonio Oeste, in the province of Río Negro.
								</text-comp>
							</div>
								
							<span class="divider bottom mobile"></span>

							<div class="about-us__content desktop">
								<div class="about-container">
								<div class="about__side-bar">
									<div class="side-bar__faq">
										<h3 class="side-bar__title yellow active" item="first">About ALPAT</h3>
									</div>
									<div class="side-bar__content">
										<h3 class="content__title">
											Company strongly committed to excellence in quality and customer service.
										</h3>
									</div>
								</div>
									<div class="about__content">
										<div class="content-item first active">
											<text-comp variant="about company-hero" scheme="f-light" contains-html>
												Alcalis de la Patagonia (ALPAT) started its activities in 2005 and is currently the first and only sodium carbonate producer in Latin America.
												<br><br>
												Sodium carbonate is a raw material used in the glass industry, which requires dense sodium carbonate, while its light version is used in the chemical industry for the production of soaps and detergents. It is also used in the paper, oil and gas and metallurgy industries.
												<br><br>
												Alpat is based in San Antonio Oeste, in the province of Río Negro.
											</text-comp>
										</div>
									</div>
								</div>
							</div>

							<div class="about-us__media hidden">
								<div class="media__facts-container">
									<div class="facts__item hidden">
										<h3 class="item__number red" data-val="170000">0</h3>
										<p class="item__text">170,000 tons of sodium carbonate per year</p>
									</div>
									<div class="facts__item">
										<h3 class="item__number blue" data-val="5">0</h3>
										<p class="item__text">Exports to 5 countries in the region.</p>
									</div>
									<div class="facts__item last">
										<h3 class="item__number green" data-val="400">0</h3>
										<p class="item__text">More than 400 direct employees.</p>
									</div>
									<span class="divider dark bottom mobile"></span>
								</div>

								<div class="media__video-container">
									<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
									<video-embed src="${$6d3773fa6fde224a$var$en_videoAlpat}"></video-embed>
								</div>

								<a class="hero__btn-link" href="https://alcalisdelapatagonia.com/" target="_blank">
									<button class="btn bottom__btn">
										Visit website
									</button>
								</a>
							</div>
						</div>
						<en-footer-comp></en-footer-comp>
						</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$b87cea178d57ad98$exports});
                background-position: center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$b87cea178d57ad98$exports});
					background-position: center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 200px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 230px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
				min-height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					width: 70%;
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 70%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 65%;
				}
			}

			.facts__item {
				width: 75%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			@media (min-width: 960px) {
				.facts__item {	
					width: 70%
				}
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 100%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1280px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 85%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const itemNumberEl = this.querySelectorAll(".item__number");
        const factsItemEl = this.querySelector(".facts__item");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        window.addEventListener("scroll", ()=>{
            if (window.scrollY < 100) itemNumberEl.forEach((item)=>{
                item.textContent = "0";
            });
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    if (factsItemEl.classList.contains("show")) itemNumberEl.forEach((item)=>{
                        const updateNumber = ()=>{
                            const endValue = +item.getAttribute("data-val");
                            let startValue = +item.textContent;
                            item.textContent = `${Math.ceil(endValue)}`;
                            let increment = endValue / 100;
                            if (startValue < endValue) {
                                item.textContent = `${Math.ceil(startValue + increment)}`;
                                setTimeout(updateNumber, 20);
                            } else item.textContent = endValue.toString();
                        };
                        updateNumber();
                    });
                } else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






customElements.define("en-serma-page", class initSermaPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$32bc09c7dfbdca68$exports}">
						</div>
                        <title-comp variant="hero company-slogan jakarta thick-line medium bold" scheme="light">
						Leading company in environmental engineering for the oil market.
                        </title-comp>
					</div>
					<a class="hero__btn-link" href="https://serma.com.ar/" target="_blank">
					<button class="btn hero__btn">
						Visitar web
					</button>
					</a>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">About Serma</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light">
						Serma S.A. was founded in 2006 as a company dedicated to providing upstream and downstream services for the oil industry in the province of Neuquén and Río Negro. Today, with services in the provinces of La Pampa, Mendoza, Río Negro and Santa Cruz, the company continues to grow, adapting its offer to the needs of the oil market in order to consolidate and continue to be a benchmark for services in the national oil industry.
						</text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">ABout Serma</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
								A service reference in the domestic oil industry.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light">
									Serma S.A. was founded in 2006 as a company dedicated to providing upstream and downstream services for the oil industry in the province of Neuquén and Río Negro. Today, with services in the provinces of La Pampa, Mendoza, Río Negro and Santa Cruz, the company continues to grow, adapting its offer to the needs of the oil market in order to consolidate and continue to be a benchmark for services in the national oil industry.
									</text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">Linear km covered</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Projects implemented</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Employees</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<a class="hero__btn-link" href="https://serma.com.ar/" target="_blank">
						<button class="btn bottom__btn">
							Visit website
						</button>
						</a>
						</div>
				</div>
				<en-footer-comp></en-footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$2548ae788ce5686d$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$2548ae788ce5686d$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 130px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 180px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 200px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 230px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
                border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			.hero__btn-link {
				color: var(--dark-color);
				text-decoration: none;
				align-self: center;
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});






customElements.define("en-pilgrim-page", class initPilgrimPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.addListeners();
    }
    render() {
        this.innerHTML = `
            <div class="container">
                <en-company-header-comp class="header"></en-company-header-comp>
            
				<div id="hero" class="hero">
                    <div class="hero__company-info">
						<div class="info__wrapper">
							<img class="info__company-logo" src="${$ba7ed2acb1e041df$exports}">
						</div>
                        <title-comp variant="hero company-slogan minimized jakarta thick-line medium bold" scheme="light">
							Empresa especializada en la producción y desarrollo de yacimientos de petróleo y gas.
						</title-comp>
					</div>
					<button style="display: none" class="btn hero__btn">
						Visitar web
					</button>
				</div>
				
				<div id="about-us" class="about-us">
                	<span class="divider mobile"></span>
                    <div class="about-us__content mobile">
                        <subtitle-comp class="hidden" variant="section jakarta bold" scheme="light">Acerca de PILGRIM ENERGY</subtitle-comp>
                        <text-comp class="hidden" variant="section" scheme="light" contains-html>
                            Es una empresa argentina que desarrolla de manera rentable activos de productividad marginal en exploración, producción y transporte de crudo y gas. Tiene operación y actividades en la provincia de Chubut, en el área Cerro Negro, localizada en la Cuenca del Golfo San Jorge, a 130 km al Oeste de la ciudad de Comodoro Rivadavia y a 25 km al sureste de la ciudad de Sarmiento. Se extiende un área de 186 km2. 
							<br><br>
							La empresa cuenta con un equipo de trabajo profesional y altamente calificado que busca obtener la mayor rentabilidad de sus activos, desarrollando e implementando modelos operativos y de desarrollo con altos estándares de calidad, seguridad y medio ambiente.
                        </text-comp>
					</div>
						
					<span class="divider bottom mobile"></span>

					<div class="about-us__content desktop">
						<div class="about-container">
                		<div class="about__side-bar">
                		    <div class="side-bar__faq">
                		        <h3 class="side-bar__title yellow active" item="first">Acerca de PILGRIM ENERGY</h3>
                		    </div>
                		    <div class="side-bar__content">
                		        <h3 class="content__title">
									Empresa especializada en la producción y desarrollo de yacimientos de petróleo y gas.
                		        </h3>
                		    </div>
                		</div>
                			<div class="about__content">
                			    <div class="content-item first active">
                			        <text-comp variant="about company-hero" scheme="f-light" contains-html>
                                        Es una empresa argentina que desarrolla de manera rentable activos de productividad marginal en exploración, producción y transporte de crudo y gas. Tiene operación y actividades en la provincia de Chubut, en el área Cerro Negro, localizada en la Cuenca del Golfo San Jorge, a 130 km al Oeste de la ciudad de Comodoro Rivadavia y a 25 km al sureste de la ciudad de Sarmiento. Se extiende un área de 186 km2. 
										<br><br>
										La empresa cuenta con un equipo de trabajo profesional y altamente calificado que busca obtener la mayor rentabilidad de sus activos, desarrollando e implementando modelos operativos y de desarrollo con altos estándares de calidad, seguridad y medio ambiente.
                			        </text-comp>
                			    </div>
                			</div>
            			</div>
					</div>

					<div style="display: none" class="about-us__media hidden">
						<div class="media__facts-container">
							<div class="facts__item">
								<h3 class="item__number red">20.000</h3>
								<p class="item__text">kms lineales recorridos</p>
							</div>
							<div class="facts__item">
								<h3 class="item__number blue">500</h3>
								<p class="item__text">Proyectos ejecutados</p>
							</div>
							<div class="facts__item last">
								<h3 class="item__number green">1200</h3>
								<p class="item__text">Trabajadores</p>
							</div>
							<span class="divider bottom mobile"></span>
						</div>
	
						<div class="media__video-container">
							<img class="hidden media__icon" src="${$58a3dc59024aec1d$exports}">
						</div>
	
						<button class="btn bottom__btn">
							Visitar web
						</button>
					</div>
				</div>
				<en-footer-comp></en-footer-comp>
			</div>
        	`;
        const style = document.createElement("style");
        style.textContent = `

			.hidden {
				opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
			}

			@media (prefers-reduced-motion) {
				.hidden {
					transition: none;
				}
			}

			.show {
				opacity: 1;
				filter: blur(0);
				transform: translateY(0);
			}

            .divider {
                margin-top: 3.8vh;
                width: 8vh;
                height: 1px;
                transform: rotate(90deg);
                border: 1px solid var(--white-color);
            }

			.divider.dark {
				border-color: var(--dark-color);
			}

            .divider.xl {
                width: 75px;
            }

            .divider.bottom {
                margin-top: 0;
                margin-bottom: 3.8vh;
				align-self: center;
            }

			@media (min-width: 768px) {
				.divider {
					display: none;
				}
			}
			
			@media (min-width: 630px) {
				.divider.mobile {
					display: none;
				}
			}

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.hero {
                width: 100%;
                height: 100vh;
				padding: 0 50px;
				padding-top: 25vh;
				padding-bottom: 10vh;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-image: url(${$ea54a7185f45d98b$exports});
                background-position: bottom center;
				background-size: cover;
            }

			@media (min-width: 500px) {
				.hero {
					justify-content: space-between;
					align-items: flex-start;
					background-image: url(${$ea54a7185f45d98b$exports});
					background-position: bottom center;
					background-size: cover;
				}
			}
			
			@media (min-width: 768px) {
				.hero {
					height: 100vh;
				}
			}

			@media (min-width: 1440px) {
				.hero {
					padding: 0 100px;
					padding-top: 25vh;
					padding-bottom: 10vh;
				}
			}

            .hero__company-info {
				max-width: 275px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
				gap: 40px;
            }

			@media (min-width: 500px) {
				.hero__company-info {
					max-width: none;
				}
			}

			.info__wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
			}

			.info__company-logo {
				width: 205px;
			}

			@media (min-width: 960px) {
				.info__company-logo {
					width: 270px;
				}	
			}

			@media (min-width: 1280px) {
				.info__company-logo {
					width: 300px;
				}	
			}

			@media (min-width: 1440px) {
				.info__company-logo {
					width: 320px;
				}	
			}

			@media (min-width: 1850px) {
				.info__company-logo {
					width: 400px;
				}	
			}

			.about-container {
                height: 70vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

			@media (min-width: 768px) {
				.about-container {
					height: 80vh;
				}
			}

			@media (min-width: 1280px) {
				.about-container {
					height: 90vh;
				}
			}

            .about__side-bar {
                width: 40%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				gap: 10px;
                border-right: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: 100%;
                    padding: 0 50px;

                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 35%;
                }
            }

            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 40%;
                    height: 100%;
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    height: 100%;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 20px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            .content__title {
                font: 700 16px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 19px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 23px;
                }
            }

            @media (min-width: 1440px) {
                .content__title {
                    font-size: 22px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 33px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 60%;
                height: 100%;
                padding: 0 25px;
				display: flex;
				justify-content: center;
				align-items: center;
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

			@media (min-width: 1280px) {
                .about__content {
					width: 64%;
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

			.about-us {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
				background-color: var(--bkgd-color);
                border-top: 1px solid var(--white-color);
				border-bottom: 1px solid var(--white-color);
            }

			@media (min-width: 630px) {
				.about-us {
					border-top: none;
				}
			}

			.about-us__content {
				width: 100%;
				height: 100%;
				padding: 10vh 25px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.about-us__content.second-section {
				border-bottom: 1px solid var(--white-color);
			}

			@media (min-width: 630px) {
				.about-us__content {
					padding: 0;
					padding-top: 9vh;
					border-bottom: 1px solid var(--white-color)
				}
			}

			.about-us__content.desktop {
				display: none;
			}

			@media (min-width: 630px) {
				.about-us__content.mobile {
					display: none;
				}
				
				.about-us__content.desktop {
					display: inherit;
				}
			}

			.about-us__media {
				width: 100%;
				height: 100%;
				padding: 50px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
				background-color: var(--white-color);
			}

			@media (min-width: 1850px) {
				.about-us__media {
					padding: 100px 0;
				}
			}

			.media__facts-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 50px;
				border-bottom: 1px solid var(--primary-color);
			}

			@media (min-width: 768px) {
				.media__facts-container {
					width: 60%;
					border-bottom: none;
				}
			}

			@media (min-width: 960px) {
				.media__facts-container {
					flex-direction: row;
					align-items: flex-start;
					border-bottom: none;
				}
			}

			@media (min-width: 1280px) {
				.media__facts-container {
					width: 50%;
				}
			}

			@media (min-width: 1850px) {
				.media__facts-container {
					width: 55%;
				}
			}

			.facts__item {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.facts__item.last {
				padding-bottom: 7vh;
			}

			@media (min-width: 960px) {
				.facts__item.last {
					padding-bottom: 0;
				}
			}

			.item__number {
				font: 700 49px var(--jakarta-font);
				line-height: 68px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 1280px) {
				.item__number {
					font-size: 65px;
				}
			}

			@media (min-width: 1440px) {
				.item__number {
					font-size: 80px;
				}
			}

			@media (min-width: 1850px) {
				.item__number {
					font-size: 95px;
				}
			}

			.item__text {
				width: 70%;
				font: 700 15px var(--jakarta-font);
				line-height: 22px;
				text-align: center;
				color: var(--primary-color);
			}

			@media (min-width: 425px) {
				.item__text {
					width: 50%;
				}
			}

			@media (min-width: 600px) {
				.item__text {
					width: 45%;
				}
			}

			@media (min-width: 768px) {
				.item__text {
					width: 65%;
					font-weight: 400;
					font-size: 20px;
				}
			}

			@media (min-width: 960px) {
				.item__text {
					width: 80%;
					margin-top: 15px;
				}
			}

			@media (min-width: 1440px) {
				.item__text {
					width: 75%;
					font-size: 22px;
					margin-top: 20px;
				}
			}

			@media (min-width: 1850px) {
				.item__text {
					width: 70%;
					font-size: 33px;
					line-height: 1.2;
					margin-top: 30x;
				}
			}

			.media__video-container {
				width: 100%;
				height: 100%;
				padding: 0px 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 15px;
			}

			@media (min-width: 768px) {				
				.media__video-container {
					height: 65vh;
					padding: 50px 0;
				}
			}

			@media (min-width: 960px) {
				.media__video-container {
					height: 80vh;
					padding-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.media__video-container {
					height: 90vh;
					padding: 60px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1440px) {
				.media__video-container {
					padding: 100px 0;
					padding-top: 0;
				}
			}

			@media (min-width: 1850px) {
				.media__video-container {
					padding: 110px 0;
					padding-top: 0;
				}
			}

			.media__icon {
				mix-blend-mode: difference;
			}

			@media (min-width: 768px) {
				.media__icon {
					display: none;
				}
			}

			.btn {
                width: 95px;
                padding: 9px 19px;
                text-align: center;
                border: none;
                border-radius: 50px;
                font: 400 11px var(--roboto-font);
				transition: all .4s;
			}

			.btn:hover {
				cursor: pointer;
				opacity: .7;
			}

			.hero__btn {
				color: var(--primary-color);
                background-color: var(--white-color);
			}

			@media (min-width: 500px) {
				.hero__btn {
					align-self: center;
				}
			}

			@media (min-width: 768px) {
				.hero__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 1280px) {
				.hero__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.hero__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.bottom__btn {
				margin-top: 50px;
				margin-bottom: 25px;
				color: var(--text-color);
                background-color: var(--primary-color);
			}

			@media (min-width: 768px) {
				.bottom__btn {
					width: 120px;
					height: 40px;
					font-size: 14px;
				}
			}

			@media (min-width: 960px) {
				.bottom__btn {
					margin-top: 0;
				}
			}

			@media (min-width: 1280px) {
				.bottom__btn {
					width: 140;
					height: 50px;
					font-size: 16px;
				}
			}

			@media (min-width: 1440px) {
				.bottom__btn {
					width: 180px;
					height: 65px;
					font-size: 21px;
				}
			}

			.red {
				color: var(--origin-red-color);
			}

			.blue {
				color: var(--origin-blue-color);
			}

			.green {
				color: var(--origin-green-color);
			}
		`;
        this.appendChild(style);
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        window.addEventListener("load", ()=>{
            bodyEl.style.overflowY = "auto";
        });
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("show");
                else entry.target.classList.remove("show");
            });
        });
        const hiddenElements = this.querySelectorAll(".hidden");
        hiddenElements.forEach((el)=>observer.observe(el));
    }
});





class $d9bd86496a9ccf19$var$en_HeaderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
        .header {
            z-index: 200;
            position: fixed;
            left: 0;
            right: 0;
            width: calc(100% - 50px);
            padding: 0 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: var(--menu-bkgd-color);
            backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			border-bottom: 1px solid #fff;
			transition: all .4s linear;
        }
        
			.header__right {
				display: none
			}
			
			@media (min-width: 768px) {
					.header {
						width: calc(100% - 100px);
						padding: 0 50px;
					}
			}
			@media (max-width: 767px) {
				.header {
					gap: 12px;
					justify-content: flex-start;
				}
				.header__right {
					display: flex;
					width: 100%;
					justify-content: space-between;
				}
			}
		

		@media (min-width: 1280px) {
			.header {
				height: 90px;
			}
		}

		@media (min-width: 1440px) {
            .header {
				width: calc(100% - 200px);
				padding: 0 100px;
            }
        }

		.header__companies {
			margin: 0 auto;
			font: 700 18px var(--jakarta-font);
			text-decoration: none;
			color: var(--white-color);
		}

		.header__companies:hover {
			cursor: pointer;
		}

		.companies__list {
			display: none;
			transition: all .4s linear;
		}

		.companies__list.active {
			position: absolute;
			width: 150px;
			height: 200px;
			padding: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
			background-color: var(--menu-bkgd-color);
			backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			border: 1px solid #fff;
			transition: all .4s linear;
		}

		@media (min-width: 768px) {
			.companies__list.active {
				top: 60px;
				right: 280px;
			}
		}

		@media (min-width: 1280px) {
			.companies__list.active {
				top: 90px;
			}
		}


		@media (min-width: 1440px) {
			.companies__list.active {
				top: 90px;
				right: 330px;
			}
		}

		.indalo-logo__wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
		}

		.indalo-logo {
            padding: 15px 0;
            padding-right: 25px;
			height: 20px;
		}

		@media (min-width: 768px) {
			.indalo-logo {
				padding-right: 50px;
				height: 30px;
			}
		}

		@media (min-width: 1440px) {
			.indalo-logo {
				padding-right: 100px;
				height: 30px;
			}
		}

		@media (min-width: 1850px) {
			.indalo-logo {
				height: 40px;
			}
		}

        .header .indalo-logo__wrapper {
            border-right: 1px solid #fff;
        }

		.indalo-logo:hover {
			cursor: pointer;
		}
		
		.header-nav {
			display: none;
		}

		@media (min-width: 769px) {
			.header-nav {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 34px;
			}	
		}

		.burger-menu:hover {
			cursor: pointer;
		}

		.cross-menu {
			display: none;
		}

		.cross-menu:hover {
			cursor: pointer;
		}

		@media (min-width: 769px) {
			.menu,
			.burger-menu,
			.cross-menu {
				display: none;
			}
		}
		
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                <header class="header">
                    <a class="indalo-logo__wrapper" href="/en#hero"><img class="indalo-logo" src="${$fca64589137b1371$exports}"></a>
                    <div class="header__right">
											<translate-comp class="translate--mobile"></translate-comp>
											<img class="burger-menu" src="${$b053139d7337e77f$exports}">
                    	<img class="cross-menu" src="${$138cbacc045963da$exports}">
										</div>
					<div class="header-nav">
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#hero">Home</link-comp>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#about-us">About us</link-comp>
						<a class="header__companies" href="/en#companies">Company</a>
						<div class="companies__list">
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/indalo-media">Indalo Media</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/oil-m&s">Oil M&S</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/cpc">CPC</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/providencia">Providencia</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/alpat">Alpat</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/serma">Serma</link-comp>
						</div>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#sust">Sustainability</link-comp>
						<translate-comp></translate-comp>
					</div>
                </header>
                <en_menu-comp class="menu"></en_menu-comp>
        `;
    }
    elementsOverlap(el1, el2) {
        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();
        const overlaps = !(domRect1.top > domRect2.bottom || domRect1.bottom < domRect2.top);
        return overlaps;
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const burgerMenu = this.shadow.querySelector(".burger-menu");
        const crossMenu = this.shadow.querySelector(".cross-menu");
        const headerEl = this.shadow.querySelector(".header");
        const menuComponentEl = this.shadow.querySelector(".menu");
        const headerNavLinksEl = this.shadow.querySelectorAll(".header-nav__link");
        const headerCompaniesEl = this.shadow.querySelector(".header__companies");
        const companiesListEl = this.shadow.querySelector(".companies__list");
        const shadowMenuEl = menuComponentEl.shadowRoot.querySelector(".menu-container");
        const shadowMenuLinksEl = menuComponentEl.shadowRoot.querySelectorAll(".nav-link");
        const aboutUsDividerEl = document.querySelector(".divider.bottom");
        const mediaSectionEl = document.querySelector(".about-us__media");
        const companiesSectionEl = document.querySelector(".companies");
        const rseSectionEl = document.querySelector(".sust");
        burgerMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "hidden";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "none";
            crossMenu.style.display = "inherit";
        });
        crossMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "auto";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "inherit";
            crossMenu.style.display = "none";
        });
        headerEl.addEventListener("mouseleave", ()=>{
            companiesListEl.classList.remove("active");
        });
        headerCompaniesEl.addEventListener("mouseover", ()=>{
            companiesListEl.classList.toggle("active");
        });
        headerNavLinksEl.forEach((link)=>{
            link.addEventListener("mouseover", ()=>{
                companiesListEl.classList.remove("active");
            });
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        const mainLandingWindowEvent = ()=>{
            const headerOverlapsDivider = this.elementsOverlap(headerEl, aboutUsDividerEl);
            const headerOverlapsMediaSection = this.elementsOverlap(headerEl, mediaSectionEl);
            const headerOverlapsCompaniesSection = this.elementsOverlap(headerEl, companiesSectionEl);
            const headerOverlapsRSESection = this.elementsOverlap(headerEl, rseSectionEl);
            if (headerOverlapsMediaSection || headerOverlapsCompaniesSection || headerOverlapsRSESection) {
                headerEl.style.backdropFilter = "blur(0)";
                headerEl.style.backgroundColor = "#111";
                companiesListEl.style.backdropFilter = "blur(0)";
                companiesListEl.style.backgroundColor = "#111";
            } else if (headerOverlapsDivider) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop < window.innerHeight) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
        };
        window.addEventListener("scroll", mainLandingWindowEvent);
    }
}
customElements.define("en-header-comp", $d9bd86496a9ccf19$var$en_HeaderComponent);







class $7c9488ff6b6f42c0$var$en_FooterComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .footer {
            width: 100vw;
            height: 25vh;
            min-height: 210px;
            padding-bottom: 25px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-image: url(${$42dad3286475bcc1$exports});
            background-color: var(--black-color);
            background-position: 0 35%;
            background-size: 75px;
            background-repeat: no-repeat;
        }

        @media (min-width: 600px) {
            .footer {
                background-size: 80px;
            }
        }

        @media (min-width: 768px) {
            .footer {
                width: 100vw;
                height: 30vh;
                padding: 50px 0;
                background-size: 15%;
                background-position: left center;
                background-color: var(--dark-gray-color);
            }
        }

        @media (min-width: 960px) {
            .footer {
                width: 99.7vw;
                height: 100%;
                max-height: 310px;
                padding: 50px 0;
                background-size: 10%;
            }
        }

        @media (min-width: 1440px) {
            .footer {
                justify-content: flex-end;
                padding: 100px 0;
                background-size: 12%;
            }
        }

        @media (min-width: 1850px) {
            .footer {
                background-size: 10%;
            }
        }

        .footer__content {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        @media (min-width: 768px) {
            .footer__content {
                max-width: none;
                justify-content: space-between;
                align-items: center;
            }
        }

        .content__left-side {
            width: 40%;
            height: 80%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            gap: 15px;
        }

        @media (min-width: 768px) {
            .content__left-side {
                height: 100%;
                justify-content: center;
            }
        }

        @media (min-width: 960px) {
            .content__left-side {
                width: 45%;
            }
        }


        .left-side__logo {
            width: 100px;
            height: auto;
        }

        @media (min-width: 550px) {
            .left-side__logo {
                width: 150px;
            }
        }

        @media (min-width: 768px) {            
            .left-side__logo {
                padding-left: 50px;
                width: 205px;
            }
        }

        @media (min-width: 960px) {            
            .left-side__logo {
                padding-left: 50px;
                width: 220px;
            }
        }

        @media (min-width: 1280px) {
            .left-side__logo {
                width: 300px;
            }
        }

        @media (min-width: 1440px) {
            .left-side__logo {
                width: 325px;
            }
        }

        @media (min-width: 1850px) {            
            .left-side__logo {
                width: 400px;
            }
        }

        .content__right-side {
            width: 40%;
            height: 80%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
        }

        @media (min-width: 768px) {
            .content__right-side {
                width: 20%;
                height: 100%;
            }
        }

        @media (min-width: 960px) {
            .content__right-side {
                width: 24%;
            }
        }

        @media (min-width: 1280px) {
            .content__right-side {
                width: 22%;
            }
        }

        .content__nav-links {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }

        .nav-links__title {
            width: 65%;
            font: 400 14px var(--roboto-font);
            color: var(--white-color);
            text-align: left;
        }

        @media (min-width: 768px) {
            .nav-links__title {
                width: 100%;
                font-family: var(--jakarta-font);
                font-size: 16px;
                text-decoration: none;
            }
        }

        @media (min-width: 960px) {
            .nav-links__title {
                font-size: 19px;
                margin-bottom: 10px;
            }
        }

        @media (min-width: 1440px) {
            .nav-links__title {
                margin-bottom: 20px;
                font-size: 24px;
            }
        }

        .nav-links__title.bold {
            font-weight: 700;
            font-size: 18px;
        }

        @media (min-width: 768px) {
            .nav-links__title.bold {
                font-size: 20px;
            }
        }

        @media (min-width: 960px) {
            .nav-links__title.bold {
                margin-top: 0;
                font-size: 24px;
            }
        }


        @media (min-width: 1280px) {
            .nav-links__title.bold {
                font-size: 28px;
            }
        }

        @media (min-width: 1440px) {
            .nav-links__title.bold {
                font-size: 32px;
            }
        }

        .content__social-media {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
        }

        @media (min-width: 768px) {
            .content__social-media {
                width: 150px;
                justify-content: flex-start;
            }    
        }

        @media (min-width: 960px) {
            .content__social-media {
                width: 170px;
                justify-content: flex-start;
            }    
        }

        @media (min-width: 1280px) {
            .content__social-media {
                width: 250px;
            }    
        }

        @media (min-width: 1440px) {
            .content__social-media {
                width: 270px;
            }    
        }

        @media (min-width: 1850px) {
            .content__social-media {
                width: 350px;
            }    
        }

        .content__social-media-logo {
            width: 25px;
        }

        @media (min-width: 960px) {
            .content__social-media-logo {
                width: 30px;
            }
        }

        @media (min-width: 1280px) {
            .content__social-media-logo {
                width: 40px;
            }
        }
        
        @media (min-width: 1440px) {
            .content__social-media-logo {
                width: 45px;
            }
        }

        @media (min-width: 1850px) {
            .content__social-media-logo {
                width: 54px;
            }
        }

        .social-media__link {
            text-decoration: none;
        }

        .content__details {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
        }

        .details__first-section {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 15px;
        }

        .footer__details {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
        }

        @media (min-width: 768px) {
            .footer__details {
                width: 22%;
                height: 100%;
                padding-right: 50px;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: flex-start;
            }
        }

        @media (min-width: 960px) {
            .footer__details {
                width: 30%;
                padding: 0;
            }
        }

        @media (min-width: 1280px) {
            .footer__details {
                width: 20%;
            }
        }

        @media (min-width: 1280px) {
            .footer__details {
                width: 24%;
            }
        }

        @media (min-width: 1440px) {
            .footer__details {
                width: 24%;
            }
        }

        .desktop {
            display: none;
        }

        @media (min-width: 768px) {            
            .mobile {
                display: none;
            }

            .desktop {
                display: inherit;
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    //! footer__details (Mobile y Desktop) tiene display: none; (estilos inline)
    render() {
        this.shadow.innerHTML = `
        <footer class="footer">
            <div class="footer__content">
				<div class="content__left-side">
                    <img class="left-side__logo" src="${$125e1db133398f72$exports}">
                    <div class="content__social-media">
                        <a class="social-media__link" href="https://instagram.com/grupoindalooficial?igshid=YmMyMTA2M2Y=" target="_blank">
                            <img class="content__social-media-logo" src="${$5f5de6ecc8a73be6$exports}" alt="Instagram">
                        </a>
                        <a class="social-media__link" href="https://www.linkedin.com/company/grupo-indalo/posts/?
                        feedView=all&viewAsMember=true" target="_blank">
                            <img class="content__social-media-logo" src="${$492809a4e9407687$exports}" alt="LinkedIn">
                        </a>
                        <a class="social-media__link" href="https://twitter.com/indaloprensa?s=11&t=NnNu0h-1-eNnbilJH-dz6w" target="_blank">
                            <img class="content__social-media-logo" src="${$a54685e3e631b55c$exports}" alt="Twitter">
                        </a>
                    </div>
				</div>
                <div class="content__right-side">
                    <h3 class="nav-links__title bold">Menu</h3>
                    <div class="content__nav-links">
                        <a href="#hero" class="nav-links__title">Home</a>
                        <a href="#about-us" class="nav-links__title">About us</a>
                        <a href="#companies" class="nav-links__title">Our group</a>
                        <a href="#rse" class="nav-links__title">Sustainability</a>
                    </div>
                </div>
                <div style="display: none" class="footer__details desktop">
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                    Privacy Policy
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                    Terms of use
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                    Privacy and cookies
                    </text-comp>
                    <text-comp class="hidden" variant="footer-details padding-applied" scheme="f-light">
                    Accessibility Statement
                    </text-comp>
                </div>
			</div>
			<div style="display: none" class="footer__details mobile">
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
                Privacy Policy
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
                Terms of use
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
                Privacy and cookies
				</text-comp>
				<text-comp class="hidden" variant="footer-details padding-applied" scheme="light">
                Accessibility Statement
				</text-comp>
			</div>
        </footer>
        `;
    }
    addListeners() {}
}
customElements.define("en-footer-comp", $7c9488ff6b6f42c0$var$en_FooterComponent);





class $31279e899a54fcf4$var$en_CompanyHeaderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
        .header {
            z-index: 200;
            position: fixed;
            left: 0;
            right: 0;
            width: calc(100% - 50px);
            padding: 0 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: var(--menu-bkgd-color);
            border-bottom: 1px solid #fff;
			transition: all .4s linear;
        }
        
			.header__right {
				display: none
			}
			
			@media (min-width: 768px) {
					.header {
						width: calc(100% - 100px);
						padding: 0 50px;
					}
			}
			@media (max-width: 767px) {
				.header {
					gap: 12px;
					justify-content: flex-start;
				}
				.header__right {
					display: flex;
					width: 100%;
					justify-content: space-between;
				}
			}
		

		@media (min-width: 1280px) {
			.header {
				height: 90px;
			}
		}

		@media (min-width: 1440px) {
            .header {
				width: calc(100% - 200px);
				padding: 0 100px;
            }
        }

		.header__companies {
			margin: 0 auto;
			font: 700 18px var(--jakarta-font);
			text-decoration: none;
			color: var(--white-color);
		}

		.header__companies:hover {
			cursor: pointer;
		}

		.companies__list {
			display: none;
			transition: all .4s linear;
		}

		.companies__list.active {
			position: absolute;
			width: 150px;
			height: 200px;
			padding: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
			background-color: var(--menu-bkgd-color);
            backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			border: 1px solid #fff;
			transition: all .4s linear;
		}

		@media (min-width: 768px) {
			.companies__list.active {
				top: 60px;
				right: 280px;
			}
		}

		@media (min-width: 1280px) {
			.companies__list.active {
				top: 90px;
			}
		}


		@media (min-width: 1440px) {
			.companies__list.active {
				top: 90px;
				right: 330px;
			}
		}

		.indalo-logo__wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
		}

		.indalo-logo {
            padding: 15px 0;
            padding-right: 25px;
			height: 20px;
		}

		@media (min-width: 768px) {
			.indalo-logo {
				padding-right: 50px;
				height: 30px;
			}
		}

		@media (min-width: 1440px) {
			.indalo-logo {
				padding-right: 100px;
				height: 30px;
			}
		}

		@media (min-width: 1850px) {
			.indalo-logo {
				height: 40px;
			}
		}

        .header .indalo-logo__wrapper {
            border-right: 1px solid #fff;
        }

		.indalo-logo:hover {
			cursor: pointer;
		}
		
		.header-nav {
			display: none;
		}

		@media (min-width: 769px) {
			.header-nav {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 34px;
			}	
		}

		.burger-menu:hover {
			cursor: pointer;
		}

		.cross-menu {
			display: none;
		}

		.cross-menu:hover {
			cursor: pointer;
		}

		@media (min-width: 769px) {
			.menu,
			.burger-menu,
			.cross-menu {
				display: none;
			}
		}
		
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                <header class="header">
                    <a class="indalo-logo__wrapper" href="/en#hero"><img class="indalo-logo" src="${$fca64589137b1371$exports}"></a>
                    <div class="header__right">
											<translate-comp class="translate--mobile"></translate-comp>
											<img class="burger-menu" src="${$b053139d7337e77f$exports}">
                    	<img class="cross-menu" src="${$138cbacc045963da$exports}">
										</div>
					<div class="header-nav">
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#hero">Home</link-comp>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#about-us">About us</link-comp>
						<a class="header__companies" scheme="light" href="/en#companies">Company</a>
						<div class="companies__list">
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/indalo-media">Indalo Media</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/oil-m&s">Oil M&S</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/cpc">CPC</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/providencia">Providencia</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/alpat">Alpat</link-comp>
							<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/serma">Serma</link-comp>
						</div>
						<link-comp class="header-nav__link" variant="header" scheme="light" href="/en#sust">Sustainability</link-comp>
						<translate-comp></translate-comp>
					</div>
                </header>
                <en_menu-comp class="menu"></en_menu-comp>
        `;
    }
    elementsOverlap(el1, el2) {
        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();
        const overlaps = !(domRect1.top > domRect2.bottom || domRect1.bottom < domRect2.top);
        return overlaps;
    }
    addListeners() {
        const bodyEl = document.querySelector("body");
        const burgerMenu = this.shadow.querySelector(".burger-menu");
        const crossMenu = this.shadow.querySelector(".cross-menu");
        const headerEl = this.shadow.querySelector(".header");
        const menuComponentEl = this.shadow.querySelector(".menu");
        const shadowMenuEl = menuComponentEl.shadowRoot.querySelector(".menu-container");
        const headerNavLinksEl = this.shadow.querySelectorAll(".header-nav__link");
        const headerCompaniesEl = this.shadow.querySelector(".header__companies");
        const companiesListEl = this.shadow.querySelector(".companies__list");
        const shadowMenuLinksEl = menuComponentEl.shadowRoot.querySelectorAll(".nav-link");
        const lightSectionStarting = document.querySelector(".about-us");
        const darkSectionStarting = document.querySelector(".btn");
        burgerMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "hidden";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "none";
            crossMenu.style.display = "inherit";
        });
        crossMenu.addEventListener("click", ()=>{
            bodyEl.style.overflowY = "auto";
            shadowMenuEl.classList.toggle("active");
            burgerMenu.style.display = "inherit";
            crossMenu.style.display = "none";
        });
        headerEl.addEventListener("mouseleave", ()=>{
            companiesListEl.classList.remove("active");
        });
        headerNavLinksEl.forEach((link)=>{
            link.addEventListener("mouseover", ()=>{
                companiesListEl.classList.remove("active");
            });
        });
        headerCompaniesEl.addEventListener("mouseover", ()=>{
            companiesListEl.classList.toggle("active");
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        shadowMenuLinksEl.forEach((link)=>{
            if (!link.classList.contains("companies-list")) link.addEventListener("click", ()=>{
                bodyEl.style.overflowY = "auto";
                shadowMenuEl.classList.toggle("active");
                burgerMenu.style.display = "inherit";
                crossMenu.style.display = "none";
            });
            else bodyEl.style.overflowY = "auto";
        });
        const companyLandingWindowEvent = ()=>{
            const headerOverlapsLightContent = this.elementsOverlap(headerEl, lightSectionStarting);
            const headerOverlapsDarkContent = this.elementsOverlap(headerEl, darkSectionStarting);
            if (headerOverlapsLightContent) {
                headerEl.style.backdropFilter = "blur(0)";
                headerEl.style.backgroundColor = "#111";
                companiesListEl.style.backdropFilter = "blur(0)";
                companiesListEl.style.backgroundColor = "#111";
            } else if (headerOverlapsDarkContent) {
                headerEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backdropFilter = "blur(10px)";
            }
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop < window.innerHeight) {
                headerEl.style.backdropFilter = "blur(10px)";
                headerEl.style.backgroundColor = "var(--menu-bkgd-color)";
                companiesListEl.style.backdropFilter = "blur(10px)";
                companiesListEl.style.backgroundColor = "var(--menu-bkgd-color)";
            }
        };
        window.addEventListener("scroll", companyLandingWindowEvent);
    }
}
customElements.define("en-company-header-comp", $31279e899a54fcf4$var$en_CompanyHeaderComponent);






class $e36042282121c611$var$en_menuComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `

        .menu-container {
            width: calc(100% - 2px);
            height: 90vh;
            display: none;
            background-color: var(--menu-bkgd-color);
            backdrop-filter: blur(32px);
            -webkit-backdrop-filter: blur(32px);
            border: 1px solid var(--white-color);
        }
        
        .menu-container.active {
            z-index: 199;
            left: 0;
            right: 0;
            position: fixed;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            animation: forwardExpand 400ms ease forwards;
        }

        .menu__nav-links {
            width: 100%;
            height: 70%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding-top: 10vh;
            gap: 0px;
        }

        @media (min-width: 769px) {
            .menu__nav-links {
                height: 50vh;
                padding-top: 0;
                justify-content: space-evenly;
            }
        }

        .nav-link {
            padding: 25px;
            border-bottom: 1px solid var(--white-color);
        }

        .nav-link.companies-list {
            padding-bottom: 15px;
        }

        .menu__social-media {
            width: 50%;
            padding-top: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 25px;
        }

        @media (min-height: 840px) {
            .menu__social-media {
                padding-top: 60px;
            }
        }

        @media (min-width: 1280px) {
            .menu__social-media {
                width: 200px;
                justify-content: flex-start;
            }
        }

        .menu__social-media-logo {
            width: 50px;
        }

        .social-media__link {
            text-decoration: none;
        }

        @keyframes forwardExpand {
            0% {
                opacity: 0;
                transform: translateY(-100%);
            }
        
            100% {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @keyframes backwardExpand {
            0% {
                opacity: 0;
                transform: translateY(0);
            }
        
            100% {
                opacity: 1;
                transform: translateY(-100%);
            }
        }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
            <div class="menu-container">
                <div class="menu__nav-links">
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/en#hero">Home</link-comp>
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/en#about-us">About us</link-comp>
                    <en-accordion-item class="nav-link companies-list">Companies</en-accordion-item>
                    <link-comp class="nav-link" variant="menu" scheme="light" href="/en#sust">Sustainability</link-comp>
                </div>
                <div class="menu__social-media">
                    <a class="social-media__link" href="" target="_blank">
                        <img class="menu__social-media-logo" src="${$492809a4e9407687$exports}" alt="LinkedIn">
                    </a>
                    <a class="social-media__link" href="" target="_blank">
                    <img class="menu__social-media-logo" src="${$a54685e3e631b55c$exports}" alt="Twitter">
                    </a>
                    <a class="social-media__link" href="https://www.instagram.com/molde__arq/" target="_blank">
                    <img class="menu__social-media-logo" src="${$5f5de6ecc8a73be6$exports}" alt="Instagram">
                    </a>
                </div>
            </div>
        `;
    }
    addListeners() {
        const burgerMenuEl = this.shadow.querySelector(".menu-container");
        const scrollCheckEvent = ()=>{
            const scrollTop = document.documentElement.scrollTop;
            if (scrollTop > window.innerHeight * 2.7 && location.pathname === "/") burgerMenuEl.style.backgroundColor = "var(--primary-color)";
            else if (scrollTop > window.innerHeight * 0.7) burgerMenuEl.style.backgroundColor = "var(--primary-color)";
            else burgerMenuEl.style.backgroundColor = "var(--menu-bkgd-color)";
        };
        window.addEventListener("scroll", scrollCheckEvent);
    }
}
customElements.define("en_menu-comp", $e36042282121c611$var$en_menuComponent);









class $b39059aa5c916689$var$en_HeroSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = `
        
        .carousel-container {
            width: 100vw;
            height: 90vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 45px;
        } 

        @media (min-width: 1850px) {
            .carousel-container {
                width: 100vw;
                height: 90vh;
                max-width: none;
                max-height: none;
            }
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        .sliders-container {
            width: 500%;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all .7s ease;
        }
        
        .sliders__item {
            width: 100vw;
            height: 100%;
        }
        
        .sliders__item.first-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$ea54a7185f45d98b$exports});
        }

        .sliders__item.second-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$0639761b32001ba7$exports});
        }

        .sliders__item.third-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$a77e43b5ed177443$exports});
        }

        .sliders__item.fourth-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom center;
            background-image: url(${$e44a9ca88677ea64$exports});
        }

        .sliders__item.fifth-item {
            height: 90vh;
            background-size: cover;
            background-position: bottom right;
            background-image: url(${$1c813357f4895e23$exports});
        }

        .item__content {
            position: absolute;
            left: 10%;
            top: 40%;
            max-width: 80%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            z-index: 100;
        }

        @media (min-width: 768px) {
            .item__content {
                max-width: 70%;
            }
        }

        @media (min-width: 1850px) {
            .item__content {
                max-width: 50%;
            }
        }

        .item__title {
            width: 100%;
        }

        .item__text {
            margin-top: 10px;
        }

        @media (min-width: 768px) {
            .item__text {
                margin-top: 20px;
            }
        }

        @media (min-width: 1440px) {
            .item__text {
                margin-top: 30px;
            }
        }

        @media (min-width: 1850px) {
            .item__text {
                margin-top: 35px;
            }
        }

        .item__controls {
            width: 100%;
            margin-top: 15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 20px;
        }

        .left-arrow, 
        .right-arrow {
            width: 43px;    
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }
        
        @media (min-width: 1280px) {
            .left-arrow, 
            .right-arrow {
                width: 45px;
            }    
        }

        @media (min-width: 1850px) {
            .left-arrow, 
            .right-arrow {
                width: 48px;    
            }    
        }

        `;
        this.render();
        this.shadow.appendChild(style);
    }
    addListeners() {
        const carouselEl = this.shadow.querySelector(".carousel");
        const SlContainerEl = this.shadow.querySelector(".sliders-container");
        const slidersItemsEl = this.shadow.querySelectorAll(".sliders__item");
        const leftArrowEl = this.shadow.querySelector(".left-arrow");
        const rightArrowEl = this.shadow.querySelector(".right-arrow");
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID, currentIndex = 0;
        slidersItemsEl.forEach((slide, index)=>{
            slide.addEventListener("touchstart", touchStart(index));
            slide.addEventListener("touchend", touchEnd);
            slide.addEventListener("touchmove", touchMove);
        });
        function getPositionX(event) {
            return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        }
        function touchStart(index) {
            return function(event) {
                currentIndex = index;
                startPos = getPositionX(event);
                isDragging = true;
                animationID = requestAnimationFrame(animation);
            };
        }
        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }
        function touchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            if (movedBy > 100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (movedBy > 100 && offset == "4") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (movedBy > 100 && offset == "3") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy > 100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy > 100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
            if (movedBy < -100 && offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (movedBy < -100 && offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (movedBy < -100 && offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (movedBy < -100 && offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (movedBy < -100 && offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        }
        function animation() {
            if (isDragging) requestAnimationFrame(animation);
        }
        leftArrowEl.addEventListener("click", (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (position == "previous" && offset == "0") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (position == "previous" && offset == "4") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (position == "previous" && offset == "3") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (position == "previous" && offset == "2") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (position == "previous" && offset == "1") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        });
        rightArrowEl.addEventListener("click", (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (position == "next" && offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (position == "next" && offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (position == "next" && offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (position == "next" && offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (position == "next" && offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        });
        setInterval(()=>{
            const offset = SlContainerEl.getAttribute("offset");
            if (offset == "0") {
                SlContainerEl.style.transform = "translateX(-20%)";
                SlContainerEl.setAttribute("offset", "1");
            } else if (offset == "1") {
                SlContainerEl.style.transform = "translateX(-40%)";
                SlContainerEl.setAttribute("offset", "2");
            } else if (offset == "2") {
                SlContainerEl.style.transform = "translateX(-60%)";
                SlContainerEl.setAttribute("offset", "3");
            } else if (offset == "3") {
                SlContainerEl.style.transform = "translateX(-80%)";
                SlContainerEl.setAttribute("offset", "4");
            } else if (offset == "4") {
                SlContainerEl.style.transform = "translateX(0%)";
                SlContainerEl.setAttribute("offset", "0");
            }
        }, 5000);
    }
    render() {
        this.shadow.innerHTML = `
        <div class="carousel-container">
            <div class="item__content">
                <title-comp class="item__title" variant="hero left-sided no-margin jakarta bold" scheme="light">WE ARE</title-comp>
                <title-comp class="item__title" variant="hero left-sided no-margin jakarta bold" scheme="light">GRUPO INDALO</title-comp>
                <text-comp class="item__text" variant="slider no-margin left-sided" scheme="f-light">
                    ${this.textContent}
                </text-comp>
                <div class="item__controls">
                    <img class="left-arrow" src="${$2a03b197c7bfe3c5$exports}" position="previous">
                    <img class="right-arrow" src="${$685962251ed1dff4$exports}" position="next">
                </div>
            </div>
            <div class="carousel">
                <div class="sliders-container" offset="0">
                    <div class="first-item sliders__item" offset="0">
                    </div>
                    <div class="second-item sliders__item" offset="1">
                    </div>
                    <div class="third-item sliders__item" offset="2">
                    </div>
                    <div class="fourth-item sliders__item" offset="3">
                    </div>
                    <div class="fifth-item sliders__item" offset="4">
                    </div>
                </div>
            </div>
        </div>
        `;
        this.addListeners();
    }
}
customElements.define("en-hero-slider", $b39059aa5c916689$var$en_HeroSliderComponent);


class $027ae4e879dfe5ed$var$en_accordionComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
		.accordion-item {
			width: 100%;
			height: 100%;
			margin: 0 auto;
			text-align: left;
		}

		.accordion-item:hover {
			cursor: pointer;
		}

		.accordion-item__wrapper {
			padding-bottom: 15px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
		}

		@media (min-width: 768px) {
			.accordion-item__wrapper {
				width: calc(100% - 100px);
				height: auto;
			}
		}

		.accordion-item__inverse-wrapper {
			flex-direction: row-reverse;	
		}

		.accordion-item__title {
            font: 700 26px var(--jakarta-font);
			color: var(--white-color);
			padding: 0 25px;
            text-decoration: none;
        }

		.accordion-item__toggle {
			font: 700 26px var(--jakarta-font);
			color: var(--white-color);
			margin: 0;
            text-decoration: none;
			transition: transform .4s ease;
		}

		.accordion-item__number {
			margin-left: 10px;
			font: 400 15px var(--aeonik-font);
		}

		.accordion-item__content {
			padding: 0 25px;
			display: none;
			overflow: auto;
		}
		
		.accordion-item__content.deactive {
			max-height: 0px;
		}

		.accordion-item__content.active {
			height: 100px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 15px;
		}

		@media (min-height: 840px) {
			.accordion-item__content.active {
				height: 200px;
			}
		}
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
        <div class="accordion-item">
			<div class="accordion-item__wrapper ${this.hasAttribute("inverse") ? "accordion-item__inverse-wrapper" : ""}">
				<div class="accordion-item__title">
            		${this.textContent}
				</div>
				<h3 class="accordion-item__toggle ${this.hasAttribute("active") ? "active" : ""}">${this.hasAttribute("active") ? "-" : "+"}</h3>
			</div>
			<div class="accordion-item__content deactive ${this.hasAttribute("active") ? "active" : ""}">
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/indalo-media">Indalo Media</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/oil-m&s">Oil M&S</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/cpc">CPC</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/providencia">Providencia</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/alpat">Alpat</link-comp>
				<link-comp class="nav-link" variant="menu submenu" scheme="light" href="/en/company/serma">Serma</link-comp>
			</div>
        </div>
        `;
    }
    addListeners() {
        const accordionItemEl = this.shadow.querySelector(".accordion-item");
        const itemContentEl = this.shadow.querySelector(".accordion-item__content");
        const itemToggleEl = this.shadow.querySelector(".accordion-item__toggle");
        itemContentEl.addEventListener("animationend", ()=>{
            if (itemContentEl.classList.contains("deactive") && itemContentEl.classList.contains("active")) itemContentEl.classList.toggle("deactive");
        }, {
            once: true
        });
        accordionItemEl.addEventListener("click", ()=>{
            itemContentEl.classList.toggle("active");
            itemContentEl.classList.toggle("deactive");
            itemToggleEl.classList.toggle("active");
        });
    }
}
customElements.define("en-accordion-item", $027ae4e879dfe5ed$var$en_accordionComponent);


class $78815820a482ee36$var$en_AboutComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
            .about-container {
                height: 90vh;
                width: 100vw;
                display: flex;
                justify-content: space-between;
                align-items: center;

            }

            .about__side-bar {
                width: 40%;
                height: calc(100% - 25px);
                padding: 0 25px;
                padding-top: 25px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                border-right: 1px solid var(--white-color);
                border-top: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__side-bar {
                    height: calc(100% - 50px);
                    padding: 0 50px;
                    padding-top: 50px;
                }
            }

            @media (min-width: 960px) {
                .about__side-bar {
                    width: 38%;
                }
            }

            @media (min-width: 1280px) {
                .about__side-bar {
                    width: 30%;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .about__side-bar {
                    height: calc(100% - 25px);
                    padding-top: 25px;
                }
            }


            @media (min-width: 1440px) {
                .about__side-bar {
                    width: 42%;
                    height: calc(100% - 50px);
                    padding: 0 100px;
                    padding-top: 50px;
                }
            }

            @media (min-width: 1850px) {
                .about__side-bar {
                    width: 39%;
                    height: calc(100% - 100px);
                    padding-top: 100px;
                }
            }

            .side-bar__faq {
                width: 100%;
            }

            .side-bar__title {
                width: 100%;
                margin: 10px 0;
                font: 700 19px var(--jakarta-font);
                color: var(--white-color);
                text-align: left;
                opacity: .25;
                transition: all .4s;
            }
            
            .side-bar__title:hover {
                cursor: pointer;
            }

            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    margin: 10px 0;
                    font-size: 24px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .side-bar__title {
                    font-size: 25px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 32px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    margin: 27px 0;
                    font-size: 47px;
                }
            }

            .side-bar__title.active {
                opacity: 1;
            }

            .side-bar__title.active.yellow {
                color: var(--yellow-color);
            }

            .side-bar__title.active.red {
                color: var(--red-color);
            }

            .side-bar__title.active.blue {
                color: var(--blue-color);
            }

            .side-bar__title.active.green {
                color: var(--green-color);
            }

            .side-bar__content {
                width: 100%;
            }

            @media (min-width: 1850px) {
                .side-bar__content {
                    margin-top: 55px; 
                }
            }

            .content__title {
                font: 700 22px var(--jakarta-font);
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1280px) {
                .content__title {
                    font-size: 33px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .content__title {
                    font-size: 27px;
                }
            }


            @media (min-width: 1440px) {
                .content__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .content__title {
                    margin: 0;
                    font-size: 54px;
                }
            }

            .content__text {
                width: 85%;
                font: 500 12px var(--jakarta-font); 
                color: var(--white-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1280px) and (max-height: 720px) {
                .content__text {
                    font-size: 14px;
                }
            }


            @media (min-width: 1440px) {
                .content__text {
                    font-size: 18px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .about__content {
                width: 55%;
                height: 100%;
                padding: 0 25px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-top: 1px solid var(--white-color);
            }

            @media (min-width: 768px) {
                .about__content {
                    height: 100%;
                    padding: 0 50px;
                }
            }

            @media (min-width: 960px) {
                .about__content {
                    width: 60%;
                }
            }

            @media (min-width: 1440px) {
                .about__content {
                    padding: 0 100px;
                }
            }

            @media (min-width: 1850px) {
                .about__content {
                    height: 100%;
                }
            }

            .content-item {
                max-width: 300px;
                position: absolute;
                opacity: 0;
				filter: blur(5px);
				transform: translateY(-50px);
				transition: all .6s;
            }
            
            @media (min-width: 768px) {
                .content-item {
                    max-width: 325px;
                }
            }

            @media (min-width: 960px) {
                .content-item {
                    max-width: 450px;
                }
            }

            @media (min-width: 1280px) {
                .content-item {
                    max-width: 670px;
                }
            }

            @media (min-width: 1440px) {
                .content-item {
                    max-width: 600px;
                }
            }

            @media (min-width: 1850px) {
                .content-item {
                    max-width: 840px;
                }
            }

            .content-item.active {
                opacity: 1;
                filter: blur(0);
				transform: translateY(0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
            <div class="about-container">
                <div class="about__side-bar">
                    <div class="side-bar__faq">
                        <h3 class="side-bar__title yellow active" item="first">What is Grupo Indalo?</h3>
                        <h3 class="side-bar__title red" item="second">Mission</h3>
                        <h3 class="side-bar__title blue" item="third">Vision</h3>
                        <h3 class="side-bar__title green" item="fourth">Values</h3>
                    </div>
                    <div class="side-bar__content">
                        <h3 class="content__title">
                            Our future,
                            <br>
                            much to do.
                        </h3>
                        <p class="content__text">
                            It was established in 1999 and since then it has become one of the most prominent groups in Argentina with growth projections across the region.
                        </p>
                    </div>
                </div>
                <div class="about__content">
                    <div class="content-item first active">
                        <text-comp variant="about" scheme="f-light">
                        Grupo Indalo is a conglomerate of companies that has been investing in Argentina for more than twenty years and is committed to the development of the country, generating employment for thousands of workers throughout the country. 
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                        Grupo Indalo includes production and service companies in different industries, mainly in media, construction, energy and mining.
                        </text-comp>
                    </div>
                    <div class="content-item second">
                        <text-comp variant="about" scheme="f-light">
                            Our mission is to contribute to the economic and social development of Argentina by investing in companies in different industries, generating employment and improving the quality of life of the population.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                        We aim to be leaders in each of our business areas, providing high quality products and services that meet the needs of our customers and generate a positive impact on society.
                        </text-comp>
                    </div>
                    <div class="content-item third">
                        <text-comp variant="about" scheme="f-light">
                        We aim to consolidate the leadership of our business group in the country and to expand into the region in search of new strategic markets.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                        To be a key player in each of the industries in which we operate, providing innovative products and solutions that generate value for our customers and society in general.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light">
                        In addition, we are committed to being a socially responsible company, promoting sustainability and environmental protection in each of our operations and contributing to the development of the communities in which we operate.
                        </text-comp>
                    </div>
                    <div class="content-item fourth">
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Commitment:</b>
                            We are committed to providing innovative and quality products to our customers and to being a socially responsible group of companies that contributes to the sustainable development of the communities in which we operate.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Innovation:</b>
                            We strive to be at the forefront of each of the markets in which we operate, investing in new technologies and fostering creativity and innovation in all our work teams.
                        </text-comp>
                        <text-comp variant="about" scheme="f-light" contains-html>
                            <b>Excellence:</b>
                            We pursue excellence in everything we do, from business management to the quality of our products and services.
                        </text-comp>
                    </div>
                </div>
            </div>
        `;
    }
    addListeners() {
        const sideBarTitles = this.shadow.querySelectorAll(".side-bar__title");
        const firstTitleEl = this.shadow.querySelector("[item=first]");
        const secondTitleEl = this.shadow.querySelector("[item=second]");
        const thirdTitleEl = this.shadow.querySelector("[item=third]");
        const fourthTitleEl = this.shadow.querySelector("[item=fourth]");
        const firstContentEl = this.shadow.querySelector(".content-item.first");
        const secondContentEl = this.shadow.querySelector(".content-item.second");
        const thirdContentEl = this.shadow.querySelector(".content-item.third");
        const fourthContentEl = this.shadow.querySelector(".content-item.fourth");
        sideBarTitles.forEach((title)=>{
            title.addEventListener("click", ()=>{
                const itemAttr = title.getAttribute("item");
                if (itemAttr == "first") {
                    firstTitleEl.classList.add("active");
                    firstContentEl.classList.add("active");
                    secondTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "second") {
                    secondTitleEl.classList.add("active");
                    secondContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "third") {
                    thirdTitleEl.classList.add("active");
                    thirdContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    secondTitleEl.classList.remove("active");
                    fourthTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    fourthContentEl.classList.remove("active");
                } else if (itemAttr == "fourth") {
                    fourthTitleEl.classList.add("active");
                    fourthContentEl.classList.add("active");
                    firstTitleEl.classList.remove("active");
                    secondTitleEl.classList.remove("active");
                    thirdTitleEl.classList.remove("active");
                    firstContentEl.classList.remove("active");
                    secondContentEl.classList.remove("active");
                    thirdContentEl.classList.remove("active");
                }
            });
        });
    }
}
customElements.define("en-about-content", $78815820a482ee36$var$en_AboutComponent);




class $bf6197baaa4a06c8$var$en_CardComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
                    .company-card {
                        width: 210px;
                        height: 360px;
                        position: relative;
                        left: 0;
                        right: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        align-items: center;
                        background-color: var(--black-color);
                        border: none;
                        border-radius: 10px; 
                        transition: all .4s;
                    }

                    @media (min-width: 1440px) {
                        .company-card {
                            width: 277px;
                            height: 480px;
                        }
                    }
  
                    @media (min-width: 1850px) {
                        .company-card {
                            width: 345px;
                            height: 600px;
                        }
                    }

                    .company-card:hover {
                        background-color: var(--secondary-color);   
                        cursor: pointer;
                    }

                    .company-card__wrapper {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                    }
                    
                    .company-card__data {
                        width: calc(100% - 40px);
                        height: 100%;
                        padding: 0 20px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
            
                    @media (min-width: 768px) {
                        .company-card__data {
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                        }
                    }
            
                    .company-card__logo-container {
                        width: 100%;
                        height: 30%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo-container {
                            width: 85%;
                        }
                    }

                    .company-card__logo {
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 80px;
                    }

                    @media (min-width: 960px) {
                        .company-card__logo {
                            max-height: 75px;
                        }
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo {
                            max-height: 100px;
                        }
                    }

                    .company-card__logo.rectangular-logos {
                        width: 100%;
                    }

                    @media (min-width: 1440px) {
                        .company-card__logo.rectangular-logos {
                            width: 75%;
                        }    
                    }

                    @media (min-width: 1850px) {
                        .company-card__logo.rectangular-logos {
                            width: 90%;
                        }    
                    }

                    .company-card__logo.square-logos {
                        height: 100%;
                    }
            
                    .company-card__redirect {
                        width: 100%;
                        height: 50px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        background-color: var(--gray-color);
                        border-radius: 0 0 9px 9px;
                        transition: all .4s;
                    }

                    @media (min-width: 1850px) {
                        .company-card__redirect {
                            height: 85px;
                        }
                    }

                    .company-card__redirect:hover {
                        opacity: .8;
                    }

                    .company-card__redirect-arrow {
                        width: 29px;
                    }

                    .company-card__redirect-arrow:hover {
                        cursor: pointer;
                    }

                    .company-card__link {
                        width: 100%;
                        height: 100%;
                        padding: 0 20px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        gap: 5px;
                        text-decoration: none;
                    }

                    .company-card__link:hover {
                        cursor: pointer;
                    }
            
                    `;
        this.render();
        this.shadow.appendChild(style);
        this.addListeners();
    }
    render() {
        this.shadow.innerHTML = `
                    <div class="company-card">
                        <div class="company-card__wrapper">
                            <div class="company-card__data">
                                <div class="company-card__logo-container">
                                    <img class="company-card__logo ${this.hasAttribute("rectangularLogo") ? "rectangular-logos" : ""}
                                    ${this.hasAttribute("squareLogo") ? "square-logos" : ""}
                                    "
                                    src="${this.getAttribute("src")}">
                                </div>

                                <text-comp variant="card middle-sided" scheme="f-light">
                                ${this.textContent}
                                </text-comp>
                            </div>
                            <div class="company-card__redirect">
                                <a class="company-card__link" path="${this.getAttribute("path")}">
                                    <img class="company-card__redirect-arrow" src="${$a1b65d7217d97d91$exports}" alt="">
                                    <text-comp variant="card" scheme="dark">See more</text-comp>
                                </a>
                            </div>
                        </div>
                    </div>
                    `;
    }
    addListeners() {
        const companyCardEl = this.shadow.querySelector(".company-card");
        const companyCardLinkEl = this.shadow.querySelector(".company-card__link");
        function getPageMaxScroll() {
            return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
        }
        const scrollUp = ()=>{
            let top = 1000000;
            const maxScroll = getPageMaxScroll();
            if (top > maxScroll) top = maxScroll;
            const rect = document.querySelector("div").getBoundingClientRect();
            window.scrollTo({
                top: rect.top,
                behavior: "smooth"
            });
        };
        scrollUp();
        companyCardEl.addEventListener("click", ()=>{
            const path = this.getAttribute("path");
            (0, $2c24f9dd87b676fe$export$55185c17a0fcbe46).go(path);
            setTimeout(scrollUp, 100);
        });
        companyCardLinkEl.addEventListener("click", ()=>{
            const path = this.getAttribute("path");
            (0, $2c24f9dd87b676fe$export$55185c17a0fcbe46).go(path);
            setTimeout(scrollUp, 100);
        });
    }
}
customElements.define("en-company-card", $bf6197baaa4a06c8$var$en_CardComponent);











class $3886d52012d58aed$var$en_CompaniesSliderComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = `
        
        .carousel-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 45px;
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        @media (min-width: 630px) {
            .carousel {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
            }
        }

        .sliders-container {
            width: calc(100% + 13% * 5);
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6%;
            transform: translateX(-40%);
            transition: all .7s ease;
			scroll-snap-type: x mandatory;
			scroll-behavior: smooth;
        }

        @media (min-width: 425px) {
            .sliders-container {
                gap: 10%;
            }
        }

		@media (min-width: 500px) {
			.sliders-container {
				transform: translateX(-37%);
			}
		}

        @media (min-width: 630px) {
            .sliders-container {
                transform: translateX(-15%);
            }
        }

        .slider__item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            opacity: .35;
            transform: scale(0.9);
            transition: all .6s;
        }

        .slider__item.active {
            opacity: 1;
            transform: scale(1);            
        }

        .item__controlls {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 45px;
            mix-blend-mode: difference;
        }

        .left-arrow, 
        .right-arrow {
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }

        `;
        this.render();
        this.shadow.appendChild(style);
    }
    addListeners() {
        const carouselEl = this.shadow.querySelector(".carousel");
        const SlContainerEl = this.shadow.querySelector(".sliders-container");
        const slidersItemsEl = this.shadow.querySelectorAll(".slider__item");
        const leftArrowEl = this.shadow.querySelector(".left-arrow");
        const rightArrowEl = this.shadow.querySelector(".right-arrow");
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID, currentIndex = 0;
        slidersItemsEl.forEach((slide, index)=>{
            slide.addEventListener("touchstart", touchStart(index));
            slide.addEventListener("mousedown", touchStart(index));
            slide.addEventListener("touchend", touchEnd);
            slide.addEventListener("mouseup", touchEnd);
            slide.addEventListener("touchmove", touchMove);
            slide.addEventListener("mousemove", touchMove);
        });
        function getPositionX(event) {
            return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        }
        function touchStart(index) {
            return function(event) {
                currentIndex = index;
                startPos = getPositionX(event);
                isDragging = true;
                animationID = requestAnimationFrame(animation);
            };
        }
        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }
        function touchEnd() {
            cancelAnimationFrame(animationID);
            isDragging = false;
            const offset = SlContainerEl.getAttribute("offset");
            const movedBy = currentTranslate - prevTranslate;
            // if moved enough negative then snap to next slide if there is one
            if (window.innerWidth <= 425) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 630) {
                if (movedBy > 100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy > 100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (movedBy > 100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy > 100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy > 100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy > 100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            }
            if (window.innerWidth <= 425) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 630) {
                if (movedBy < -100 && offset == "0") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (movedBy < -100 && offset == "1") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (movedBy < -100 && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (movedBy < -100 && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (movedBy < -100 && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (movedBy < -100 && offset == "5") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            }
        }
        function animation() {
            if (isDragging) requestAnimationFrame(animation);
        }
        const leftArrowListener = (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (window.innerWidth <= 425) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            } else if (window.innerWidth >= 630) {
                if (position == "previous" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "previous" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                } else if (position == "previous" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "previous" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "previous" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "previous" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                }
            }
        };
        const rightArrowListener = (e)=>{
            const target = e.target;
            const position = target.getAttribute("position");
            const offset = SlContainerEl.getAttribute("offset");
            if (window.innerWidth <= 425) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(40%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(0%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-40%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-80%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-120%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(80%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 450 && window.innerWidth < 600) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(34%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(-2%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-37%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-73%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-108%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(69%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            } else if (window.innerWidth >= 630) {
                if (position == "next" && offset == "0") {
                    SlContainerEl.style.transform = "translateX(45%)";
                    SlContainerEl.setAttribute("offset", "1");
                } else if (position == "next" && offset == "1") {
                    SlContainerEl.style.transform = "translateX(15%)";
                    SlContainerEl.setAttribute("offset", "2");
                } else if (position == "next" && offset == "2") {
                    SlContainerEl.style.transform = "translateX(-15%)";
                    SlContainerEl.setAttribute("offset", "3");
                } else if (position == "next" && offset == "3") {
                    SlContainerEl.style.transform = "translateX(-45%)";
                    SlContainerEl.setAttribute("offset", "4");
                } else if (position == "next" && offset == "4") {
                    SlContainerEl.style.transform = "translateX(-75%)";
                    SlContainerEl.setAttribute("offset", "5");
                } else if (position == "next" && offset == "5") {
                    SlContainerEl.style.transform = "translateX(75%)";
                    SlContainerEl.setAttribute("offset", "0");
                }
            }
        };
        leftArrowEl.addEventListener("click", leftArrowListener);
        rightArrowEl.addEventListener("click", rightArrowListener);
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") slidersItemsEl.forEach((item)=>{
                    const itemOffset = item.getAttribute("offset");
                    const sliderOffset = SlContainerEl.getAttribute("offset");
                    if (sliderOffset == itemOffset) item.classList.add("active");
                    else item.classList.remove("active");
                });
            });
        });
        observer.observe(SlContainerEl, {
            attributes: true
        });
        const translationOnResize = ()=>{
            leftArrowEl.removeEventListener("click", leftArrowListener);
            leftArrowEl.removeEventListener("click", rightArrowListener);
            leftArrowEl.addEventListener("click", leftArrowListener);
            rightArrowEl.addEventListener("click", rightArrowListener);
        };
        window.addEventListener("resize", translationOnResize);
    }
    render() {
        this.shadow.innerHTML = `
        <div class="carousel-container">
            <div class="carousel">
                <div class="sliders-container" offset="3">
                    <div class="slider__item" offset="0">
                        <en-company-card path="/en/company/indalo-media" src="${$42cb1983031089b4$exports}">
						One of the principal multimedia companies in Argentina. It has a strong presence in the television, radio, graphic and digital media industries and in the production of audiovisual content.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="1">
                        <en-company-card path="/en/company/oil-m&s" src="${$a2bd2683f70a0a67$exports}">
						Company providing comprehensive solutions to the hydrocarbon and mining industries throughout the country.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="2">
                        <en-company-card path="/en/company/cpc" src="${$cc64f062cd38ae25$exports}">
						Leading company in the implementation of large-scale public work projects.
                        </en-company-card>
                    </div> 
                    <div class="slider__item active" offset="3">
                        <en-company-card path="/en/company/providencia" src="${$39341b9d299a6db1$exports}">
						Insurance company specialized in providing a wide range of services to individuals and companies through brokers and producers.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="4">
                        <en-company-card path="/en/company/alpat" src="${$3e67dcecaa17c827$exports}">
						The only sodium carbonate producer in Latin America.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="5">
                        <en-company-card path="/en/company/serma" src="${$32bc09c7dfbdca68$exports}">
						Providing environmental engineering services to companies in the hydrocarbon and mining industries. 
                        </en-company-card>
                    </div>
                </div>
            </div>
            <div class="item__controlls">
            <img class="chevron-arrow left-arrow" src="${$2a03b197c7bfe3c5$exports}" position="previous">
            <img class="chevron-arrow right-arrow" src="${$685962251ed1dff4$exports}" position="next">
            </div>
        </div>
        `;
        this.addListeners();
    }
}
customElements.define("en-companies-slider", $3886d52012d58aed$var$en_CompaniesSliderComponent);









class $2a5c7a404fe0027d$var$en_CompaniesComponent extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
        let style = document.createElement("style");
        style.textContent = `
            .companies-container {
                height: 180vh;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 780px) {
                .companies-container {
                    height: 200vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 700px) {
                .companies-container {
                    height: 225vh;
                }
            }

            @media (min-width: 768px) and (max-width: 1440px) and (max-height: 650px) {
                .companies-container {
                    height: 230vh;
                }
            }

            @media (min-width: 1440px) {
                .companies-container {
                    height: 260vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 780px) {
                .companies-container {
                    height: 275vh;
                }
            }

            @media (min-width: 1440px) and (max-height: 700px) {
                .companies-container {
                    height: 290vh;
                }
            }

            .companies__side-bar {
                width: 40%;
                height: calc(100% - 25px);
                padding: 0 25px;
                padding-top: 25px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                border-right: 1px solid var(--black-color);
                border-top: 1px solid var(--black-color);
                border-bottom: 1px solid var(--black-color);
            }

            @media (min-width: 768px) {
                .companies__side-bar {
                    height: calc(100% - 180px);
                    padding: 90px 50px;
                }
            }

            @media (min-width: 960px) {
                .companies__side-bar {
                    width: 42%;
                }
            }

            @media (min-width: 1280px) {
                .companies__side-bar {
                    height: calc(100% - 300px);
                    padding: 150px 50px;
                    width: 38%;
                }
            }

            @media (min-width: 1440px) {
                .companies__side-bar {
                    width: 42%;
                    height: calc(100% - 330px);
                    padding: 165px 100px;
                }
            }

            @media (min-width: 1850px) {
                .companies__side-bar {
                    width: 45%;
                }
            }


            .side-bar__title {
                width: 100%;
                margin: 0;
                margin-bottom: 27px;
                font: 700 20px var(--jakarta-font);
                color: var(--black-color);
                text-align: left;
                transition: all .4s;
            }
            
            .side-bar__title:hover {
                cursor: pointer;
            }

            @media (min-width: 960px) {
                .side-bar__title {
                    width: 100%;
                    font-size: 27px;
                }
            }

            @media (min-width: 1280px) {
                .side-bar__title {
                    font-size: 30px;
                }
            }

            @media (min-width: 1440px) {
                .side-bar__title {
                    font-size: 35px;
                }
            }

            @media (min-width: 1850px) {
                .side-bar__title {
                    font-size: 47px;
                }
            }

            .side-bar__content {
                width: 100%;
                position: sticky;
                top: 45%;
            }

            @media (min-width: 1850px) {
                .side-bar__content {
                    margin-top: 55px; 
                }
            }

            .content__text {
                width: 100%;
                font: 500 12px var(--jakarta-font); 
                color: var(--black-color);
            }

            @media (min-width: 960px) {
                .content__text {
                    font-size: 14px;
                }
            }

            @media (min-width: 1280px) {
                .content__text {
                    font-size: 16px;
                }
            }

            @media (min-width: 1440px) {
                .content__text {
                    font-size: 20px;
                }
            }

            @media (min-width: 1850px) {
                .content__text {
                    font-size: 24px;
                }
            }

            .companies__content-cards {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 25px;
                padding-right: 50px;
                border-top: 1px solid var(--black-color);
                border-bottom: 1px solid var(--black-color);
                gap: 25px;
            }

            @media (min-width: 960px) {
                .companies__content-cards {
                    width: 80%;
                    padding: 0;
                }
            }

            @media (min-width: 1280px) {
                .companies__content-cards {
                    gap: 30px;
                }
            }

            @media (min-width: 1440px) {
                .companies__content-cards {
                    gap: 50px;
                }
            }

            @media (min-width: 1850px) {
                .companies__content-cards {
                    width: 85%;
                    gap: 100px;
                }
            }

            .content__left-side {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding-top: 25vh;
            }

            @media (min-width: 1280px) {
                .content__left-side {
                    padding-top: 35vh;
                }
            }

            @media (min-width: 1850px) {
                .content__left-side {
                    padding-top: 30vh;
                }
            }

            .content__right-side {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .content__left-side,
            .content__right-side {
                gap: 25px;
                padding-top: 25vh;
            }

            @media (min-width: 1280px) {
                .content__left-side,
                .content__right-side {
                    gap: 30px;
                    padding-top: 35vh;
                }
            }

            @media (min-width: 1440px) {
                .content__left-side,
                .content__right-side {
                    gap: 50px;
                }
            }

            @media (min-width: 1850px) {
                .content__left-side,
                .content__right-side {
                    gap: 100px;
                    padding-top: 30vh;
                }
            }
            
        `;
        this.render();
        this.shadow.appendChild(style);
    }
    render() {
        this.shadow.innerHTML = `
            <div class="companies-container">
                <div class="companies__side-bar">
                    <div class="side-bar__content">
                        <h3 class="side-bar__title">
                        Our group
                        </h3>
                        <p class="content__text">
                        The Group is comprised of production and service companies in different industries, principally in media, construction, energy and mining.
                        </p>
                    </div>
                </div>
                <div class="companies__content-cards">
                    <div class="content__left-side">
                        <en-company-card path="/en/company/indalo-media" src="${$42cb1983031089b4$exports}" rectangularLogo>
                            One of the principal multimedia companies in Argentina. It has a strong presence in the television, radio, graphic and digital media industries and in the production of audiovisual content.
                        </en-company-card>
                        <en-company-card path="/en/company/cpc" src="${$cc64f062cd38ae25$exports}" squareLogo>
                            Leading company in the implementation of large-scale public work projects.
                        </en-company-card>
                        <en-company-card path="/en/company/alpat" src="${$3e67dcecaa17c827$exports}" squareLogo>
                            The only sodium carbonate producer in Latin America.
                        </en-company-card>
                    </div>
                    <div class="content__right-side">
                        <en-company-card path="/en/company/oil-m&s" src="${$a2bd2683f70a0a67$exports}" rectangularLogo>
                            Company providing comprehensive solutions to the hydrocarbon and mining industries throughout the country.
                        </en-company-card>
                        <en-company-card path="/en/company/providencia" src="${$39341b9d299a6db1$exports}" rectangularLogo>
                            Insurance company specialized in providing a wide range of services to individuals and companies through brokers and producers.
                        </en-company-card>
                        <en-company-card path="/en/company/serma" src="${$32bc09c7dfbdca68$exports}" squareLogo>
                            Providing environmental engineering services to companies in the hydrocarbon and mining industries. 
                        </en-company-card>
                    </div>
                </div>
            </div>
        `;
    }
}
customElements.define("en-companies-content", $2a5c7a404fe0027d$var$en_CompaniesComponent);




//# sourceMappingURL=index.5ff85458.js.map
